import React, { Component } from "react";
import { connect } from "react-redux";
import {
  addVendorRegistration_action,
  updateVendorRegistration_action,
  getDetailsVendorRegistration_action,
} from "../../../../actions/admin_module_action/vendor_action/vendorRegistration_action/vendorRegistration_action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withRouter } from "../../../../utils/withRouter";
import moment from "moment";
import Modal from "react-modal";
import Loader from "../../../../utils/Loader";
import {
  toastError,
  toastSuccess,
  hallMasterListActionId,
  stallActionId,
  exhibitionId,
  vendorListId,
  serviceTypeId,
  ServiceSubTypeActionId,
  DeliverablesServiceActionId,
  HallZoneListActionId,
  vendorStaffSectionShiftActionId,
  exhibitorBadgeDaysActionId,
  workOrderDesignationActionId,
  BASE_URL,
  AccesibleActionId,
  DeliverablesPricingActionId,
  scopeOfWorkVendorServicesActionId,
  scopeOfWorkHallZoneListctionId,
  scopeOfWorkVendorActionId,
} from "../../../../utils/constants";
import { fill_action } from "../../../../actions/fillCombo_action";
import $, { data } from "jquery";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../common_components/exhibitor_module_topmenu";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import Select from "react-select";
import { Description } from "@mui/icons-material";
import Pagination from "../../../../utils/pagination";
import { getHallStallList_action } from "../../../../actions/admin_module_action/vendor_action/vendorAllocation_action/vendorAllocation_action";
import {
  insertUpdateVendorWorkOrder_action,
  getVendorWorkOrderDetails_action,
  createhallManagerAccess_action,
  SOWTagRead_action,
  getDeliverablesDocumentLog_action,
  createZoneManagerTeamMember_action,
  deleteZoneManagerTeamMember_action
} from "../../../../actions/admin_module_action/vendor_action/vendorWorkOrder_action/vendorWorkOrder_action";
import { revokeVendorPlan_action } from "../../../../actions/vendor_module_action/vendor_exhibition_list_action/vendor_plan_action";
import { updatePassword_action } from "../../../../actions/user_login_auth_actions/user_login_auth_action";
import Resizer from "react-image-file-resizer";
import { delimiter } from "path-browserify";
import { Dropdown } from "react-bootstrap";
import JoditEditor from "jodit-react";
import {
  emailValidator,
  notMendetoryMobileNoValidator,
  notMendetoryEmailValidator,
  newPasswordValidator,
} from "../../../../utils/Validator";
import VendorDrawer from "../../../../common_components/vendor_module_drawer";
import { Switch } from "antd";

const config = {
  readonly: false,
  height: 300,
  placeholder: "",
  disableBeautify: true,
  useAceEditor: false,
  uploader: { insertImageAsBase64URI: true },
  toolbarSticky: false,
  showAbout: false,
  showPoweredBy: false,
};
const mapStateToProps = (state) => ({
  ...state,
});

class VendorWorkOrderAU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      summaryPage: "WorkOrderDetails",
      deliveryServices: [],
      sectionPage: "",
      workOrderServices: [],
      WorkOrderServiceList: [],
      SectionPageList: [],
      dummySectionPageList: {
        OrganizerResponsibilitiesList: [{ Id: "1", Responsibilities: "" }],
      },
      isOpen: false,
      hallId: "",
      hallList: [],
      stallId: "",
      stallList: [],
      hallStallList: [],
      renderhallStallList: [],
      ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
      exhibitionList: [],
      vendorId: "",
      vendorList: [],
      StartDate: "",
      EndDate: "",
      WorkOrderNumber: "",
      PersonName: "",
      EmailID: "",
      MobileNumber: "",
      documentList: [
        {
          DocumentName: null,
          WorkOrderID: null,
          ActionID: 1,
          AttachmentPath: null,
        },
      ],
      WorkOrderID: null,
      RenderhallList: [],
      selectedHallStallList: [],
      allSelected: false,
      allSelectedHallStall: false,
      allHallStallList: [],
      DeliveryServicesIndex: "",
      isDeliveryServicesPop: false,
      DeliverablesServiceFillListArray: [],
      ServiceSubTypeFillListArray: [],
      isDeliveryServicesPopFlag: "isAdd",
      isScopeOfWorkPop: false,
      StaffSectionHallPop: false,
      HallZoneList: [],
      StaffSectionIndex: "",
      StaffSectionShiftPop: false,
      staffSectionTableName: "",
      hallDismantlingDaysList: [],

      deletedDeliverablesServices: [],
      deletedPreSetupDaysList: [],
      deletedEventDaysList: [],
      deletedDismantlingDaysList: [],
      isHallChecked: false,
      workOrderDesignationList: [],

      update: false,
      isView: false,
      replicate: false,
      isVendor: JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7 || JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 17,
      ErroMsg: "",
      ErroMsgNo: "",
      vendorIdErr: "",
      workOrderServicesErr: "",
      StartDateErr: "",
      EndDateErr: "",
      WorkOrderNumberErr: "",
      PersonNameErr: "",
      EmailIDErr: "",
      MobileNumberErr: "",
      isHallPop: false,
      deleteDocumentList: [],
      isAddDeliveryServicesPop: true,
      isHallManager: false,
      isWorkUpdation: this.props.location.pathname == "/vendorAndScopofwork",
      AccesibleList: [],
      DeliverablesPricingList: [],
      FormStatusID: false,
      RoleID: sessionStorage.getItem("RoleIDSS"),
      visibleIndexPassword: false,
      showRevokePlanModal: false,
      showChangePasswordModal: false,
      selectedUserId: null,
      is_showOldpass: false,
      is_showConfirmpass: false,
      is_showNewpass: false,
      old_pass: "",
      new_pass: "",
      confirm_pass: "",
      old_passErr: "",
      new_passErr: "",
      confirm_passErr: "",
      isInstruction: false,
      isCommentPop: false,
      commentList: [],
      isConfirmPop: false,
      isCreateZoneManagerTeamMember: false,
      ZoneManagerUserName: ''
    };
    this.getFillList = this.getFillList.bind(this);
    this.updatePasswordModal = this.updatePasswordModal.bind(this);
    this.handleObscurePassword = this.handleObscurePassword.bind(this);
    this.inputValidatePassword = this.inputValidatePassword.bind(this);
  }

  async componentDidMount() {
    if (this.props.location.state && this.props.location.state.update) {
      await this.getFillList(serviceTypeId, "", "", "", "", "");
      await this.getFillList(vendorListId, "", "", "", "", "");
    } else {
      await this.getFillList(scopeOfWorkVendorActionId, "", "", "", "", "");
    }
    await this.getFillList(exhibitionId, "", "", "", "", "");
    await this.getFillList(workOrderDesignationActionId, "", "", "", "", "");
    await this.getFillList(AccesibleActionId, "", "", "", "", "");
    await this.getFillList(DeliverablesPricingActionId, "", "", "", "", "");
    await this.getFillList(
      hallMasterListActionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      "",
      "",
      ""
    );
    await this.getFillList(
      stallActionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      "",
      "",
      ""
    );
    // await this.getFillList(HallZoneListActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '')
    await this.getFillList(
      exhibitorBadgeDaysActionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      "",
      "",
      ""
    );
    await this.getFillList(
      vendorStaffSectionShiftActionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      "P",
      "",
      ""
    );
    await this.getFillList(
      vendorStaffSectionShiftActionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      "D",
      "",
      ""
    );
    setTimeout(() => {
      this.setState(
        {
          WorkOrderID:
            this.props.location.state != null &&
              this.props.location.state.WorkOrderID != null
              ? this.props.location.state.WorkOrderID
              : null,
          update:
            this.props.location.state != null &&
              this.props.location.state.update != null
              ? this.props.location.state.update
              : false,
          isView:
            this.props.location.state != null &&
              this.props.location.state.isView != null
              ? this.props.location.state.isView
              : false,
          replicate:
            this.props.location.state != null &&
              this.props.location.state.replicate != null
              ? this.props.location.state.replicate
              : false,
          vendorId:
            this.props.location.state != null &&
              this.props.location.state.vendorId != null
              ? this.props.location.state.vendorId
              : null,
          PersonName:
            this.props.location.state != null &&
              this.props.location.state.PersonName != null
              ? this.props.location.state.PersonName
              : "",
          EmailID:
            this.props.location.state != null &&
              this.props.location.state.EmailID != null
              ? this.props.location.state.EmailID
              : "",
          MobileNumber:
            this.props.location.state != null &&
              this.props.location.state.MobileNumber != null
              ? this.props.location.state.MobileNumber
              : "",
          isHallManager:
            this.props.location.state != null &&
              this.props.location.state.isHallManager != null
              ? this.props.location.state.isHallManager
              : false,
        },
        async () => {
          this.props.location.state != null &&
            this.props.location.state.update != null &&
            this.props.location.state.update &&
            this.getWorkOrderDetails();
          if (
            this.props.location.state != null &&
            this.props.location.state.vendorId
          ) {
            const serviceList = await this.getFillList(
              scopeOfWorkVendorServicesActionId,
              "",
              "",
              this.props.location.state.vendorId,
              "",
              ""
            );
            await this.getFillList(
              scopeOfWorkHallZoneListctionId,
              "",
              "",
              this.props.location.state.vendorId,
              "",
              ""
            );
            const result = serviceList.map((item) => ({
              label: item.Name,
              value: item.ServiceID,
            }));
            this.onChangeWorkOrderService(result);
          }
        }
      );
    }, 100);

    this.loadscript();
  }

  getWorkOrderDetails() {
    const { WorkOrderID, ExhibitionID, replicate } = this.state;
    this.setState({ isLoading: true });
    try {
      this.props
        .getVendorWorkOrderDetails_action(WorkOrderID, ExhibitionID)
        .then(async (data) => {
          if (data.error != 1) {
            await this.getFillList(
              scopeOfWorkHallZoneListctionId,
              "",
              "",
              data.data.data[0]["VendorID"],
              "",
              ""
            );
            setTimeout(async () => {
              const serviceArray = [];
              for (let i = 0; i < data.data.data[0]["services"].length; i++) {
                this.state.WorkOrderServiceList.forEach(async (item) => {
                  if (
                    data.data.data[0]["services"][i]["MainServiceID"] ==
                    item.ServiceID
                  ) {
                    serviceArray.push({
                      label: item.Name,
                      value: item.ServiceID,
                    });
                  }
                });
              }
              this.setState({
                vendorId: data.data.data[0]["VendorID"],
                workOrderServices: serviceArray,
                sectionPage: serviceArray[0]["label"],
                StartDate: data.data.data[0]["StartDate"]
                  ? moment(
                    data.data.data[0]["StartDate"],
                    "YYYY-MM-DD HH:mm").toDate()
                  : null,
                EndDate: data.data.data[0]["EndDate"]
                  ? moment(data.data.data[0]["EndDate"], "YYYY-MM-DD HH:mm").toDate()
                  : null,

                WorkOrderNumber:
                  this.props.location.state != null &&
                    this.props.location.state.replicate != null &&
                    this.props.location.state.replicate
                    ? ""
                    : data.data.data[0]["WorkOrderNumber"],
                PersonName: data.data.data[0]["PersonName"],
                EmailID: data.data.data[0]["EmailID"],
                MobileNumber: data.data.data[0]["MobileNumber"],
                WorkOrderID: data.data.data[0]["WorkOrderID"],
                ExhibitionID: data.data.data[0]["ExhibitionID"],
                FormStatusID: replicate
                  ? false
                  : data.data.data[0]["FormStatusID"] || false,
              });
              // console.log("this.state.PreSetupDaysShiftList-->", this.state.PreSetupDaysShiftList)
              // console.log("this.state.hallDismantlingDaysList-->", this.state.hallDismantlingDaysList)
              // console.log("this.state.EventDaysShiftList-->", this.state.EventDaysShiftList)

              const result = await this.transformAllData(
                data.data.sectionPageList,
                this.state.HallZoneList,
                this.state.PreSetupDaysShiftList,
                this.state.hallDismantlingDaysList,
                this.state.EventDaysShiftList
              );
              const array = [];
              data.data.documentList.forEach((item) => {
                // const filename = item.AttachmentPath.split(`${data.data.data[0]['WorkOrderID']}/`)[1]
                const attachmentPath = item.AttachmentPath || "";
                const parts = attachmentPath ? attachmentPath.split("/") : [];
                const filename = parts.length > 0 ? parts.pop() : null;

                array.push({
                  WorkOrderDocID: item.WorkOrderDocID,
                  DocumentName: item.DocumentName,
                  ActionID: replicate ? 1 : 2,
                  FileName: filename,
                  FilePath: attachmentPath || null,
                  FileType: null,
                });
              });
              console.log("result---->", result);
              this.setState({ SectionPageList: result, documentList: array, isLoading: false }, () => {
                this.TagRead()
              });
            }, 500);
          } else {
            toastError(data.msg);
            this.setState({ isLoading: false });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch {
      toastError("Something went wrong!");
    }
  }

  createhallManagerAccess() {
    const { WorkOrderID, ExhibitionID, vendorId } = this.state;
    this.setState({ isLoading: true });
    try {
      this.props
        .createhallManagerAccess_action(ExhibitionID, vendorId)
        .then(async (data) => {
          if (data.error != 1) {
            toastSuccess("Hall manager access created successfully!");
            setTimeout(() => {
              this.getWorkOrderDetails();
              this.setState({ isLoading: false });
            }, 200);
          } else {
            toastError(data.msg);
          }
          this.setState({ isLoading: false });
        })
        .catch((err) => {
          console.log(err);
        });
    } catch {
      toastError("Something went wrong!");
      this.setState({ isLoading: false });
    }
  }

  async detailsVendorRegistration(id) {
    this.props
      .getDetailsVendorRegistration_action(id)
      .then(async (data) => {
        if (data.error != 1) {
          this.setState({
            isLoading: false,
            PersonName:
              data.data["data"][0]["FirstName"] +
              " " +
              data.data["data"][0]["LastNamePersonIncharge"],
            EmailID: data.data["data"][0]["PrimaryEmail"],
            MobileNumber:
              data.data["data"][0]["MobileNo"] &&
                data.data["data"][0]["MobileNo"].split("-")[1]?.trim() !== ""
                ? data.data["data"][0]["MobileNo"].split("-")[1]?.trim()
                : "",
          });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async transformAllData(
    AllData,
    HallZoneList,
    PreSetupDaysShiftList,
    DismantlingDaysShiftList,
    EventDaysShiftList
  ) {
    const [
      workOrders,
      deliverables,
      organizerResponsibilities,
      preSetupStaff,
      preSetupHalls,
      preSetupDates,
      eventDayStaff,
      eventDayHalls,
      eventDayDates,
      dismantlingStaff,
      dismantlingHalls,
      dismantlingDates, // skip empty
      ,
      staffBadgeCounts,
      ComplianceListRaw,
      HallManagerLoginCredentialList,
      DocumentsList,
    ] = AllData;
    console.log("DocumentsList------------>1", DocumentsList)
    // Fix null LocationIDs in ComplianceList
    const ComplianceList = ComplianceListRaw.map((item) => ({
      ...item,
      LocationID: item.LocationID == null ? "Other" : item.LocationID,
    }));

    const { replicate, workOrderDesignationList } = this.state;

    function transformHallZoneList(selectedHallZoneList, email) {
      const output = [];

      selectedHallZoneList.forEach((hall) => {
        if (hall.isHallChecked) {
          hall.zonelist.forEach((zone) => {
            if (zone.isZoneChecked) {
              output.push({
                HallID: hall.HallId,
                ZoneID: zone.ZoneID,
                EmailID: email,
              });
            }
          });
        }
      });

      return output;
    }

    function buildStaffList(
      staffArr = [],
      sectionHalls = [],
      sectionDates = [],
      hallStateList = [],
      shiftStateList = [],
      serviceId,
      type
    ) {
      // helper for cleaner ID selection
      const getHallSectionId = (staff) => {
        return (
          staff?.PreSetupStaffID ??
          staff?.EventDayStaffID ??
          staff?.DismantlingStaffID ??
          null
        );
      };

      return staffArr
        .filter((s) => s.MainServiceID === serviceId)
        .map((staff, idx) => {
          const hallSectionId = getHallSectionId(staff);

          // Merge HallZoneList
          const matchedHalls = (hallStateList || []).map((h) => {
            // reset zone checked
            h.zonelist?.forEach((obj) => {
              obj.isZoneChecked = true;
            });

            const hallZonesFromSection = (sectionHalls || []).filter(
              (hall) =>
                hall.HallID === h.HallId &&
                hall.MainServiceID === staff.MainServiceID &&
                (hall.PreSetupStaffID == hallSectionId ||
                  hall.EventDayStaffID == hallSectionId ||
                  hall.DismantlingStaffID == hallSectionId)
            );

            let zonelist = (h.zonelist || []).map((z) => ({
              ...z,
              isZoneChecked: hallZonesFromSection.some(
                (hall) => hall.ZoneID === z.ZoneID
              ),
            }));

            let checkedZones = zonelist.filter((z) => z.isZoneChecked);
            const totalZones = zonelist.length;

            let All = false;
            let Specific = false;

            if (totalZones === 1 && checkedZones.length === 1) {
              All = true;
              zonelist = zonelist.map((z) => ({ ...z, isZoneChecked: true }));
            } else if (totalZones > 1 && checkedZones.length === totalZones) {
              All = true;
              zonelist = zonelist.map((z) => ({ ...z, isZoneChecked: true }));
            } else if (totalZones > 1 && checkedZones.length > 0) {
              Specific = true;
            }


            let isHallChecked = checkedZones.length > 0;

            // Override: if hall not checked, force all zones checked
            if (!isHallChecked) {
              All = true;
              zonelist = zonelist.map((z) => ({ ...z, isZoneChecked: true }));
              checkedZones = zonelist;
            }
            console.log("isHallChecked------------->", isHallChecked)

            return {
              ...h,
              isHallChecked,
              zonelist,
              All,
              Specific,
            };
          });

          const result = transformHallZoneList(matchedHalls, staff.EmailID);

          // Merge ShiftList (only for PreSetup & Dismantling)
          let matchedShifts = [];
          let SelectedDates = "";
          let SelectedShifts = "";
          let AllocatedDateIDs = "";

          if (type === "PreSetup" || type === "Dismantling") {
            matchedShifts = (shiftStateList || []).map((d) => {
              const relatedDates =
                type === "PreSetup"
                  ? (sectionDates || []).filter(
                    (pd) => pd.PreSetupStaffID === staff.PreSetupStaffID
                  )
                  : (sectionDates || []).filter(
                    (pd) => pd.DismantlingStaffID === staff.DismantlingStaffID
                  );

              return {
                ...d,
                isDateCheck: relatedDates.some((pd) =>
                  d.shift.some((s) => s.ExhibitionDaysID === pd.AllocatedDateID)
                ),
                shift: (d.shift || []).map((s) => ({
                  ...s,
                  isShiftCheck: relatedDates.some(
                    (pd) => s.ExhibitionDaysID === pd.AllocatedDateID
                  ),
                })),
              };
            });

            // Build Selected Shifts
            SelectedShifts = matchedShifts
              .map((d) => {
                const checkedShifts = d.shift.filter((s) => s.isShiftCheck);
                if (!checkedShifts.length) return null;
                if (checkedShifts.length === d.shift.length)
                  return [`${d.date}, All Shift`];
                return checkedShifts.map((s) => `${d.date}, ${s.time}`);
              })
              .filter(Boolean)
              .flat();

            // Build Selected Dates
            SelectedDates = matchedShifts
              .filter((d) => d.shift.some((s) => s.isShiftCheck))
              .map((d) => d.date)
              .join(", ");

            // Allocated Date IDs
            AllocatedDateIDs = matchedShifts
              .flatMap((d) =>
                d.shift
                  .filter((s) => s.isShiftCheck)
                  .map((s) => s.ExhibitionDaysID)
              )
              .join(",");
          }

          if (type === "EventDay") {
            // For EventDay staff, no shifts — only dates
            const relatedDates = (sectionDates || []).filter(
              (pd) => pd.EventDayStaffID === staff.EventDayStaffID
            );
            SelectedDates = relatedDates
              .map((pd) => pd.AllocatedDate)
              .join(", ");

            matchedShifts = (shiftStateList || []).map((s) => ({
              ...s,
              isDateCheck: (sectionDates || []).some(
                (pd) =>
                  pd.EventDayStaffID === staff.EventDayStaffID &&
                  pd.AllocatedDate.trim() === s.DateValue.trim()
              ),
            }));
          }

          // Hall IDs and Names
          const HallIDs = matchedHalls
            .filter((h) => h.isHallChecked)
            .map((h) => h.HallId)
            .join(",");

          const SelectedHalls = matchedHalls
            .filter((h) => h.isHallChecked)
            .map((h) => h.HallName)
            .join(",");

          return {
            Id: idx + 1,
            MainServiceID: staff.MainServiceID,
            PersonName: staff.PersonName || "",
            EmailID: staff.EmailID || "",
            MobileNumber: staff.MobileNumber || "",
            Address: staff.Address || "",
            AllocatedDateIDs,
            HallIDs,
            HallZoneList: matchedHalls,
            ShiftList: matchedShifts,
            SelectedDates,
            SelectedHalls,
            SelectedShifts,
            IsHallManager: staff.IsHallManager,
            selectedHallZoneList: result,
            DesignationID: staff.StaffDesignationID,
            Password: staff.Password,
            DesignationList: workOrderDesignationList || [],
            ActionID: replicate ? 1 : 0,
            ...(type === "PreSetup" && {
              PreSetupStaffID: staff.PreSetupStaffID,
            }),
            ...(type === "EventDay" && {
              EventDayStaffID: staff.EventDayStaffID,
            }),
            ...(type === "Dismantling" && {
              DismantlingStaffID: staff.DismantlingStaffID,
            }),
          };
        });
    }

    // console.log("deliverables--->", deliverables)

    const serviceGroups = [
      ...new Map(deliverables.map((d) => [d.MainServiceID, d])).values(),
    ];

    // console.log("serviceGroups--->", serviceGroups)

    // 🔑 Await all services processing
    return await Promise.all(
      serviceGroups.map(async (service) => {
        const serviceId = service.MainServiceID;

        const OrganizerResponsibilitiesList = organizerResponsibilities
          .filter((o) => o.MainServiceID === serviceId)
          .map((o, index) => ({
            Id: `${serviceId}-${o.WorkOrderOrganizerResponsibilityID || index + 1
              }`,
            Responsibilities: o.Responsibility,
          }));

        const filteredDeliverables = deliverables.filter(
          (d) => d.MainServiceID === serviceId
        );

        const DeliverablesServiceFillListArray = await this.getFillList(
          DeliverablesServiceActionId,
          sessionStorage.getItem("sessionExhibitionID"),
          serviceId,
          "",
          "",
          ""
        );

        const AllDeliverablesServiceFillListArray = await this.getFillList(
          124,
          sessionStorage.getItem("sessionExhibitionID"),
          serviceId,
          "",
          "",
          ""
        );

        const array = DeliverablesServiceFillListArray;
        const filterArray = deliverables.filter(
          (item) => item.MainServiceID == serviceId
        );

        const excludeIds = filterArray.map((item) =>
          String(item.MainServiceDeliverablesID)
        );

        const finalFilterArray = array.filter(
          (item) => !excludeIds.includes(String(item.MainServiceDeliverablesID))
        );
        array.forEach((item) =>
          this.state.DeliverablesServiceFillListArray.push(item)
        );

        ComplianceList.forEach((c) => {
          c.TimeLine = c.TimeLine
            ? moment(c.TimeLine, "YYYY-MM-DD HH:mm").toDate()
            : null;
        });

        const DeliverablesServicesList = filteredDeliverables.map(
          (d, index) => ({
            ActionID: replicate ? 1 : 2,
            DropdownList: finalFilterArray,
            AllDropdownList: AllDeliverablesServiceFillListArray,
            ComplianceRequirementsList: ComplianceList.filter(
              (item) =>
                item.MainServiceID == serviceId &&
                item.WorkOrderDeliverablesID == d.WorkOrderDeliverablesID
            ),
            Deadline: "",
            DeliverablesService: d.DeliverablesService || "",
            DeliverablesServicesEndDate: d.EndDate
              ? moment(d.EndDate, "YYYY-MM-DD HH:mm").toDate()
              : "",
            DeliverablesServicesStartDate: d.StartDate
              ? moment(d.StartDate, "YYYY-MM-DD HH:mm").toDate()
              : "",
            Id: `${serviceId}-${index + 1}`,
            LogisticsResponsibilities: d.LogisticsResponsibilities || "",
            MainServiceDeliverablesID: d.MainServiceDeliverablesID || "",
            MainServiceDeliverablesName: d.MainServiceDeliverablesName || "",
            MainServiceID: d.MainServiceID,
            Manpower: d.Manpower ? String(d.Manpower) : "",
            ScopeOfWork: d.ScopeOfWork || "",
            VendorExhibitorPriceInINR: d.VEPriceInINR
              ? String(d.VEPriceInINR)
              : "",
            VendorExhibitorPriceInUSD: d.VEPriceInUSD
              ? String(d.VEPriceInUSD)
              : "",
            VendorOrganizerPriceInINR: d.VOPriceInINR
              ? String(d.VOPriceInINR)
              : "",
            VendorOrganizerPriceInUSD: d.VOPriceInUSD
              ? String(d.VOPriceInUSD)
              : "",
            WorkOrderDeliverablesID: d.WorkOrderDeliverablesID || null,
            isEditInpute: false,
            Remark: d.Remark,
            IsStockAvailable: d.IsStockAvailable,
            Quantity: d.Quantity,
            AccessibleID: d.AccessibleID,
            DeliverablesPricingID: d.DeliverablesPricingID,
            Instructions: d.Instructions || "",
            previousInstructions: d.Instructions || "",
            DocumentsList: (
              DocumentsList?.filter(
                obj => obj.WorkOrderDeliverablesID == d.WorkOrderDeliverablesID
              ) || []
            ).map((item, index) => ({
              ...item,
              DocumentName: item.DocumentPath
                ? item.DocumentPath.split('/').pop()
                : null,
              DocumentPath: item.DocumentPath || "",
              DocumentType: null,
              DocumentRefNo: item.DocumentRefNo || index + 1,
              isEditInpute: false,
              ActionID: 0,
              SowDeliverablesDocumentsID: item.SowDeliverablesDocumentsID || null
            })),
            DocumentRefNo: d.DocumentRefNo || index + 1,
            isInstructionOrDocUpdate: false,
            IsDeliverablesRead: d.IsDeliverablesRead,
            IsDocumentRead: d.IsDocumentRead,
            VendorActivity: d.VendorActivity,
          })
        );

        const filteredstaffBadgeCounts = staffBadgeCounts.filter(
          (d) => d.MainServiceID === serviceId
        );

        const PreSetupDaysStaffBadgeCount = filteredstaffBadgeCounts.length
          ? String(filteredstaffBadgeCounts[0].PreSetupStaffBadgeCount || "")
          : "";

        const DismantlingDaysStaffBadgeCount = filteredstaffBadgeCounts.length
          ? String(filteredstaffBadgeCounts[0].DismantlingStaffBadgeCount || "")
          : "";

        const PlanSubmissionDate = filteredstaffBadgeCounts.length
          ? filteredstaffBadgeCounts[0].PlantSubmissionDate
            ? moment(
              filteredstaffBadgeCounts[0].PlantSubmissionDate,
              "YYYY-MM-DD HH:mm"
            ).toDate()
            : ""
          : "";

        const staffPreSetupDaysShiftList = preSetupStaff.filter(
          (item) => !item.IsHallManager
        );
        const hallPreSetupDaysShiftList = preSetupStaff.filter(
          (item) => item.IsHallManager
        );

        const staffEventDaysShiftList = eventDayStaff.filter(
          (item) => !item.IsHallManager
        );
        const hallEventDaysShiftList = eventDayStaff.filter(
          (item) => item.IsHallManager
        );

        const staffDismantlingDaysShiftList = dismantlingStaff.filter(
          (item) => !item.IsHallManager
        );
        const hallDismantlingDaysShiftList = dismantlingStaff.filter(
          (item) => item.IsHallManager
        );

        const staffPreArray = buildStaffList(
          staffPreSetupDaysShiftList,
          preSetupHalls,
          preSetupDates,
          HallZoneList,
          PreSetupDaysShiftList,
          serviceId,
          "PreSetup"
        );
        // console.log("staffPreArray--->", staffPreArray)

        const staffEventArray = buildStaffList(
          staffEventDaysShiftList,
          eventDayHalls,
          eventDayDates,
          HallZoneList,
          EventDaysShiftList,
          serviceId,
          "EventDay"
        );

        const staffDismantlingArray = buildStaffList(
          staffDismantlingDaysShiftList,
          dismantlingHalls,
          dismantlingDates,
          HallZoneList,
          DismantlingDaysShiftList,
          serviceId,
          "Dismantling"
        );

        const hallPreArray = buildStaffList(
          hallPreSetupDaysShiftList,
          preSetupHalls,
          preSetupDates,
          HallZoneList,
          PreSetupDaysShiftList,
          serviceId,
          "PreSetup"
        );

        const hallEventArray = buildStaffList(
          hallEventDaysShiftList,
          eventDayHalls,
          eventDayDates,
          HallZoneList,
          EventDaysShiftList,
          serviceId,
          "EventDay"
        );

        const hallDismantlingArray = buildStaffList(
          hallDismantlingDaysShiftList,
          dismantlingHalls,
          dismantlingDates,
          HallZoneList,
          DismantlingDaysShiftList,
          serviceId,
          "Dismantling"
        );

        return {
          SectionPageName: service.ServiceName,
          SectionPageNameId: service.MainServiceID,
          ServiceID: service.MainServiceID,
          DeliverablesServicesList,
          OrganizerResponsibilitiesList,
          staffPreSetupDaysList: staffPreArray,
          staffEventDaysList: staffEventArray,
          staffDismantlingDaysList: staffDismantlingArray,
          hallPreSetupDaysList: hallPreArray,
          hallEventDaysList: hallEventArray,
          hallDismantlingDaysList: hallDismantlingArray,
          PreSetupDaysStaffBadgeCount,
          DismantlingDaysStaffBadgeCount,
          PlanSubmissionDate,
          isHallChecked:
            hallPreArray.length > 0 ||
            hallEventArray.length > 0 ||
            hallDismantlingArray.length > 0,
          HallManagerLoginCredentialList,
        };
      })
    );
  }

  checkDuplicates(array, keys) {
    const seen = new Set();
    const duplicates = [];

    for (let i = 0; i < array.length; i++) {
      const obj = array[i];
      const compositeKey = keys.map((k) => obj[k]).join("|");

      if (seen.has(compositeKey)) {
        duplicates.push({ index: i, values: compositeKey });
      } else {
        seen.add(compositeKey);
      }
    }

    if (duplicates.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  checkValuesNotEmpty(arr, keys) {
    return arr.every((obj) =>
      keys.every((key) => obj[key] !== null && obj[key] !== "")
    );
  }

  checkAllocateHallDateDuplicates(list) {
    const seen = [];
    const getHalls = (h) => h.split(",").map((x) => x.trim().toLowerCase());

    const isAllShift = (shift) => shift.toLowerCase().includes("all shift");

    for (let i = 0; i < list.length; i++) {
      const item = list[i];

      const halls = getHalls(item.SelectedHalls || "");
      const date = item.SelectedDates;
      const shifts = item.SelectedShifts || [];

      const shiftTypes = shifts.map((s) => (isAllShift(s) ? "ALL" : s));

      for (let j = 0; j < seen.length; j++) {
        const prev = seen[j];

        // --- Dates must match ---
        if (prev.date === date) {
          // --- Check hall overlap ---
          const hallOverlap = prev.halls.some((h) => halls.includes(h));
          if (!hallOverlap) continue;

          // RULE 1: one has ALL shift → conflict
          if (prev.shifts.includes("ALL") || shiftTypes.includes("ALL")) {
            return true;
          }

          // RULE 2: identical shift text → conflict
          const sameShift = prev.shifts.some((s) => shiftTypes.includes(s));
          if (sameShift) {
            return true;
          }
        }
      }

      // Add current to seen list
      seen.push({ halls, date, shifts: shiftTypes });
    }

    return false;
  }

  inputValidate() {
    const {
      vendorId,
      workOrderServices,
      StartDate,
      EndDate,
      WorkOrderNumber,
      PersonName,
      EmailID,
      MobileNumber,
    } = this.state;
    if (vendorId == "" || vendorId == null) {
      this.setState({ vendorIdErr: "Please select vendor" });
    }
    if (workOrderServices.length == 0) {
      this.setState({
        workOrderServicesErr: "Please select work order service",
      });
    }
    if (StartDate == null || StartDate == "") {
      this.setState({ StartDateErr: "Please select start date" });
    }
    if (EndDate == null || EndDate == "") {
      this.setState({ EndDateErr: "Please select end date" });
    }
    if (WorkOrderNumber.trim() == "") {
      this.setState({ WorkOrderNumberErr: "Please enter work order number" });
    }
    if (PersonName.trim() == "") {
      this.setState({ PersonNameErr: "Please enter person name" });
    }
    if (EmailID.trim() == "") {
      this.setState({ EmailIDErr: "Please enter email" });
    }
    if (MobileNumber.trim() == "") {
      this.setState({ MobileNumberErr: "Please enter mobile number" });
    }
  }

  insertUpdateWorkOrder(IsSubmitted, IsUpdate, IsCreateHallManager, formType) {
    const {
      vendorId,
      workOrderServices,
      StartDate,
      EndDate,
      WorkOrderNumber,
      PersonName,
      EmailID,
      MobileNumber,
      WorkOrderID,
      ExhibitionID,
      SectionPageList,
      documentList,
      deletedDeliverablesServices,
      deletedPreSetupDaysList,
      deletedEventDaysList,
      deletedDismantlingDaysList,
      replicate,
      isVendor,
      deleteDocumentList,
      isHallManager,
      update,
    } = this.state;
    this.inputValidate();
    this.setState({ isLoading: true });

    if (
      ExhibitionID == "" ||
      ExhibitionID == null ||
      vendorId == "" ||
      vendorId == null ||
      WorkOrderNumber == "" ||
      WorkOrderNumber == null ||
      PersonName == "" ||
      PersonName == null ||
      EmailID == "" ||
      EmailID == null ||
      MobileNumber == "" ||
      MobileNumber == null ||
      StartDate == "" ||
      StartDate == null ||
      EndDate == "" ||
      EndDate == null ||
      workOrderServices.length == 0
    ) {
      this.setState({ isLoading: false });
      return toastError("Please enter mandatory feilds!");
    }

    const isEmailValidate = emailValidator(EmailID);
    if (isEmailValidate) {
      this.setState({ isLoading: false });
      return toastError(isEmailValidate);
    }

    const isMobileValidate = notMendetoryMobileNoValidator(MobileNumber);
    if (isMobileValidate) {
      this.setState({ isLoading: false });
      return toastError(`${isMobileValidate}`);
    }

    const array1 = [];
    const array2 = [];
    const array3 = [];
    const array4 = [];
    const array5 = [];
    const array6 = [];
    const array7 = [];
    const array8 = [];
    const array9 = [];
    const array10 = [];
    const array11 = [];
    const array12 = [];
    const array13 = [];

    for (const item of SectionPageList) {
      // item.isHallChecked = item.SectionPageName == "Onsite Agency"
      const SectionTypeName = item.SectionPageName == "Onsite Agency" ? 'hall manager' : 'team member'
      item.isHallChecked = item.SectionPageName == "Onsite Agency" ? true : item.isHallChecked
      for (const o of deletedDeliverablesServices) {
        if (item.ActionID != 0 && !replicate) {
          array1.push({
            WorkOrderDeliverablesID: o.WorkOrderDeliverablesID,
            ActionID: o.ActionID,
            MainServiceID: item.ServiceID,
            MainServiceDeliverablesID: o.MainServiceDeliverablesID,
            DeliverablesService: o.MainServiceDeliverablesName,
            ScopeOfWork: o.ScopeOfWork,
            LogisticsResponsibilities: o.LogisticsResponsibilities,
            ComplianceRequirements: o.ComplianceRequirements,
            Manpower: o.Manpower,
            StartDate: o.DeliverablesServicesStartDate
              ? moment(o.DeliverablesServicesStartDate).format(
                "YYYY-MM-DD HH:mm"
              )
              : null,
            EndDate: o.DeliverablesServicesEndDate
              ? moment(o.DeliverablesServicesEndDate).format("YYYY-MM-DD HH:mm")
              : null,
            VOPriceInUSD: o.VendorOrganizerPriceInUSD,
            VOPriceInINR: o.VendorOrganizerPriceInINR,
            VEPriceInUSD: o.VendorExhibitorPriceInUSD,
            VEPriceInINR: o.VendorExhibitorPriceInINR,
            Remark: o.Remark,
            Quantity: o.Quantity,
            IsStockAvailable: o.IsStockAvailable,
            AccessibleID: o.AccessibleID,
            DeliverablesPricingID: o.DeliverablesPricingID,
            Instructions: o.Instructions,
            DocumentRefNo: o.DocumentRefNo,
            isInstructionOrDocUpdate: o.isInstructionOrDocUpdate || false
          });
        }
      }

      for (const o of deletedPreSetupDaysList) {
        if (o.ActionID != 0 && !replicate) {
          array3.push({
            PreStaffID: o.PreSetupStaffID,
            StaffBadgeCount: item.PreSetupDaysStaffBadgeCount,
            MainServiceID: item.ServiceID,
            PersonName: o.PersonName,
            EmailID: o.EmailID,
            MobileNumber: o.MobileNumber,
            Address: null,
            AllocatedDateIDs: null,
            IsHallManager: 0,
            ActionID: o.ActionID,
            DesignationID: o.DesignationID,
          });
        }
      }

      for (const o of deletedEventDaysList) {
        if (o.ActionID != 0 && !replicate) {
          array4.push({
            EventDayStaffID: o.EventDayStaffID,
            StaffBadgeCount: null,
            MainServiceID: item.ServiceID,
            PersonName: o.PersonName,
            EmailID: o.EmailID,
            MobileNumber: o.MobileNumber,
            Address: null,
            AllocatedDate: null,
            IsHallManager: 0,
            ActionID: o.ActionID,
            DesignationID: o.DesignationID,
          });
        }
      }

      for (const o of deletedDismantlingDaysList) {
        if (o.ActionID != 0 && !replicate) {
          array5.push({
            DismantlingStaffID: o.DismantlingStaffID,
            StaffBadgeCount: item.DismantlingDaysStaffBadgeCount,
            MainServiceID: item.ServiceID,
            PersonName: o.PersonName,
            EmailID: o.EmailID,
            MobileNumber: o.MobileNumber,
            Address: null,
            AllocatedDateIDs: null,
            IsHallManager: 0,
            ActionID: o.ActionID,
            DesignationID: o.DesignationID,
          });
        }
      }

      for (const o of item.DeliverablesServicesList) {
        if (item.ActionID != 0) {
          array1.push({
            WorkOrderDeliverablesID: o.WorkOrderDeliverablesID,
            ActionID: o.ActionID,
            MainServiceID: item.ServiceID,
            MainServiceDeliverablesID: o.MainServiceDeliverablesID,
            DeliverablesService: o.MainServiceDeliverablesName,
            ScopeOfWork: o.ScopeOfWork,
            LogisticsResponsibilities: o.LogisticsResponsibilities,
            Manpower: o.Manpower,
            StartDate: o.DeliverablesServicesStartDate
              ? moment(o.DeliverablesServicesStartDate).format(
                "YYYY-MM-DD HH:mm"
              )
              : null,
            EndDate: o.DeliverablesServicesEndDate
              ? moment(o.DeliverablesServicesEndDate).format("YYYY-MM-DD HH:mm")
              : null,
            VOPriceInUSD: o.VendorOrganizerPriceInUSD,
            VOPriceInINR: o.VendorOrganizerPriceInINR,
            VEPriceInUSD: o.VendorExhibitorPriceInUSD,
            VEPriceInINR: o.VendorExhibitorPriceInINR,
            Remark: o.Remark,
            Quantity: o.Quantity,
            IsStockAvailable: o.IsStockAvailable,
            AccessibleID: o.AccessibleID,
            DeliverablesPricingID: o.DeliverablesPricingID,
            Instructions: o.Instructions,
            DocumentRefNo: o.DocumentRefNo,
            isInstructionOrDocUpdate: o.isInstructionOrDocUpdate
          });
        }
      }

      for (const o of item.DeliverablesServicesList) {
        if (o.ActionID != 0) {
          for (let d = 0; d < o.DocumentsList.length; d++) {
            if (o.DocumentsList[d].ActionID != 0) {
              array13.push({
                DocumentRefNo: o.DocumentRefNo,
                DocumentPath: o.DocumentsList[d].DocumentPath,
                DocumentName: o.DocumentsList[d].DocumentName,
                DocumentType: o.DocumentsList[d].DocumentType,
                ActionID: o.DocumentsList[d].ActionID,
                SowDeliverablesDocumentsID: o.DocumentsList[d].SowDeliverablesDocumentsID
              });
            }
          }
          if (o.isInstructionsChange && (o.previousInstructions != o.Instructions)) {
            array13.push({
              DocumentRefNo: o.DocumentRefNo,
              DocumentPath: null,
              DocumentName: null,
              DocumentType: null,
              ActionID: 1,
              SowDeliverablesDocumentsID: null,
              Instructions: o.Instructions,
            });
          }
        }
      }

      array12.push({
        MainServiceID: item.ServiceID,
        PlanSubmissionDate: item.PlanSubmissionDate
          ? moment(item.PlanSubmissionDate).format("YYYY-MM-DD HH:mm")
          : null,
      });

      const PlanSubmissionDate = array12.every(
        (item) =>
          item.PlanSubmissionDate != "" && item.PlanSubmissionDate != null
      );
      if (!PlanSubmissionDate) {
        this.setState({ isLoading: false });
        return toastError(
          `Plan Submission Date should not be blank in ${item.SectionPageName}`
        );
      }

      const DeliverablesServicesIsLength0 =
        item.DeliverablesServicesList.length == 0;
      if (DeliverablesServicesIsLength0) {
        this.setState({ isLoading: false });
        return toastError(
          `Please atleast 1 row add on deliverables services in ${item.SectionPageName}`
        );
      }

      for (const o of item.OrganizerResponsibilitiesList) {
        if (item.ActionID != 0) {
          array2.push({
            MainServiceID: item.ServiceID,
            Responsibility: o.Responsibilities,
          });
        }
      }

      const staffPreSetupIsBlank = this.checkValuesNotEmpty(
        item.staffPreSetupDaysList,
        ["PersonName", "EmailID", "MobileNumber", "DesignationID"]
      );

      if (!staffPreSetupIsBlank && isVendor) {
        this.setState({ isLoading: false });
        return toastError(
          `Please fill all row in the staff section on pre-setup days in ${item.SectionPageName}`
        );
      }

      const staffPreSetupIsLength0 = item.staffPreSetupDaysList.length == 0;
      if (staffPreSetupIsLength0 && isVendor) {
        this.setState({ isLoading: false });
        return toastError(
          `Please atleast 1 row add in the staff section on pre-setup days in ${item.SectionPageName}`
        );
      }

      const staffPreSetupDuplicate = this.checkDuplicates(
        item.staffPreSetupDaysList,
        ["PersonName", "EmailID", "MobileNumber", "DesignationID"]
      );
      if (staffPreSetupDuplicate) {
        this.setState({ isLoading: false });
        return toastError(
          `Duplicate records cannot be inserted in the staff section on pre-setup days in ${item.SectionPageName}`
        );
      }

      for (const o of item.staffPreSetupDaysList) {
        if (o.ActionID != 0) {
          const isEmailValidate = notMendetoryEmailValidator(o.EmailID);
          if (isEmailValidate) {
            this.setState({ isLoading: false });
            return toastError(
              `${isEmailValidate} in the staff section on pre-setup days`
            );
          }
          const isMobileValidate = notMendetoryMobileNoValidator(o.MobileNumber);
          if (isMobileValidate && isVendor) {
            this.setState({ isLoading: false });
            return toastError(
              `${isMobileValidate} in the staff section on pre-setup days in ${item.SectionPageName}`
            );
          }
          array3.push({
            PreStaffID: o.PreSetupStaffID,
            StaffBadgeCount: item.PreSetupDaysStaffBadgeCount,
            MainServiceID: item.ServiceID,
            PersonName: o.PersonName,
            EmailID: o.EmailID,
            MobileNumber: o.MobileNumber,
            Address: null,
            AllocatedDateIDs: null,
            IsHallManager: 0,
            ActionID: o.ActionID,
            DesignationID: o.DesignationID,
          });
        }
      }

      const staffEventIsBlank = this.checkValuesNotEmpty(
        item.staffEventDaysList,
        ["PersonName", "EmailID", "MobileNumber", "DesignationID"]
      );
      if (!staffEventIsBlank && isVendor) {
        this.setState({ isLoading: false });
        return toastError(
          `Please fill all row in the staff section on event days in ${item.SectionPageName}`
        );
      }

      const staffEventIsLength0 = item.staffEventDaysList.length == 0;
      if (staffEventIsLength0 && isVendor) {
        this.setState({ isLoading: false });
        return toastError(
          `Please atleast 1 row add in the staff section on event days in ${item.SectionPageName}`
        );
      }

      const staffEventDuplicate = this.checkDuplicates(
        item.staffEventDaysList,
        ["PersonName", "EmailID", "MobileNumber", "DesignationID"]
      );
      if (staffEventDuplicate) {
        this.setState({ isLoading: false });
        return toastError(
          `Duplicate records cannot be inserted in the staff section on event days in ${item.SectionPageName}`
        );
      }

      for (const o of item.staffEventDaysList) {
        if (o.ActionID != 0) {
          const isEmailValidate = notMendetoryEmailValidator(o.EmailID);
          if (isEmailValidate) {
            this.setState({ isLoading: false });
            return toastError(
              `${isEmailValidate} in the staff section on event days in ${item.SectionPageName}`
            );
          }
          const isMobileValidate = notMendetoryMobileNoValidator(o.MobileNumber);
          if (isMobileValidate && isVendor) {
            this.setState({ isLoading: false });
            return toastError(
              `${isMobileValidate} in the staff section on event days in ${item.SectionPageName}`
            );
          }
          array4.push({
            EventDayStaffID: o.EventDayStaffID,
            StaffBadgeCount: null,
            MainServiceID: item.ServiceID,
            PersonName: o.PersonName,
            EmailID: o.EmailID,
            MobileNumber: o.MobileNumber,
            Address: null,
            AllocatedDate: null,
            IsHallManager: 0,
            ActionID: o.ActionID,
            DesignationID: o.DesignationID,
          });
        }
      }

      const staffDismantlingIsBlank = this.checkValuesNotEmpty(
        item.staffDismantlingDaysList,
        ["PersonName", "EmailID", "MobileNumber", "DesignationID"]
      );
      if (!staffDismantlingIsBlank && isVendor) {
        this.setState({ isLoading: false });
        return toastError(
          `Please fill all row in the staff section on dismantling days in ${item.SectionPageName}`
        );
      }

      const staffDismantlingIsLength0 =
        item.staffDismantlingDaysList.length == 0;
      if (staffDismantlingIsLength0 && isVendor) {
        this.setState({ isLoading: false });
        return toastError(
          `Please atleast 1 row add in the staff section on dismantling days in ${item.SectionPageName}`
        );
      }

      const staffDismantlingDuplicate = this.checkDuplicates(
        item.staffDismantlingDaysList,
        ["PersonName", "EmailID", "MobileNumber", "DesignationID"]
      );
      if (staffDismantlingDuplicate) {
        this.setState({ isLoading: false });
        return toastError(
          `Duplicate records cannot be inserted in the staff section on dismantling days in ${item.SectionPageName}`
        );
      }

      for (const o of item.staffDismantlingDaysList) {
        if (o.ActionID != 0) {
          const isEmailValidate = notMendetoryEmailValidator(o.EmailID);
          if (isEmailValidate && item.isHallChecked) {
            this.setState({ isLoading: false });
            return toastError(
              `${isEmailValidate} in the staff section on dismantling days in ${item.SectionPageName}`
            );
          }
          const isMobileValidate = notMendetoryMobileNoValidator(o.MobileNumber);
          if (isMobileValidate && isVendor) {
            this.setState({ isLoading: false });
            return toastError(
              `${isMobileValidate} in the staff section on dismantling days in ${item.SectionPageName}`
            );
          }
          array5.push({
            DismantlingStaffID: o.DismantlingStaffID,
            StaffBadgeCount: item.DismantlingDaysStaffBadgeCount,
            MainServiceID: item.ServiceID,
            PersonName: o.PersonName,
            EmailID: o.EmailID,
            MobileNumber: o.MobileNumber,
            Address: null,
            AllocatedDateIDs: null,
            IsHallManager: 0,
            ActionID: o.ActionID,
            DesignationID: o.DesignationID,
          });
        }
      }

      // if (item.SectionPageName == "Onsite Agency") {

      const hallPreSetupIsBlank = this.checkValuesNotEmpty(
        item.hallPreSetupDaysList,
        [
          "PersonName",
          "EmailID",
          "MobileNumber",
          "SelectedHalls",
          "AllocatedDateIDs",
        ]
      );
      if (!hallPreSetupIsBlank && item.isHallChecked && isVendor) {
        this.setState({ isLoading: false });
        return toastError(
          `Please fill all row in the ${SectionTypeName} on pre-setup days in ${item.SectionPageName}`
        );
      }

      const hallPreSetupIsLength0 = item.hallPreSetupDaysList.length == 0;
      if (hallPreSetupIsLength0 && item.isHallChecked && isVendor) {
        this.setState({ isLoading: false });
        return toastError(
          `Please atleast 1 row add in the ${SectionTypeName} on pre-setup days in ${item.SectionPageName}`
        );
      }

      const hallPreSetupDuplicate = this.checkDuplicates(
        item.hallPreSetupDaysList,
        ["EmailID"]
      );
      if (hallPreSetupDuplicate && item.isHallChecked) {
        this.setState({ isLoading: false });
        return toastError(
          `Duplicate email cannot be insert in the ${SectionTypeName} on pre-setup  in ${item.SectionPageName}`
        );
      }

      const PreAllocateHallDateDuplicates =
        this.checkAllocateHallDateDuplicates(item.hallPreSetupDaysList);
      if (PreAllocateHallDateDuplicates && item.isHallChecked) {
        this.setState({ isLoading: false });
        return toastError(
          `The same hall and date cannot be assigned to more than one in the ${SectionTypeName} on pre-setup in ${item.SectionPageName}`
        );
      }

      for (const o of item.hallPreSetupDaysList) {
        if (o.ActionID != 0 || !item.isHallChecked) {
          const isEmailValidate = notMendetoryEmailValidator(o.EmailID);
          if (isEmailValidate && item.isHallChecked) {
            this.setState({ isLoading: false });
            return toastError(
              `${isEmailValidate} in the ${SectionTypeName} on pre-setup days in ${item.SectionPageName}`
            );
          }
          const isMobileValidate = notMendetoryMobileNoValidator(o.MobileNumber);
          if (isMobileValidate && isVendor) {
            this.setState({ isLoading: false });
            return toastError(
              `${isMobileValidate} in the ${SectionTypeName} on pre-setup days in ${item.SectionPageName}`
            );
          }
          array3.push({
            PreStaffID: o.PreSetupStaffID,
            StaffBadgeCount: item.PreSetupDaysStaffBadgeCount,
            MainServiceID: item.ServiceID,
            PersonName: o.PersonName,
            EmailID: o.EmailID,
            MobileNumber: o.MobileNumber,
            Address: null,
            AllocatedDateIDs: o.AllocatedDateIDs,
            IsHallManager: 1,
            ActionID: !item.isHallChecked ? 3 : o.ActionID,
            DesignationID: "",
          });
        }
      }

      const hallEventIsBlank = this.checkValuesNotEmpty(
        item.hallEventDaysList,
        [
          "PersonName",
          "EmailID",
          "MobileNumber",
          "SelectedHalls",
          "SelectedDates",
        ]
      );
      if (!hallEventIsBlank && item.isHallChecked && isVendor) {
        this.setState({ isLoading: false });
        return toastError(
          `Please fill all row in the ${SectionTypeName} on event  in ${item.SectionPageName}`
        );
      }

      const hallEventIsLength0 = item.hallEventDaysList.length == 0;
      if (hallEventIsLength0 && item.isHallChecked && isVendor) {
        this.setState({ isLoading: false });
        return toastError(
          `Please atleast 1 row add in the ${SectionTypeName} on event  in ${item.SectionPageName}`
        );
      }

      const hallEventDuplicate = this.checkDuplicates(item.hallEventDaysList, [
        "EmailID",
      ]);
      if (hallEventDuplicate && item.isHallChecked) {
        this.setState({ isLoading: false });
        return toastError(
          `Duplicate email cannot be insert in the ${SectionTypeName} on event  in ${item.SectionPageName}`
        );
      }

      const EventAllocateHallDateDuplicates =
        this.checkAllocateHallDateDuplicates(item.hallEventDaysList);
      if (EventAllocateHallDateDuplicates && item.isHallChecked) {
        this.setState({ isLoading: false });
        return toastError(
          `The same hall and date cannot be assigned to more than one in the ${SectionTypeName} on event in ${item.SectionPageName}`
        );
      }

      for (const o of item.hallEventDaysList) {
        if (o.ActionID != 0 || !item.isHallChecked) {
          const isEmailValidate = notMendetoryEmailValidator(o.EmailID);
          if (isEmailValidate && item.isHallChecked) {
            this.setState({ isLoading: false });
            return toastError(
              `${isEmailValidate} in the ${SectionTypeName} on event days in ${item.SectionPageName}`
            );
          }
          const isMobileValidate = notMendetoryMobileNoValidator(o.MobileNumber);
          if (isMobileValidate && isVendor) {
            this.setState({ isLoading: false });
            return toastError(
              `${isMobileValidate} in the ${SectionTypeName} on event days in ${item.SectionPageName}`
            );
          }
          array4.push({
            EventDayStaffID: o.EventDayStaffID,
            StaffBadgeCount: null,
            MainServiceID: item.ServiceID,
            PersonName: o.PersonName,
            EmailID: o.EmailID,
            MobileNumber: o.MobileNumber,
            Address: null,
            AllocatedDate: o.SelectedDates,
            IsHallManager: 1,
            ActionID: !item.isHallChecked ? 3 : o.ActionID,
            DesignationID: "",
          });
        }
      }

      const hallDismantlingIsBlank = this.checkValuesNotEmpty(
        item.hallDismantlingDaysList,
        [
          "PersonName",
          "EmailID",
          "MobileNumber",
          "SelectedHalls",
          "AllocatedDateIDs",
        ]
      );
      if (!hallDismantlingIsBlank && item.isHallChecked && isVendor) {
        this.setState({ isLoading: false });
        return toastError(
          `Please fill all row in the ${SectionTypeName} on dismantling  in ${item.SectionPageName}`
        );
      }

      const hallDismantlingIsLength0 = item.hallDismantlingDaysList.length == 0;
      if (hallDismantlingIsLength0 && item.isHallChecked && isVendor) {
        this.setState({ isLoading: false });
        return toastError(
          `Please atleast 1 row add in the ${SectionTypeName} on dismantling  in ${item.SectionPageName}`
        );
      }

      const hallDismantlingDuplicate = this.checkDuplicates(
        item.hallDismantlingDaysList,
        ["EmailID"]
      );
      if (hallDismantlingDuplicate && item.isHallChecked) {
        this.setState({ isLoading: false });
        return toastError(
          `Duplicate email cannot be insert in the ${SectionTypeName} on dismantling  in ${item.SectionPageName}`
        );
      }

      const DismantlingAllocateHallDateDuplicates =
        this.checkAllocateHallDateDuplicates(item.hallDismantlingDaysList);
      if (DismantlingAllocateHallDateDuplicates && item.isHallChecked) {
        this.setState({ isLoading: false });
        return toastError(
          `The same hall and date cannot be assigned to more than one in the ${SectionTypeName} on dismantling in ${item.SectionPageName}`
        );
      }

      for (const o of item.hallDismantlingDaysList) {
        if (o.ActionID != 0 || !item.isHallChecked) {
          const isEmailValidate = notMendetoryEmailValidator(o.EmailID);
          if (isEmailValidate) {
            this.setState({ isLoading: false });
            return toastError(
              `${isEmailValidate} in the ${SectionTypeName} on dismantling days in ${item.SectionPageName}`
            );
          }
          const isMobileValidate = notMendetoryMobileNoValidator(o.MobileNumber);
          if (isMobileValidate && isVendor) {
            this.setState({ isLoading: false });
            return toastError(
              `${isMobileValidate} in the ${SectionTypeName} on dismantling days in ${item.SectionPageName}`
            );
          }
          array5.push({
            DismantlingStaffID: o.DismantlingStaffID,
            StaffBadgeCount: item.DismantlingDaysStaffBadgeCount,
            MainServiceID: item.ServiceID,
            PersonName: o.PersonName,
            EmailID: o.EmailID,
            MobileNumber: o.MobileNumber,
            Address: null,
            AllocatedDateIDs: o.AllocatedDateIDs,
            IsHallManager: 1,
            ActionID: !item.isHallChecked ? 3 : o.ActionID,
            DesignationID: "",
          });
        }
      }

      item.hallPreSetupDaysList.length > 0 &&
        item.hallPreSetupDaysList.map((obj) => {
          if (obj.ActionID != 0) {
            obj.selectedHallZoneList.forEach((o) => {
              array6.push({
                MainServiceID: item.ServiceID,
                EmailID: obj.EmailID,
                HallID: o.HallID,
                ZoneID: o.ZoneID,
              });
            });
          }
        });

      item.hallEventDaysList.length > 0 &&
        item.hallEventDaysList.map((obj) => {
          if (obj.ActionID != 0) {
            obj.selectedHallZoneList.forEach((o) => {
              array7.push({
                MainServiceID: item.ServiceID,
                EmailID: obj.EmailID,
                HallID: o.HallID,
                ZoneID: o.ZoneID,
              });
            });
          }
        });

      item.hallDismantlingDaysList.length > 0 &&
        item.hallDismantlingDaysList.map((obj) => {
          if (obj.ActionID != 0) {
            obj.selectedHallZoneList.forEach((o) => {
              array8.push({
                MainServiceID: item.ServiceID,
                EmailID: obj.EmailID,
                HallID: o.HallID,
                ZoneID: o.ZoneID,
              });
            });
          }
        });
      // }

      for (const obj of item.DeliverablesServicesList) {
        if (obj.ActionID != 0 || !item.isHallChecked) {
          const ComplianceRequirementsIsBlank = this.checkValuesNotEmpty(
            obj.ComplianceRequirementsList,
            ["Specification", "LocationID", "Quantity", "DesigTimeLinenationID"]
          );

          if (!ComplianceRequirementsIsBlank) {
            this.setState({ isLoading: false });
            return toastError(
              `Please fill all row in the deliverables ${obj.DeliverablesService} compliance requirements in ${item.SectionPageName}`
            );
          }

          const ComplianceRequirementsListDuplicate = this.checkDuplicates(
            obj.ComplianceRequirementsList,
            ["Specification", "LocationID", "Quantity", "TimeLine"]
          );
          if (ComplianceRequirementsListDuplicate) {
            this.setState({ isLoading: false });
            return toastError(
              `Duplicate records cannot be inserted in the deliverables ${obj.DeliverablesService} compliance requirements in ${item.SectionPageName}`
            );
          }

          for (const o of obj.ComplianceRequirementsList) {
            array9.push({
              MainServiceID: item.ServiceID,
              DeliverablesID: obj.MainServiceDeliverablesID,
              Specification: o.Specification,
              LocationID: o.LocationID != "Other" ? o.LocationID : null,
              LocationName: o.LocationName,
              Quantity: o.Quantity,
              TimeLine: o.TimeLine
                ? moment(o.TimeLine).format("YYYY-MM-DD HH:mm")
                : null,
            });
          }
        }
      }

      array10.push({
        MainServiceID: item.ServiceID,
        StaffBadgeCount: item.PreSetupDaysStaffBadgeCount,
      });

      array11.push({
        MainServiceID: item.ServiceID,
        StaffBadgeCount: item.DismantlingDaysStaffBadgeCount,
      });

      const isPreSetupCountBlank = array10.every(
        (item) => item.StaffBadgeCount != "" && item.StaffBadgeCount != null
      );
      if (!isPreSetupCountBlank && isVendor) {
        this.setState({ isLoading: false });
        return toastError(
          `Pre-setup days staff count should not be blank in ${item.SectionPageName}`
        );
      }

      const isDismantlingCountBlank = array11.every(
        (item) => item.StaffBadgeCount != "" && item.StaffBadgeCount != null
      );
      if (!isDismantlingCountBlank && isVendor) {
        this.setState({ isLoading: false });
        return toastError(
          `Dismantling days staff count should not be blank in ${item.SectionPageName}`
        );
      }
    }


    const servicesids = workOrderServices.map((item) => item.value).join(",");
    const formateStartDate = StartDate
      ? moment(StartDate).format("YYYY-MM-DD HH:mm")
      : null;
    const formateEndDate = EndDate
      ? moment(EndDate).format("YYYY-MM-DD HH:mm")
      : null;

    try {
      this.setState({ isLoading: true });
      this.props
        .insertUpdateVendorWorkOrder_action(
          replicate ? null : WorkOrderID,
          ExhibitionID,
          vendorId,
          WorkOrderNumber,
          servicesids,
          PersonName,
          EmailID,
          MobileNumber,
          formateStartDate,
          formateEndDate,
          array1,
          array2,
          array3,
          array4,
          array5,
          array6,
          array7,
          array8,
          array9,
          array10,
          array11,
          [...documentList, ...deleteDocumentList],
          isVendor ? 0 : IsSubmitted,
          array12,
          IsUpdate,
          formType,
          array13
        )
        .then((data) => {
          if (data.error != 1) {
            if (isHallManager) {
              toastSuccess("Scope of work update successfully!");
            } else {
              if (IsCreateHallManager) {
                this.createhallManagerAccess();
              } else {
                this.isInstructionOrDocUpdateTag()
                toastSuccess(
                  `Scope of work ${update ? "updated" : "added"} successfully!`
                );
                setTimeout(() => {
                  (JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7 || JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 17)
                    ? this.props.navigate("/VendorModule")
                    : this.props.navigate("/vendorWorkOrderList");
                }, 2000);
              }
            }
          } else {
            toastError(data.msg);
          }
          this.setState({ isLoading: false });
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
        });
    } catch {
      toastError("Something went wrong!");
      this.setState({ isLoading: false });
    } finally {
      // this.setState({ isLoading: false })
    }
  }

  saveAsDraftWorkOrder(IsSubmitted, IsUpdate, IsCreateHallManager, formType) {
    const {
      vendorId,
      workOrderServices,
      StartDate,
      EndDate,
      WorkOrderNumber,
      PersonName,
      EmailID,
      MobileNumber,
      WorkOrderID,
      ExhibitionID,
      SectionPageList,
      documentList,
      deletedDeliverablesServices,
      deletedPreSetupDaysList,
      deletedEventDaysList,
      deletedDismantlingDaysList,
      replicate,
      isVendor,
      deleteDocumentList,
      isHallManager,
      update,
    } = this.state;
    this.inputValidate();
    this.setState({ isLoading: true });

    if (
      ExhibitionID == "" ||
      ExhibitionID == null ||
      vendorId == "" ||
      vendorId == null ||
      WorkOrderNumber == "" ||
      WorkOrderNumber == null ||
      PersonName == "" ||
      PersonName == null ||
      EmailID == "" ||
      EmailID == null ||
      MobileNumber == "" ||
      MobileNumber == null ||
      StartDate == "" ||
      StartDate == null ||
      EndDate == "" ||
      EndDate == null ||
      workOrderServices.length == 0
    ) {
      this.setState({ isLoading: false });
      return toastError("Please enter mandatory feilds!");
    }

    const isEmailValidate = emailValidator(EmailID);
    if (isEmailValidate) {
      this.setState({ isLoading: false });
      return toastError(isEmailValidate);
    }

    const isMobileValidate = notMendetoryMobileNoValidator(MobileNumber);
    if (isMobileValidate) {
      this.setState({ isLoading: false });
      return toastError(`${isMobileValidate}`);
    }

    const array1 = [];
    const array2 = [];
    const array3 = [];
    const array4 = [];
    const array5 = [];
    const array6 = [];
    const array7 = [];
    const array8 = [];
    const array9 = [];
    const array10 = [];
    const array11 = [];
    const array12 = [];
    const array13 = [];

    for (const item of SectionPageList) {
      for (const o of deletedDeliverablesServices) {
        if (item.ActionID != 0 && !replicate) {
          array1.push({
            WorkOrderDeliverablesID: o.WorkOrderDeliverablesID,
            ActionID: o.ActionID,
            MainServiceID: item.ServiceID,
            MainServiceDeliverablesID: o.MainServiceDeliverablesID,
            DeliverablesService: o.MainServiceDeliverablesName,
            ScopeOfWork: o.ScopeOfWork,
            LogisticsResponsibilities: o.LogisticsResponsibilities,
            ComplianceRequirements: o.ComplianceRequirements,
            Manpower: o.Manpower,
            StartDate: o.DeliverablesServicesStartDate
              ? moment(o.DeliverablesServicesStartDate).format(
                "YYYY-MM-DD HH:mm"
              )
              : null,
            EndDate: o.DeliverablesServicesEndDate
              ? moment(o.DeliverablesServicesEndDate).format("YYYY-MM-DD HH:mm")
              : null,
            VOPriceInUSD: o.VendorOrganizerPriceInUSD,
            VOPriceInINR: o.VendorOrganizerPriceInINR,
            VEPriceInUSD: o.VendorExhibitorPriceInUSD,
            VEPriceInINR: o.VendorExhibitorPriceInINR,
            Remark: o.Remark,
            Quantity: o.Quantity,
            IsStockAvailable: o.IsStockAvailable,
            AccessibleID: o.AccessibleID,
            DeliverablesPricingID: o.DeliverablesPricingID,
          });
        }
      }

      for (const o of deletedPreSetupDaysList) {
        if (o.ActionID != 0 && !replicate) {
          array3.push({
            PreStaffID: o.PreSetupStaffID,
            StaffBadgeCount: item.PreSetupDaysStaffBadgeCount,
            MainServiceID: item.ServiceID,
            PersonName: o.PersonName,
            EmailID: o.EmailID,
            MobileNumber: o.MobileNumber,
            Address: null,
            AllocatedDateIDs: null,
            IsHallManager: 0,
            ActionID: o.ActionID,
            DesignationID: o.DesignationID,
          });
        }
      }

      for (const o of deletedEventDaysList) {
        if (o.ActionID != 0 && !replicate) {
          array4.push({
            EventDayStaffID: o.EventDayStaffID,
            StaffBadgeCount: null,
            MainServiceID: item.ServiceID,
            PersonName: o.PersonName,
            EmailID: o.EmailID,
            MobileNumber: o.MobileNumber,
            Address: null,
            AllocatedDate: null,
            IsHallManager: 0,
            ActionID: o.ActionID,
            DesignationID: o.DesignationID,
          });
        }
      }

      for (const o of deletedDismantlingDaysList) {
        if (o.ActionID != 0 && !replicate) {
          array5.push({
            DismantlingStaffID: o.DismantlingStaffID,
            StaffBadgeCount: item.DismantlingDaysStaffBadgeCount,
            MainServiceID: item.ServiceID,
            PersonName: o.PersonName,
            EmailID: o.EmailID,
            MobileNumber: o.MobileNumber,
            Address: null,
            AllocatedDateIDs: null,
            IsHallManager: 0,
            ActionID: o.ActionID,
            DesignationID: o.DesignationID,
          });
        }
      }

      for (const o of item.DeliverablesServicesList) {
        if (item.ActionID != 0) {
          array1.push({
            WorkOrderDeliverablesID: o.WorkOrderDeliverablesID,
            ActionID: o.ActionID,
            MainServiceID: item.ServiceID,
            MainServiceDeliverablesID: o.MainServiceDeliverablesID,
            DeliverablesService: o.MainServiceDeliverablesName,
            ScopeOfWork: o.ScopeOfWork,
            LogisticsResponsibilities: o.LogisticsResponsibilities,
            Manpower: o.Manpower,
            StartDate: o.DeliverablesServicesStartDate
              ? moment(o.DeliverablesServicesStartDate).format(
                "YYYY-MM-DD HH:mm"
              )
              : null,
            EndDate: o.DeliverablesServicesEndDate
              ? moment(o.DeliverablesServicesEndDate).format("YYYY-MM-DD HH:mm")
              : null,
            VOPriceInUSD: o.VendorOrganizerPriceInUSD,
            VOPriceInINR: o.VendorOrganizerPriceInINR,
            VEPriceInUSD: o.VendorExhibitorPriceInUSD,
            VEPriceInINR: o.VendorExhibitorPriceInINR,
            Remark: o.Remark,
            Quantity: o.Quantity,
            IsStockAvailable: o.IsStockAvailable,
            AccessibleID: o.AccessibleID,
            DeliverablesPricingID: o.DeliverablesPricingID,
            Instructions: o.Instructions,
            DocumentRefNo: o.DocumentRefNo,
            isInstructionOrDocUpdate: false
          });
        }
      }

      for (const o of item.DeliverablesServicesList) {
        if (o.ActionID != 0) {
          for (let d = 0; d < o.DocumentsList.length; d++) {
            if (o.DocumentsList[d].ActionID != 0) {
              array13.push({
                DocumentRefNo: o.DocumentRefNo,
                DocumentPath: o.DocumentsList[d].DocumentPath,
                DocumentName: o.DocumentsList[d].DocumentName,
                DocumentType: o.DocumentsList[d].DocumentType,
                ActionID: o.DocumentsList[d].ActionID,
                SowDeliverablesDocumentsID: o.DocumentsList[d].SowDeliverablesDocumentsID,
              });
            }
          }
          if (o.isInstructionsChange && (o.previousInstructions != o.Instructions)) {
            array13.push({
              DocumentRefNo: o.DocumentRefNo,
              DocumentPath: null,
              DocumentName: null,
              DocumentType: null,
              ActionID: 1,
              SowDeliverablesDocumentsID: null,
              Instructions: o.Instructions,
            });
          }
        }
      }

      array12.push({
        MainServiceID: item.ServiceID,
        PlanSubmissionDate: item.PlanSubmissionDate
          ? moment(item.PlanSubmissionDate).format("YYYY-MM-DD HH:mm")
          : null,
      });

      for (const o of item.OrganizerResponsibilitiesList) {
        if (item.ActionID != 0) {
          array2.push({
            MainServiceID: item.ServiceID,
            Responsibility: o.Responsibilities,
          });
        }
      }

      for (const o of item.staffPreSetupDaysList) {
        if (o.ActionID != 0) {
          const isEmailValidate = notMendetoryEmailValidator(o.EmailID);
          if (isEmailValidate) {
            this.setState({ isLoading: false });
            return toastError(
              `${isEmailValidate} in the staff section on pre-setup days`
            );
          }
          array3.push({
            PreStaffID: o.PreSetupStaffID,
            StaffBadgeCount: item.PreSetupDaysStaffBadgeCount,
            MainServiceID: item.ServiceID,
            PersonName: o.PersonName,
            EmailID: o.EmailID,
            MobileNumber: o.MobileNumber,
            Address: null,
            AllocatedDateIDs: null,
            IsHallManager: 0,
            ActionID: o.ActionID,
            DesignationID: o.DesignationID,
          });
        }
      }

      for (const o of item.staffEventDaysList) {
        if (o.ActionID != 0) {
          const isEmailValidate = notMendetoryEmailValidator(o.EmailID);
          if (isEmailValidate) {
            this.setState({ isLoading: false });
            return toastError(
              `${isEmailValidate} in the staff section on event days in ${item.SectionPageName}`
            );
          }
          array4.push({
            EventDayStaffID: o.EventDayStaffID,
            StaffBadgeCount: null,
            MainServiceID: item.ServiceID,
            PersonName: o.PersonName,
            EmailID: o.EmailID,
            MobileNumber: o.MobileNumber,
            Address: null,
            AllocatedDate: null,
            IsHallManager: 0,
            ActionID: o.ActionID,
            DesignationID: o.DesignationID,
          });
        }
      }

      for (const o of item.staffDismantlingDaysList) {
        if (o.ActionID != 0) {
          const isEmailValidate = notMendetoryEmailValidator(o.EmailID);
          if (isEmailValidate && item.isHallChecked) {
            this.setState({ isLoading: false });
            return toastError(
              `${isEmailValidate} in the staff section on dismantling days in ${item.SectionPageName}`
            );
          }
          array5.push({
            DismantlingStaffID: o.DismantlingStaffID,
            StaffBadgeCount: item.DismantlingDaysStaffBadgeCount,
            MainServiceID: item.ServiceID,
            PersonName: o.PersonName,
            EmailID: o.EmailID,
            MobileNumber: o.MobileNumber,
            Address: null,
            AllocatedDateIDs: null,
            IsHallManager: 0,
            ActionID: o.ActionID,
            DesignationID: o.DesignationID,
          });
        }
      }
      // if (item.SectionPageName == "Onsite Agency") {
      for (const o of item.hallPreSetupDaysList) {
        if (o.ActionID != 0 || !item.isHallChecked) {
          const isEmailValidate = notMendetoryEmailValidator(o.EmailID);
          if (isEmailValidate && item.isHallChecked) {
            this.setState({ isLoading: false });
            return toastError(
              `${isEmailValidate} in the hall manager on pre-setup days in ${item.SectionPageName}`
            );
          }
          array3.push({
            PreStaffID: o.PreSetupStaffID,
            StaffBadgeCount: item.PreSetupDaysStaffBadgeCount,
            MainServiceID: item.ServiceID,
            PersonName: o.PersonName,
            EmailID: o.EmailID,
            MobileNumber: o.MobileNumber,
            Address: null,
            AllocatedDateIDs: o.AllocatedDateIDs,
            IsHallManager: 1,
            ActionID: !item.isHallChecked ? 3 : o.ActionID,
            DesignationID: "",
          });
        }
      }

      for (const o of item.hallEventDaysList) {
        if (o.ActionID != 0 || !item.isHallChecked) {
          const isEmailValidate = notMendetoryEmailValidator(o.EmailID);
          if (isEmailValidate && item.isHallChecked) {
            this.setState({ isLoading: false });
            return toastError(
              `${isEmailValidate} in the hall manager on event days in ${item.SectionPageName}`
            );
          }
          array4.push({
            EventDayStaffID: o.EventDayStaffID,
            StaffBadgeCount: null,
            MainServiceID: item.ServiceID,
            PersonName: o.PersonName,
            EmailID: o.EmailID,
            MobileNumber: o.MobileNumber,
            Address: null,
            AllocatedDate: o.SelectedDates,
            IsHallManager: 1,
            ActionID: !item.isHallChecked ? 3 : o.ActionID,
            DesignationID: "",
          });
        }
      }


      for (const o of item.hallDismantlingDaysList) {
        if (o.ActionID != 0 || !item.isHallChecked) {
          const isEmailValidate = notMendetoryEmailValidator(o.EmailID);
          if (isEmailValidate) {
            this.setState({ isLoading: false });
            return toastError(
              `${isEmailValidate} in the hall manager on dismantling days in ${item.SectionPageName}`
            );
          }

          array5.push({
            DismantlingStaffID: o.DismantlingStaffID,
            StaffBadgeCount: item.DismantlingDaysStaffBadgeCount,
            MainServiceID: item.ServiceID,
            PersonName: o.PersonName,
            EmailID: o.EmailID,
            MobileNumber: o.MobileNumber,
            Address: null,
            AllocatedDateIDs: o.AllocatedDateIDs,
            IsHallManager: 1,
            ActionID: !item.isHallChecked ? 3 : o.ActionID,
            DesignationID: "",
          });
        }
      }

      item.hallPreSetupDaysList.length > 0 &&
        item.hallPreSetupDaysList.map((obj) => {
          if (obj.ActionID != 0) {
            obj.selectedHallZoneList.forEach((o) => {
              array6.push({
                MainServiceID: item.ServiceID,
                EmailID: obj.EmailID,
                HallID: o.HallID,
                ZoneID: o.ZoneID,
              });
            });
          }
        });

      item.hallEventDaysList.length > 0 &&
        item.hallEventDaysList.map((obj) => {
          if (obj.ActionID != 0) {
            obj.selectedHallZoneList.forEach((o) => {
              array7.push({
                MainServiceID: item.ServiceID,
                EmailID: obj.EmailID,
                HallID: o.HallID,
                ZoneID: o.ZoneID,
              });
            });
          }
        });

      item.hallDismantlingDaysList.length > 0 &&
        item.hallDismantlingDaysList.map((obj) => {
          if (obj.ActionID != 0) {
            obj.selectedHallZoneList.forEach((o) => {
              array8.push({
                MainServiceID: item.ServiceID,
                EmailID: obj.EmailID,
                HallID: o.HallID,
                ZoneID: o.ZoneID,
              });
            });
          }
        });
      // }

      for (const obj of item.DeliverablesServicesList) {
        if (obj.ActionID != 0 || !item.isHallChecked) {
          for (const o of obj.ComplianceRequirementsList) {
            array9.push({
              MainServiceID: item.ServiceID,
              DeliverablesID: obj.MainServiceDeliverablesID,
              Specification: o.Specification,
              LocationID: o.LocationID != "Other" ? o.LocationID : null,
              LocationName: o.LocationName,
              Quantity: o.Quantity,
              TimeLine: o.TimeLine
                ? moment(o.TimeLine).format("YYYY-MM-DD HH:mm")
                : null,
            });
          }
        }
      }

      array10.push({
        MainServiceID: item.ServiceID,
        StaffBadgeCount: item.PreSetupDaysStaffBadgeCount,
      });

      array11.push({
        MainServiceID: item.ServiceID,
        StaffBadgeCount: item.DismantlingDaysStaffBadgeCount,
      });

    }

    const servicesids = workOrderServices.map((item) => item.value).join(",");
    const formateStartDate = StartDate
      ? moment(StartDate).format("YYYY-MM-DD")
      : null;
    const formateEndDate = EndDate
      ? moment(EndDate).format("YYYY-MM-DD")
      : null;

    try {
      this.setState({ isLoading: true });
      this.props
        .insertUpdateVendorWorkOrder_action(
          replicate ? null : WorkOrderID,
          ExhibitionID,
          vendorId,
          WorkOrderNumber,
          servicesids,
          PersonName,
          EmailID,
          MobileNumber,
          formateStartDate,
          formateEndDate,
          array1,
          array2,
          array3,
          array4,
          array5,
          array6,
          array7,
          array8,
          array9,
          array10,
          array11,
          [...documentList, ...deleteDocumentList],
          isVendor ? 0 : IsSubmitted,
          array12,
          IsUpdate,
          formType,
          array13
        )
        .then((data) => {
          if (data.error != 1) {
            if (isHallManager) {
              toastSuccess("Scope of work update successfully!");
            } else {
              if (IsCreateHallManager) {
                this.createhallManagerAccess();
              } else {
                toastSuccess(
                  `Scope of work save as draft successfully!`
                );
                setTimeout(() => {
                  (JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7 || JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 17)
                    ? this.props.navigate("/VendorModule")
                    : this.props.navigate("/vendorWorkOrderList");
                }, 2000);
              }
            }
          } else {
            toastError(data.msg);
          }
          this.setState({ isLoading: false });
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
        });
    } catch {
      toastError("Something went wrong!");
      this.setState({ isLoading: false });
    } finally {
      // this.setState({ isLoading: false })
    }
  }

  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }

  convertToShifts(data) {
    return Object.values(
      data.reduce((acc, curr) => {
        const formattedDate = moment(curr.AllocatedDate).format("DD MMM YYYY");

        if (!acc[formattedDate]) {
          acc[formattedDate] = { date: formattedDate, shift: [] };
        }

        acc[formattedDate].shift.push({
          time: `${curr.FromTime.replace(" ", "")} - ${curr.ToTime.replace(
            " ",
            ""
          )}`,
          ExhibitionDaysID: curr.ExhibitionDaysID,
        });

        return acc;
      }, {})
    );
  }

  // get fill List dropdown
  async getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
    const { hallId } = this.state;
    this.setState({ isLoading: true })

    try {
      const data = await this.props.fill_action(
        actionID,
        exhibitionID,
        moduleID,
        keyValue,
        value
      );

      if (data.error === 1) {
        toastError(data.msg);
        return [];
      }

      if (actionID === exhibitionId) {
        this.setState({ exhibitionList: data.data });
      }

      if (actionID === AccesibleActionId) {
        this.setState({ AccesibleList: data.data });
      }

      if (actionID === DeliverablesPricingActionId) {
        this.setState({ DeliverablesPricingList: data.data });
      }

      if (actionID === vendorListId || actionID === scopeOfWorkVendorActionId) {
        this.setState({ vendorList: data.data });
      }

      if (
        actionID == scopeOfWorkVendorServicesActionId ||
        actionID == serviceTypeId
      ) {
        this.setState({ WorkOrderServiceList: data.data });
        return data.data;
      }

      if (actionID === workOrderDesignationActionId) {
        this.setState({ workOrderDesignationList: data.data });
      }

      if (actionID === hallMasterListActionId) {
        this.setState({
          hallList: [
            ...data.data,
            {
              HallName: "Other",
              HallId: "Other",
            },
          ],
        });
      }

      if (actionID === stallActionId) {
        this.setState({ allHallStallList: data.data });
      }

      if (actionID === exhibitorBadgeDaysActionId) {
        this.setState({ EventDaysShiftList: data.data });
      }

      if (actionID === vendorStaffSectionShiftActionId && keyValue == "P") {
        const array = this.convertToShifts(data.data);
        // console.log("array---->", array)
        this.setState({ PreSetupDaysShiftList: array });
      }

      if (actionID === vendorStaffSectionShiftActionId && keyValue == "D") {
        const array = this.convertToShifts(data.data);
        this.setState({ hallDismantlingDaysList: array });
      }

      if (actionID === ServiceSubTypeActionId) {
        const array = data.data.map((item, index) => ({
          Id: 1,
          ServiceSubType: item.Name,
          ServiceSubTypeID: item.ServiceGroupID,
          VendorOrganizerPriceInINR: "",
          VendorOrganizerPriceInUSD: "",
          VendorExhibitorPriceInINR: "",
          VendorExhibitorPriceInUSD: "",
        }));

        return array;
      }

      if (actionID === DeliverablesServiceActionId) {
        return [...data.data];
      }

      if (actionID === 124) {
        return [...data.data];
      }

      if (actionID === scopeOfWorkHallZoneListctionId) {
        const HallZoneList = Object.values(
          data.data.reduce((acc, { HallId, HallName, Zone, ZoneID }) => {
            if (!acc[HallId]) {
              acc[HallId] = {
                HallId,
                HallName,
                All: true,
                Specific: false,
                isHallChecked: false,
                zonelist: [],
              };
            }
            acc[HallId].zonelist.push({ Zone, ZoneID, isZoneChecked: true });
            return acc;
          }, {})
        );
        setTimeout(() => {
          this.setState({
            HallZoneList: HallZoneList,
          });
        }, 100);
      }

      return [];
    } catch (e) {
      console.error(e);
      return [];
    } finally {
      // console.log("this.props", this.props)
      if (this.props.location.state && this.props.location.state.add) {
        this.setState({ isLoading: false });
      }
    }
  }

  handleClear() {
    this.setState({
      renderServiceTypeList: "",
      Billing: "",
      Approval_Rights: "",
      companyName: "",
      password: "",
      countryName: "",
      stateName: "",
      cityName: "",
      pinCode: "",
      address1: "",
      address2: "",
      title_inchargeFirstName: "",
      inchargeFirstName: "",
      lastNamePersonIncharge: "",
      designation: "",
      registerMobileNo: "",
      registerAlternateMobileNo: "",
      registerTelephoneNo: "",
      registerTelephoneNo1: "",
      registerTelefaxNo: "",
      primaryEmailId: "",
      secondaryEmailId: "",
      website: "",
      title_name_Of_CEO_MD_President_Owner: "",
      nameOfOwner: "",
      lastName: "",
      ownerMobileNo: "",
      ownerEmailId: "",
      compInfoNameOnPanCard: "",
      compInfoPanNo: "",
      compInfoTAN: "",
      compInfoGstNo: "",
      compInfoRegistrationNo: "",
      compInfoIecCode: "",
      bankDtlAccountName: "",
      bankDtlAccountNo: "",
      bankDtlAccountType: "",
      bankDtlAccountTypeOthers: "",
      bankDtlBankName: "",
      bankDtlBranchName: "",
      bankDtlIfscCode: "",
      PreMobileNo: "",
      PreAlternateMobileNo: "",
      PreTelephoneNo: "",
      PreTelephoneNo1: "",
      preMobile: "",
      staffSectionTableName: "",
    });
  }

  cancle() {
    window.history.back();
  }

  // onChangeWorkOrderService = async (e) => {
  //   const { SectionPageList, dummySectionPageList, deletedDeliverablesServices } = this.state;

  //   const selectedItems = e.map(item => ({
  //     label: item.label,
  //     code: item.value
  //   }));

  //   const serviceId = selectedItems[selectedItems.length - 1]?.code || null;

  //   // Fetch lists
  //   const DeliverablesServiceArray = await this.getFillList(
  //     DeliverablesServiceActionId,
  //     sessionStorage.getItem("sessionExhibitionID"),
  //     serviceId, '', '', ''
  //   );

  //   const ServiceSubTypeArray = await this.getFillList(
  //     ServiceSubTypeActionId,
  //     sessionStorage.getItem("sessionExhibitionID"),
  //     serviceId, '', '', ''
  //   );

  //   console.log("DeliverablesServiceArray--->",DeliverablesServiceArray)

  //   // 🧩 Find removed services (those no longer selected)
  //   const removedServices = SectionPageList.filter(
  //     oldItem => !selectedItems.some(sel => sel.code === oldItem.SectionPageNameId)
  //   );

  //   // 🗑️ Prepare deletedDeliverablesServices array with ActionID:3
  //   const deletedArray = removedServices.flatMap(item =>
  //     item.DeliverablesServicesList
  //       .filter(d => d.WorkOrderDeliverablesID)
  //       .map(d => ({
  //         ...d,
  //         ActionID: 3,
  //       }))
  //   );

  //   // 🧹 Remove deselected services from SectionPageList
  //   let updatedSectionPageList = SectionPageList.filter(item =>
  //     selectedItems.some(sel => sel.code === item.SectionPageNameId)
  //   );

  //   // ➕ Add any new selected services
  //   selectedItems.forEach(({ label, code }) => {
  //     const exists = updatedSectionPageList.some(
  //       item => item.SectionPageNameId === code
  //     );
  //     if (!exists) {
  //       updatedSectionPageList.push({
  //         ...dummySectionPageList,
  //         DeliverablesServicesList: [],
  //         SectionPageName: label,
  //         SectionPageNameId: code,
  //         ServiceID: serviceId,
  //         PreSetupDaysStaffBadgeCount: '',
  //         DismantlingDaysStaffBadgeCount: '',
  //         PlanSubmissionDate: '',
  //         staffPreSetupDaysList: [],
  //         staffEventDaysList: [],
  //         staffDismantlingDaysList: [],
  //         hallPreSetupDaysList: [],
  //         hallEventDaysList: [],
  //         hallDismantlingDaysList: [],
  //         isHallChecked: false
  //       });
  //     }
  //   });

  //   // 🧩 Update DeliverablesServiceFillListArray (avoid duplicates)
  //   DeliverablesServiceArray.forEach(item => {
  //     const exists = this.state.DeliverablesServiceFillListArray.some(
  //       existing => existing.MainServiceDeliverablesID === item.MainServiceDeliverablesID
  //     );
  //     if (!exists) {
  //       this.state.DeliverablesServiceFillListArray.push(item);
  //     }
  //   });

  //   // 🧠 Merge new deleted items with existing ones
  //   const updatedDeletedDeliverables = [
  //     ...deletedDeliverablesServices,
  //     ...deletedArray
  //   ];

  //   console.log("updatedDeletedDeliverables--------------------->", updatedDeletedDeliverables);

  //   this.setState({
  //     sectionPage: selectedItems[0]?.label || "",
  //     SectionPageList: updatedSectionPageList,
  //     workOrderServices: e,
  //     ServiceSubTypeFillListArray: ServiceSubTypeArray,
  //     workOrderServicesErr: '',
  //     deletedDeliverablesServices: updatedDeletedDeliverables
  //   }, () => {
  //     console.log("updated SectionPageList--->", this.state.SectionPageList);
  //     console.log("deletedDeliverablesServices--->", this.state.deletedDeliverablesServices);
  //   });
  // };

  onChangeWorkOrderService = async (e) => {
    const {
      SectionPageList,
      dummySectionPageList,
      deletedDeliverablesServices,
      hallDismantlingDaysList,
      EventDaysShiftList,
      PreSetupDaysShiftList,
    } = this.state;

    const selectedItems = e.map((item) => ({
      label: item.label,
      code: item.value,
    }));

    // Identify removed services
    const removedServices = SectionPageList.filter(
      (oldItem) =>
        !selectedItems.some((sel) => sel.code === oldItem.SectionPageNameId)
    );

    const deletedArray = removedServices.flatMap((item) =>
      item.DeliverablesServicesList.filter(
        (d) => d.WorkOrderDeliverablesID
      ).map((d) => ({ ...d, ActionID: 3 }))
    );

    let updatedSectionPageList = SectionPageList.filter((item) =>
      selectedItems.some((sel) => sel.code === item.SectionPageNameId)
    );

    // Add newly selected services (and fetch their deliverables individually)
    for (const { label, code } of selectedItems) {
      const exists = updatedSectionPageList.some(
        (item) => item.SectionPageNameId === code
      );

      if (!exists) {
        // Fetch deliverables for only this service
        const DeliverablesServiceArray = await this.getFillList(
          DeliverablesServiceActionId,
          sessionStorage.getItem("sessionExhibitionID"),
          code,
          "",
          "",
          ""
        );
        DeliverablesServiceArray.map((item) =>
          this.state.DeliverablesServiceFillListArray.push(item)
        );

        updatedSectionPageList.push({
          ...dummySectionPageList,
          DeliverablesServicesList: DeliverablesServiceArray.map(
            (d, index) => ({
              Id: index + 1,
              ComplianceRequirementsList: [],
              Deadline: "",
              ScopeOfWork: null,
              DeliverablesService: d.MainServiceDeliverablesName,
              LogisticsResponsibilities: "",
              Manpower: "",
              MainServiceDeliverablesID: d.MainServiceDeliverablesID,
              MainServiceDeliverablesName: d.MainServiceDeliverablesName,
              DropdownList: DeliverablesServiceArray,
              AllDropdownList: DeliverablesServiceArray,
              DeliverablesServicesStartDate: "",
              DeliverablesServicesEndDate: "",
              VendorExhibitorPriceInUSD: "",
              VendorExhibitorPriceInINR: "",
              VendorOrganizerPriceInUSD: "",
              VendorOrganizerPriceInINR: "",
              IsStockAvailable: true,
              Quantity: "",
              WorkOrderDeliverablesID: null,
              ActionID: 1,
              MainServiceID: code,
              AccessibleID: 1,
              DeliverablesPricingID: "",
              Instructions: "",
              DocumentsList: [],
              DocumentRefNo: index + 1
            })
          ),
          SectionPageName: label,
          SectionPageNameId: code,
          ServiceID: code,
          PreSetupDaysStaffBadgeCount: "",
          DismantlingDaysStaffBadgeCount: "",
          PlanSubmissionDate: "",
          staffPreSetupDaysList: [
            {
              Id: 1,
              PersonName: "",
              EmailID: "",
              MobileNumber: "",
              Address: "",
              IsHallManager: 0,
              AllocatedHallsIds: "",
              AllocatedHallsNames: "",
              AllocatedDateIDs: "",
              AllocatedShiftIds: "",
              AllocatedDateNames: "",
              HallZoneList: this.state.HallZoneList,
              ShiftList: PreSetupDaysShiftList,
              selectedHallZoneList: [],
              SelectedShifts: [],
              MainServiceID: code,
              ActionID: 1,
              PreSetupStaffID: null,
              DesignationID: "",
              DesignationList: this.state.workOrderDesignationList,
            },
          ],
          staffEventDaysList: [
            {
              Id: 1,
              PersonName: "",
              EmailID: "",
              MobileNumber: "",
              Address: "",
              IsHallManager: 0,
              AllocatedHallsIds: "",
              AllocatedHallsNames: "",
              AllocatedDateIDs: "",
              AllocatedShiftIds: "",
              AllocatedDateNames: "",
              HallZoneList: this.state.HallZoneList,
              ShiftList: EventDaysShiftList,
              selectedHallZoneList: [],
              SelectedShifts: [],
              MainServiceID: code,
              ActionID: 1,
              EventDayStaffID: null,
              DesignationID: "",
              DesignationList: this.state.workOrderDesignationList,
            },
          ],
          staffDismantlingDaysList: [
            {
              Id: 1,
              PersonName: "",
              EmailID: "",
              MobileNumber: "",
              Address: "",
              IsHallManager: 0,
              AllocatedHallsIds: "",
              AllocatedHallsNames: "",
              AllocatedDateIDs: "",
              AllocatedShiftIds: "",
              AllocatedDateNames: "",
              HallZoneList: this.state.HallZoneList,
              ShiftList: hallDismantlingDaysList,
              selectedHallZoneList: [],
              SelectedShifts: [],
              MainServiceID: code,
              ActionID: 1,
              DismantlingStaffID: null,
              DesignationID: "",
              DesignationList: this.state.workOrderDesignationList,
            },
          ],
          hallPreSetupDaysList: [
            {
              Id: 1,
              PersonName: "",
              EmailID: "",
              MobileNumber: "",
              Address: "",
              IsHallManager: 1,
              AllocatedHallsIds: "",
              AllocatedHallsNames: "",
              AllocatedDateIDs: "",
              AllocatedShiftIds: "",
              AllocatedDateNames: "",
              SelectedHalls: "",
              HallZoneList: this.state.HallZoneList,
              ShiftList: PreSetupDaysShiftList,
              selectedHallZoneList: [],
              SelectedShifts: [],
              MainServiceID: code,
              ActionID: 1,
              PreSetupStaffID: null,
              DesignationID: "",
              DesignationList: this.state.workOrderDesignationList,
            },
          ],
          hallEventDaysList: [
            {
              Id: 1,
              PersonName: "",
              EmailID: "",
              MobileNumber: "",
              Address: "",
              IsHallManager: 1,
              AllocatedHallsIds: "",
              AllocatedHallsNames: "",
              AllocatedDateIDs: "",
              AllocatedShiftIds: "",
              AllocatedDateNames: "",
              SelectedHalls: "",
              SelectedDates: "",
              HallZoneList: this.state.HallZoneList,
              ShiftList: EventDaysShiftList,
              selectedHallZoneList: [],
              SelectedShifts: [],
              MainServiceID: code,
              ActionID: 1,
              EventDayStaffID: null,
              DesignationID: "",
              DesignationList: this.state.workOrderDesignationList,
            },
          ],
          hallDismantlingDaysList: [
            {
              Id: 1,
              PersonName: "",
              EmailID: "",
              MobileNumber: "",
              Address: "",
              IsHallManager: 1,
              AllocatedHallsIds: "",
              AllocatedHallsNames: "",
              AllocatedDateIDs: "",
              AllocatedShiftIds: "",
              AllocatedDateNames: "",
              SelectedHalls: "",
              HallZoneList: this.state.HallZoneList,
              ShiftList: hallDismantlingDaysList,
              selectedHallZoneList: [],
              SelectedShifts: [],
              MainServiceID: code,
              ActionID: 1,
              DismantlingStaffID: null,
              DesignationID: "",
              DesignationList: this.state.workOrderDesignationList,
            },
          ],
          isHallChecked: false,
        });
      }
    }

    const updatedDeletedDeliverables = [
      ...deletedDeliverablesServices,
      ...deletedArray,
    ];

    this.setState(
      {
        sectionPage: selectedItems[0]?.label || "",
        SectionPageList: updatedSectionPageList,
        workOrderServices: e,
        workOrderServicesErr: "",
        deletedDeliverablesServices: updatedDeletedDeliverables,
      },
      () => {
        console.log("Updated SectionPageList:", this.state.SectionPageList);
        console.log(
          "Deleted Deliverables:",
          this.state.deletedDeliverablesServices
        );
      }
    );
  };

  addMoreSectionPageList(sectionPageName, sectionName, feild) {
    const {
      DeliverablesServiceFillListArray,
      hallDismantlingDaysList,
      EventDaysShiftList,
      PreSetupDaysShiftList,
      DeliveryServicesIndex,
    } = this.state;

    this.setState(
      (prevState) => {
        const updatedList = prevState.SectionPageList.map((item) => {
          if (item.SectionPageName === sectionPageName) {
            let updatedItem = { ...item };

            // helper to check if any row is blank
            const hasBlankRow = (list, requiredFields) =>
              list.some((row) =>
                requiredFields.some(
                  (field) => !row[field] || row[field].toString().trim() === ""
                )
              );

            // ---------------- DeliverablesServices ----------------
            if (sectionName === "DeliverablesServices") {
              if (feild === "ComplianceRequirementsList") {
                const target =
                  updatedItem.DeliverablesServicesList[DeliveryServicesIndex];
                if (
                  target &&
                  hasBlankRow(target.ComplianceRequirementsList || [], [
                    "Specification",
                    "LocationID",
                    "Quantity",
                    "TimeLine",
                  ])
                ) {
                  toastError("Please firstly fill all feilds");
                  return updatedItem;
                }

                updatedItem.DeliverablesServicesList =
                  updatedItem.DeliverablesServicesList.map((obj, i) => {
                    if (i === DeliveryServicesIndex) {
                      return {
                        ...obj,
                        ComplianceRequirementsList: [
                          ...(obj.ComplianceRequirementsList || []),
                          {
                            SrNo:
                              (obj.ComplianceRequirementsList || []).length + 1,
                            Specification: "",
                            LocationID: "",
                            LocationName: "",
                            Quantity: "",
                            TimeLine: "",
                          },
                        ],
                      };
                    }
                    return obj;
                  });
              } else {
                console.log(
                  "DeliverablesServiceFillListArray---------------->",
                  DeliverablesServiceFillListArray
                );
                const array = DeliverablesServiceFillListArray.filter(
                  (obj) => obj.MainServiceID == item.ServiceID
                );
                const filterArray = updatedItem.DeliverablesServicesList.filter(
                  (obj) => obj.MainServiceDeliverablesID
                );
                const excludeIds = filterArray.map((item) =>
                  String(item.MainServiceDeliverablesID)
                );
                const finalFilterArray = array.filter(
                  (item) =>
                    !excludeIds.includes(String(item.MainServiceDeliverablesID))
                );

                const nextId =
                  (updatedItem.DeliverablesServicesList?.length > 0
                    ? Math.max(
                      ...updatedItem.DeliverablesServicesList.map((x) => x.Id)
                    )
                    : 0) + 1;

                updatedItem.DeliverablesServicesList = [
                  ...updatedItem.DeliverablesServicesList,
                  {
                    Id: updatedItem.DeliverablesServicesList.length + 1,
                    ComplianceRequirementsList: [],
                    Deadline: "",
                    ScopeOfWork: null,
                    DeliverablesService: "",
                    LogisticsResponsibilities: "",
                    Manpower: "",
                    MainServiceDeliverablesID: null,
                    MainServiceDeliverablesName: "",
                    DropdownList: finalFilterArray || [],
                    AllDropdownList: finalFilterArray || [],
                    DeliverablesServicesStartDate: "",
                    DeliverablesServicesEndDate: "",
                    VendorExhibitorPriceInUSD: "",
                    VendorExhibitorPriceInINR: "",
                    VendorOrganizerPriceInUSD: "",
                    VendorOrganizerPriceInINR: "",
                    IsStockAvailable: true,
                    Quantity: "",
                    WorkOrderDeliverablesID: null,
                    ActionID: 1,
                    MainServiceID: item.ServiceID,
                    AccessibleID: "",
                    DeliverablesPricingID: "",
                    Instructions: "",
                    DocumentsList: [],
                    DocumentRefNo: updatedItem.DeliverablesServicesList.length + 1
                  },
                ];
              }
            }

            // ---------------- OrganizerResponsibilities ----------------
            else if (sectionName === "OrganizerResponsibilities") {
              if (
                hasBlankRow(updatedItem.OrganizerResponsibilitiesList, [
                  "Responsibilities",
                ])
              ) {
                toastError("Please firstly fill all feilds");
                return updatedItem;
              }

              updatedItem.OrganizerResponsibilitiesList = [
                ...updatedItem.OrganizerResponsibilitiesList,
                {
                  Id: updatedItem.OrganizerResponsibilitiesList.length + 1,
                  Responsibilities: "",
                  MainServiceID: item.ServiceID,
                },
              ];
            }

            // ---------------- staffPreSetupDays ----------------
            else if (sectionName === "staffPreSetupDays") {
              if (
                hasBlankRow(updatedItem.staffPreSetupDaysList, [
                  "PersonName",
                  "EmailID",
                  "MobileNumber",
                  "DesignationID",
                ])
              ) {
                toastError("Please firstly fill all feilds");
                return updatedItem;
              }

              updatedItem.staffPreSetupDaysList = [
                ...updatedItem.staffPreSetupDaysList,
                {
                  Id: updatedItem.staffPreSetupDaysList.length + 1,
                  PersonName: "",
                  EmailID: "",
                  MobileNumber: "",
                  Address: "",
                  IsHallManager: 0,
                  AllocatedHallsIds: "",
                  AllocatedHallsNames: "",
                  AllocatedDateIDs: "",
                  AllocatedShiftIds: "",
                  AllocatedDateNames: "",
                  HallZoneList: this.state.HallZoneList,
                  ShiftList: PreSetupDaysShiftList,
                  selectedHallZoneList: [],
                  SelectedShifts: [],
                  MainServiceID: item.ServiceID,
                  ActionID: 1,
                  PreSetupStaffID: null,
                  DesignationID: "",
                  DesignationList: this.state.workOrderDesignationList,
                },
              ];
            }

            // ---------------- staffEventDays ----------------
            else if (sectionName === "staffEventDays") {
              if (
                hasBlankRow(updatedItem.staffEventDaysList, [
                  "PersonName",
                  "EmailID",
                  "MobileNumber",
                  "DesignationID",
                ])
              ) {
                toastError("Please firstly fill all feilds");
                return updatedItem;
              }

              updatedItem.staffEventDaysList = [
                ...updatedItem.staffEventDaysList,
                {
                  Id: updatedItem.staffEventDaysList.length + 1,
                  PersonName: "",
                  EmailID: "",
                  MobileNumber: "",
                  Address: "",
                  IsHallManager: 0,
                  AllocatedHallsIds: "",
                  AllocatedHallsNames: "",
                  AllocatedDateIDs: "",
                  AllocatedShiftIds: "",
                  AllocatedDateNames: "",
                  HallZoneList: this.state.HallZoneList,
                  ShiftList: EventDaysShiftList,
                  selectedHallZoneList: [],
                  SelectedShifts: [],
                  MainServiceID: item.ServiceID,
                  ActionID: 1,
                  EventDayStaffID: null,
                  DesignationID: "",
                  DesignationList: this.state.workOrderDesignationList,
                },
              ];
            }

            // ---------------- staffDismantlingDays ----------------
            else if (sectionName === "staffDismantlingDays") {
              if (
                hasBlankRow(updatedItem.staffDismantlingDaysList, [
                  "PersonName",
                  "EmailID",
                  "MobileNumber",
                  "DesignationID",
                ])
              ) {
                toastError("Please firstly fill all feilds");
                return updatedItem;
              }

              updatedItem.staffDismantlingDaysList = [
                ...updatedItem.staffDismantlingDaysList,
                {
                  Id: updatedItem.staffDismantlingDaysList.length + 1,
                  PersonName: "",
                  EmailID: "",
                  MobileNumber: "",
                  Address: "",
                  IsHallManager: 0,
                  AllocatedHallsIds: "",
                  AllocatedHallsNames: "",
                  AllocatedDateIDs: "",
                  AllocatedShiftIds: "",
                  AllocatedDateNames: "",
                  HallZoneList: this.state.HallZoneList,
                  ShiftList: hallDismantlingDaysList,
                  selectedHallZoneList: [],
                  SelectedShifts: [],
                  MainServiceID: item.ServiceID,
                  ActionID: 1,
                  DismantlingStaffID: null,
                  DesignationID: "",
                  DesignationList: this.state.workOrderDesignationList,
                },
              ];
            }

            // ---------------- hallPreSetupDays ----------------
            else if (sectionName === "hallPreSetupDays") {
              if (
                hasBlankRow(updatedItem.hallPreSetupDaysList, [
                  "PersonName",
                  "EmailID",
                  "MobileNumber",
                  "SelectedHalls",
                  "AllocatedDateIDs",
                ])
              ) {
                toastError("Please firstly fill all feilds");
                return updatedItem;
              }

              updatedItem.hallPreSetupDaysList = [
                ...updatedItem.hallPreSetupDaysList,
                {
                  Id: updatedItem.hallPreSetupDaysList.length + 1,
                  PersonName: "",
                  EmailID: "",
                  MobileNumber: "",
                  Address: "",
                  IsHallManager: 1,
                  AllocatedHallsIds: "",
                  AllocatedHallsNames: "",
                  AllocatedDateIDs: "",
                  AllocatedShiftIds: "",
                  AllocatedDateNames: "",
                  SelectedHalls: "",
                  HallZoneList: this.state.HallZoneList,
                  ShiftList: PreSetupDaysShiftList,
                  selectedHallZoneList: [],
                  SelectedShifts: [],
                  MainServiceID: item.ServiceID,
                  ActionID: 1,
                  PreSetupStaffID: null,
                  DesignationID: "",
                  DesignationList: this.state.workOrderDesignationList,
                },
              ];
            }

            // ---------------- hallEventDays ----------------
            else if (sectionName === "hallEventDays") {
              if (
                hasBlankRow(updatedItem.hallEventDaysList, [
                  "PersonName",
                  "EmailID",
                  "MobileNumber",
                  "SelectedHalls",
                  "SelectedDates",
                ])
              ) {
                toastError("Please firstly fill all feilds");
                return updatedItem;
              }

              updatedItem.hallEventDaysList = [
                ...updatedItem.hallEventDaysList,
                {
                  Id: updatedItem.hallEventDaysList.length + 1,
                  PersonName: "",
                  EmailID: "",
                  MobileNumber: "",
                  Address: "",
                  IsHallManager: 1,
                  AllocatedHallsIds: "",
                  AllocatedHallsNames: "",
                  AllocatedDateIDs: "",
                  AllocatedShiftIds: "",
                  AllocatedDateNames: "",
                  SelectedHalls: "",
                  SelectedDates: "",
                  HallZoneList: this.state.HallZoneList,
                  ShiftList: EventDaysShiftList,
                  selectedHallZoneList: [],
                  SelectedShifts: [],
                  MainServiceID: item.ServiceID,
                  ActionID: 1,
                  EventDayStaffID: null,
                  DesignationID: "",
                  DesignationList: this.state.workOrderDesignationList,
                },
              ];
            }

            // ---------------- hallDismantlingDays ----------------
            else if (sectionName === "hallDismantlingDays") {
              if (
                hasBlankRow(updatedItem.hallDismantlingDaysList, [
                  "PersonName",
                  "EmailID",
                  "MobileNumber",
                  "SelectedHalls",
                  "AllocatedDateIDs",
                ])
              ) {
                toastError("Please firstly fill all feilds");
                return updatedItem;
              }

              updatedItem.hallDismantlingDaysList = [
                ...updatedItem.hallDismantlingDaysList,
                {
                  Id: updatedItem.hallDismantlingDaysList.length + 1,
                  PersonName: "",
                  EmailID: "",
                  MobileNumber: "",
                  Address: "",
                  IsHallManager: 1,
                  AllocatedHallsIds: "",
                  AllocatedHallsNames: "",
                  AllocatedDateIDs: "",
                  AllocatedShiftIds: "",
                  AllocatedDateNames: "",
                  SelectedHalls: "",
                  HallZoneList: this.state.HallZoneList,
                  ShiftList: hallDismantlingDaysList,
                  selectedHallZoneList: [],
                  SelectedShifts: [],
                  MainServiceID: item.ServiceID,
                  ActionID: 1,
                  DismantlingStaffID: null,
                  DesignationID: "",
                  DesignationList: this.state.workOrderDesignationList,
                },
              ];
            }

            return updatedItem;
          }
          return item;
        });

        return { SectionPageList: updatedList };
      },
      () => {
        console.log("sectionPageList--->", this.state.SectionPageList);
      }
    );
  }

  handleClearSectionPageList(
    sectionPageName,
    sectionName,
    rowIndex,
    feildName,
    compIndex
  ) {
    this.setState((prevState) => {
      const updatedList = prevState.SectionPageList.map((item) => {
        if (item.SectionPageName === sectionPageName) {
          let updatedItem = { ...item };

          if (sectionName === "DeliverablesServices") {
            updatedItem.DeliverablesServicesList =
              updatedItem.DeliverablesServicesList.map((obj, i) => {
                if (i === rowIndex) {
                  return {
                    ...obj,
                    ComplianceRequirementsList:
                      obj.ComplianceRequirementsList.map((comp, idx) =>
                        idx === compIndex
                          ? {
                            ...comp,
                            Specification: "",
                            LocationID: "",
                            Quantity: "",
                            TimeLine: "",
                          } // clear just this field
                          : comp
                      ),
                  };
                }
                return obj;
              });
          } else if (sectionName === "OrganizerResponsibilities") {
            updatedItem.OrganizerResponsibilitiesList =
              updatedItem.OrganizerResponsibilitiesList.map((row, idx) =>
                idx === rowIndex ? { ...row, Responsibilities: "" } : row
              );
          } else if (sectionName === "staffPreSetupDaysList") {
            updatedItem.staffPreSetupDaysList =
              updatedItem.staffPreSetupDaysList.map((row, idx) =>
                idx === rowIndex
                  ? {
                    ...row,
                    PersonName: "",
                    EmailID: "",
                    MobileNumber: "",
                    DesignationID: "",
                    Password: null,
                  }
                  : row
              );
          } else if (sectionName === "staffEventDaysList") {
            updatedItem.staffEventDaysList = updatedItem.staffEventDaysList.map(
              (row, idx) =>
                idx === rowIndex
                  ? {
                    ...row,
                    PersonName: "",
                    EmailID: "",
                    MobileNumber: "",
                    DesignationID: "",
                    Password: null,
                  }
                  : row
            );
          } else if (sectionName === "staffDismantlingDaysList") {
            updatedItem.staffDismantlingDaysList =
              updatedItem.staffDismantlingDaysList.map((row, idx) =>
                idx === rowIndex
                  ? {
                    ...row,
                    PersonName: "",
                    EmailID: "",
                    MobileNumber: "",
                    DesignationID: "",
                    Password: null,
                  }
                  : row
              );
          } else if (sectionName === "hallPreSetupDaysList") {
            updatedItem.hallPreSetupDaysList =
              updatedItem.hallPreSetupDaysList.map((row, idx) =>
                idx === rowIndex
                  ? {
                    ...row,
                    PersonName: "",
                    EmailID: "",
                    MobileNumber: "",
                    DesignationID: "",
                    Password: null,
                    SelectedHalls: "",
                    SelectedShifts: [],

                    // ✅ Reset HallZoneList (all unchecked)
                    HallZoneList: row.HallZoneList.map((h) => ({
                      ...h,
                      isHallChecked: false,
                      All: true,
                      Specific: false,
                    })),

                    // ✅ Reset ShiftList (all unchecked)
                    ShiftList: row.ShiftList.map((d) => ({
                      ...d,
                      isDateCheck: false,
                      shift: d.shift.map((s) => ({
                        ...s,
                        isShiftCheck: false,
                      })),
                    })),
                  }
                  : row
              );
          } else if (sectionName === "hallEventDaysList") {
            updatedItem.hallEventDaysList = updatedItem.hallEventDaysList.map(
              (row, idx) =>
                idx === rowIndex
                  ? {
                    ...row,
                    PersonName: "",
                    EmailID: "",
                    MobileNumber: "",
                    DesignationID: "",
                    Password: null,
                    SelectedHalls: "",
                    SelectedShifts: [],
                    SelectedDates: "",

                    // ✅ Reset HallZoneList (all unchecked)
                    HallZoneList: row.HallZoneList.map((h) => ({
                      ...h,
                      isHallChecked: false,
                      All: true,
                      Specific: false,
                    })),

                    // ✅ Reset ShiftList (all unchecked)
                    ShiftList: row.ShiftList.map((d) => ({
                      ...d,
                      isDateCheck: false,
                    })),
                  }
                  : row
            );
          } else if (sectionName === "hallDismantlingDaysList") {
            updatedItem.hallDismantlingDaysList =
              updatedItem.hallDismantlingDaysList.map((row, idx) =>
                idx === rowIndex
                  ? {
                    ...row,
                    PersonName: "",
                    EmailID: "",
                    MobileNumber: "",
                    DesignationID: "",
                    Password: null,
                    SelectedHalls: "",
                    SelectedShifts: [],

                    // ✅ Reset HallZoneList (all unchecked)
                    HallZoneList: row.HallZoneList.map((h) => ({
                      ...h,
                      isHallChecked: false,
                      All: true,
                      Specific: false,
                    })),

                    // ✅ Reset ShiftList (all unchecked)
                    ShiftList: row.ShiftList.map((d) => ({
                      ...d,
                      isDateCheck: false,
                      shift: d.shift.map((s) => ({
                        ...s,
                        isShiftCheck: false,
                      })),
                    })),
                  }
                  : row
              );
          }

          return updatedItem;
        }
        return item;
      });

      return { SectionPageList: updatedList };
    });
  }

  handleRemoveSectionPageList(
    sectionPageName,
    sectionName,
    rowIndex,
    field,
    compIndex
  ) {
    this.setState((prevState) => {
      const updatedList = prevState.SectionPageList.map((item) => {
        if (item.SectionPageName === sectionPageName) {
          let updatedItem = { ...item };

          if (sectionName === "DeliverablesServices") {
            if (field == "ComplianceRequirementsList") {
              updatedItem.DeliverablesServicesList =
                updatedItem.DeliverablesServicesList.map((obj, i) => {
                  if (i === rowIndex) {
                    return {
                      ...obj,
                      ComplianceRequirementsList:
                        obj.ComplianceRequirementsList.filter(
                          (_, idx) => idx !== compIndex
                        ),
                    };
                  }
                  return obj;
                });
            } else {
              const deletedDeliverablesServices =
                updatedItem.DeliverablesServicesList.filter(
                  (d, idx) => idx == rowIndex && d.WorkOrderDeliverablesID
                );
              updatedItem.DeliverablesServicesList =
                updatedItem.DeliverablesServicesList.filter(
                  (_, idx) => idx !== rowIndex
                );
              this.setState((prevState) => ({
                deletedDeliverablesServices: [
                  ...prevState.deletedDeliverablesServices,
                  ...deletedDeliverablesServices.map((obj) => ({
                    ...obj,
                    ActionID: 3,
                  })),
                ],
              }));
            }
          } else if (sectionName === "OrganizerResponsibilities") {
            updatedItem.OrganizerResponsibilitiesList =
              updatedItem.OrganizerResponsibilitiesList.filter(
                (_, idx) => idx !== rowIndex
              );
          } else if (sectionName === "staffPreSetupDaysList") {
            const deletedPreSetupDaysList =
              updatedItem.staffPreSetupDaysList.filter(
                (d, idx) => idx == rowIndex && d.PreSetupStaffID
              );
            console.log(
              "deletedPreSetupDaysList  delete ----->",
              deletedPreSetupDaysList
            );
            updatedItem.staffPreSetupDaysList =
              updatedItem.staffPreSetupDaysList.filter(
                (_, idx) => idx !== rowIndex
              );

            this.setState((prevState) => ({
              deletedPreSetupDaysList: [
                ...prevState.deletedPreSetupDaysList,
                ...deletedPreSetupDaysList.map((item) => ({
                  ...item,
                  ActionID: 3,
                })),
              ],
            }));
          } else if (sectionName === "staffEventDaysList") {
            const deletedEventDaysList = updatedItem.staffEventDaysList.filter(
              (d, idx) => idx == rowIndex && d.EventDayStaffID
            );
            updatedItem.staffEventDaysList =
              updatedItem.staffEventDaysList.filter(
                (_, idx) => idx !== rowIndex
              );

            this.setState((prevState) => ({
              deletedEventDaysList: [
                ...prevState.deletedEventDaysList,
                ...deletedEventDaysList.map((obj) => ({
                  ...obj,
                  ActionID: 3,
                })),
              ],
            }));
          } else if (sectionName === "staffDismantlingDaysList") {
            const deletedDismantlingDaysList =
              updatedItem.staffDismantlingDaysList.filter(
                (d, idx) => idx == rowIndex && d.DismantlingStaffID
              );
            updatedItem.staffDismantlingDaysList =
              updatedItem.staffDismantlingDaysList.filter(
                (_, idx) => idx !== rowIndex
              );

            this.setState((prevState) => ({
              deletedDismantlingDaysList: [
                ...prevState.deletedDismantlingDaysList,
                ...deletedDismantlingDaysList.map((obj) => ({
                  ...obj,
                  ActionID: 3,
                  StaffBadgeCount: item.DismantlingDaysStaffBadgeCount,
                  MainServiceID: item.ServiceID,
                })),
              ],
            }));
          } else if (sectionName === "hallPreSetupDaysList") {
            const deletedPreSetupDaysList =
              updatedItem.hallPreSetupDaysList.filter(
                (d, idx) => idx == rowIndex && d.PreSetupStaffID
              );
            updatedItem.hallPreSetupDaysList =
              updatedItem.hallPreSetupDaysList.filter(
                (_, idx) => idx !== rowIndex
              );

            console.log(
              "deletedPreSetupDaysList---->",
              deletedPreSetupDaysList
            );
            this.setState((prevState) => ({
              deletedPreSetupDaysList: [
                ...prevState.deletedPreSetupDaysList,
                ...deletedPreSetupDaysList.map((item) => ({
                  ...item,
                  ActionID: 3,
                })),
              ],
            }));
          } else if (sectionName === "hallEventDaysList") {
            const deletedEventDaysList = updatedItem.hallEventDaysList.filter(
              (d, idx) => idx == rowIndex && d.EventDayStaffID
            );
            updatedItem.hallEventDaysList =
              updatedItem.hallEventDaysList.filter(
                (_, idx) => idx !== rowIndex
              );

            console.log("deletedEventDaysList---->", deletedEventDaysList);
            this.setState((prevState) => ({
              deletedEventDaysList: [
                ...prevState.deletedEventDaysList,
                ...deletedEventDaysList.map((obj) => ({
                  ...obj,
                  ActionID: 3,
                })),
              ],
            }));
          } else if (sectionName === "hallDismantlingDaysList") {
            const deletedDismantlingDaysList =
              updatedItem.hallDismantlingDaysList.filter(
                (d, idx) => idx == rowIndex && d.DismantlingStaffID
              );
            updatedItem.hallDismantlingDaysList =
              updatedItem.hallDismantlingDaysList.filter(
                (_, idx) => idx !== rowIndex
              );

            console.log(
              "deletedDismantlingDaysList---->",
              deletedDismantlingDaysList
            );
            this.setState((prevState) => ({
              deletedDismantlingDaysList: [
                ...prevState.deletedDismantlingDaysList,
                ...deletedDismantlingDaysList.map((obj) => ({
                  ...obj,
                  ActionID: 3,
                  StaffBadgeCount: item.DismantlingDaysStaffBadgeCount,
                  MainServiceID: item.ServiceID,
                })),
              ],
            }));
          }

          return updatedItem;
        }
        return item;
      });

      console.log("SectionPageList after delete ----->", updatedList);
      return { SectionPageList: updatedList };
    });
  }

  DeliveryServicesPop(param, rowIndex, sectionPageName, sectionName, flag, fieldName) {
    // if (param == "isAdd" && this.state.FormStatusID) {
    //   this.setState({ showRevokePlanModal: true });
    //   return;
    // }
    if (param == "isAdd") {
      this.addMoreSectionPageList(sectionPageName, sectionName);
      this.setState({
        isAddDeliveryServicesPop: true,
      });
    } else {
      this.setState({
        isAddDeliveryServicesPop: false,
      });
    }

    this.setState({
      isDeliveryServicesPop: true,
      DeliveryServicesIndex: rowIndex,
      isDeliveryServicesPopFlag: param,
      isScopeOfWorkPop: flag,
      isInstruction: fieldName == 'Instruction' || false
    });
  }

  handleRevokePlan = async () => {
    const { ExhibitionID, WorkOrderID, sectionPage, SectionPageList } = this.state;

    // Get ServiceID of the current active tab
    const currentSection = SectionPageList.find(
      (section) => section.SectionPageName === sectionPage
    );
    const ServiceID = currentSection ? currentSection.ServiceID : null;

    try {
      this.setState({ isLoading: true });
      const response = await this.props.revokeVendorPlan_action(
        ExhibitionID,
        WorkOrderID,
        ServiceID
      );

      if (response.error !== 1) {
        toastSuccess("Previous plan revoked successfully!");
        this.setState({
          showRevokePlanModal: false,
          FormStatusID: false,
        });
      } else {
        toastError(response.msg || "Failed to revoke plan");
      }
    } catch (error) {
      toastError("Something went wrong while revoking the plan!");
    } finally {
      this.setState({ isLoading: false });
    }
  };

  updateHallZoneList(HallZoneList, i, type, param, e, zoneIndex) {
    return HallZoneList.map((obj, index) => {
      if (index !== i) return obj;

      // RADIO toggle
      if (type === "radio") {
        return {
          ...obj,
          All: param === "All",
          Specific: param !== "All",
          zonelist: obj.zonelist.map((zone) => ({
            ...zone,
            isZoneChecked: param === "All",
          })),
        };
      }

      // HALL toggle
      if (type === "hall") {
        if (e.target.checked) {
          return { ...obj, isHallChecked: true };
        } else {
          return {
            ...obj,
            isHallChecked: false,
            All: true,
            Specific: false,
            zonelist: obj.zonelist.map((zone) => ({
              ...zone,
              isZoneChecked: true,
            })),
          };
        }
      }

      // ZONELIST toggle
      if (type === "zonelist") {
        const updatedZones = obj.zonelist.map((zone, zIndex) =>
          zIndex === zoneIndex
            ? { ...zone, isZoneChecked: e.target.checked }
            : zone
        );

        const allChecked = updatedZones.every((z) => z.isZoneChecked);

        return {
          ...obj,
          zonelist: updatedZones,
          All: allChecked,
          Specific: !allChecked,
        };
      }

      return obj;
    });
  }

  handleInputSectionPageList(
    dataType,
    sectionPageName,
    sectionName,
    e,
    rowIndex,
    fieldName,
    type,
    param,
    hallIndex,
    zoneIndex
  ) {
    const { DeliveryServicesIndex } = this.state;
    let value;
    if (
      [
        "Deadline",
        "ScopeOfWork",
        "DeliverablesServicesStartDate",
        "DeliverablesServicesEndDate",
        "TimeLine",
        "IsStockAvailable",
        "PlanSubmissionDate",
      ].includes(fieldName)
    ) {
      value = e;
    } else if (
      ["IsHallManager", "HallZonelist", "isHallChecked", "IsRevertRequired"].includes(fieldName)
    ) {
      value = e.target.checked;
    } else {
      if (dataType == "varchar") {
        value = e.target.value;
        if (/^\s*$/.test(value)) {
          value = "";
        }
      } else if (dataType == "int") {
        value = e.target.value.replace(/\D/g, "");
      } else if (dataType == "onlyText") {
        value = e.target.value.replace(/[^a-zA-Z ]/g, "");
      } else {
        value = e.target.value.replace(/[^0-9.]/g, "");
      }
    }
    // .replace(/\D/g, "")

    this.setState(
      (prevState) => {
        const updatedList = prevState.SectionPageList.map((item) => {
          if (item.SectionPageName !== sectionPageName) return item;

          let updatedItem = { ...item };

          if (sectionName === "DeliverablesServices") {
            if (type === "ComplianceRequirementsList") {
              updatedItem.DeliverablesServicesList =
                updatedItem.DeliverablesServicesList.map((obj, i) => {
                  if (i === DeliveryServicesIndex) {
                    // Step 1: Create updated object
                    const updatedObj = {
                      ...obj,
                      ComplianceRequirementsList:
                        obj.ComplianceRequirementsList.map((row, idx) =>
                          idx === rowIndex
                            ? {
                              ...row,
                              [fieldName]: value,
                              ActionID: row.ActionID === 0 ? 2 : row.ActionID,
                            }
                            : row
                        ),
                    };

                    const isDuplicate = this.checkDuplicates(
                      updatedObj.ComplianceRequirementsList,
                      ["Specification", "LocationID", "Quantity", "TimeLine"]
                    );

                    if (isDuplicate) {
                      toastError(`Duplicate records cannot be inserted`);
                      return obj;
                    }

                    return updatedObj;
                  }

                  return obj;
                });
            } else if (fieldName !== "MainServiceDeliverablesID") {

              updatedItem.DeliverablesServicesList =
                updatedItem.DeliverablesServicesList.map((row, idx) =>
                  idx === rowIndex
                    ? {
                      ...row,
                      [fieldName]: value,
                      ActionID: row.ActionID === 0 ? 2 : row.ActionID,
                      isInstructionsChange: fieldName === "Instructions" ? true : row.isInstructionsChange,
                      isInstructionOrDocUpdate: fieldName === "Instructions" ? true : fieldName === "IsRevertRequired" && (value == true) ? true : row.isInstructionOrDocUpdate,
                    }
                    : row
                );
            } else {
              updatedItem.DeliverablesServicesList =
                updatedItem.DeliverablesServicesList.map((row, idx) =>
                  idx === rowIndex
                    ? {
                      ...row,
                      [fieldName]: value,
                      isEditInpute: value === "Other",
                      isInstructionsChange: fieldName === "Instructions" ? true : row.isInstructionsChange,
                      isInstructionOrDocUpdate: fieldName === "Instructions" ? true : row.isInstructionOrDocUpdate,
                      MainServiceDeliverablesName: (
                        this.state.DeliverablesServiceFillListArray.find(
                          (d) => d.MainServiceDeliverablesID == value
                        ) || {}
                      ).MainServiceDeliverablesName,
                      ActionID: row.ActionID === 0 ? 2 : row.ActionID,
                    }
                    : row
                );
            }
          } else if (sectionName === "OrganizerResponsibilities") {
            const updatedOrgRespList =
              updatedItem.OrganizerResponsibilitiesList.map((row, idx) => {
                if (idx === rowIndex) {
                  return {
                    ...row,
                    [fieldName]: value,
                    ActionID: row.ActionID === 0 ? 2 : row.ActionID,
                  };
                }
                return row;
              });

            const isDuplicate = this.checkDuplicates(updatedOrgRespList, [
              "Responsibilities",
            ]);

            if (isDuplicate) {
              toastError(`Duplicate records cannot be inserted`);
              return item; // return original item without changes
            }

            updatedItem = {
              ...updatedItem,
              OrganizerResponsibilitiesList: updatedOrgRespList,
            };
          } else if (sectionName === "staffPreSetupDays") {
            const updatedList = updatedItem.staffPreSetupDaysList.map(
              (row, idx) =>
                idx === rowIndex
                  ? {
                    ...row,
                    [fieldName]: value,
                    ActionID: row.ActionID === 0 ? 2 : row.ActionID,
                  }
                  : row
            );

            const isDuplicate = this.checkDuplicates(updatedList, [
              "PersonName",
              "EmailID",
              "MobileNumber",
              "DesignationID",
            ]);
            if (isDuplicate) {
              toastError(`Duplicate records cannot be inserted`);
              return item; // return original item without updating
            }

            updatedItem = {
              ...updatedItem,
              staffPreSetupDaysList: updatedList,
            };
          } else if (sectionName === "staffEventDays") {
            const updatedList = updatedItem.staffEventDaysList.map((row, idx) =>
              idx === rowIndex
                ? {
                  ...row,
                  [fieldName]: value,
                  ActionID: row.ActionID === 0 ? 2 : row.ActionID,
                }
                : row
            );

            const isDuplicate = this.checkDuplicates(updatedList, [
              "PersonName",
              "EmailID",
              "MobileNumber",
              "DesignationID",
            ]);
            if (isDuplicate) {
              toastError(`Duplicate records cannot be inserted`);
              return item; // keep original item if duplicate
            }

            updatedItem = {
              ...updatedItem,
              staffEventDaysList: updatedList,
            };
          } else if (sectionName === "staffDismantlingDays") {
            const updatedList = updatedItem.staffDismantlingDaysList.map(
              (row, idx) =>
                idx === rowIndex
                  ? {
                    ...row,
                    [fieldName]: value,
                    ActionID: row.ActionID === 0 ? 2 : row.ActionID,
                  }
                  : row
            );

            const isDuplicate = this.checkDuplicates(updatedList, [
              "PersonName",
              "EmailID",
              "MobileNumber",
              "DesignationID",
            ]);
            if (isDuplicate) {
              toastError(`Duplicate records cannot be inserted`);
              return item; // keep original item if duplicate
            }

            updatedItem = {
              ...updatedItem,
              staffDismantlingDaysList: updatedList,
            };
          } else if (sectionName === "hallPreSetupDays") {
            if (fieldName === "Shift") {
              updatedItem.hallPreSetupDaysList =
                updatedItem.hallPreSetupDaysList.map((row, idx) => {
                  if (idx !== rowIndex) return row;

                  // Update ShiftList
                  const updatedShiftList = row.ShiftList.map(
                    (dateObj, dIdx) => {
                      if (dIdx !== hallIndex) return dateObj;

                      if (type === "isDate") {
                        return {
                          ...dateObj,
                          isDateCheck: e.target.checked,
                          shift: dateObj.shift.map((s) => ({
                            ...s,
                            isShiftCheck: e.target.checked ? true : false, // uncheck all if date unchecked
                          })),
                        };
                      }

                      if (type === "isShift") {
                        const newShifts = dateObj.shift.map((s, sIdx) =>
                          sIdx === zoneIndex
                            ? { ...s, isShiftCheck: e.target.checked }
                            : s
                        );
                        return {
                          ...dateObj,
                          shift: newShifts,
                        };
                      }

                      return dateObj;
                    }
                  );

                  // 🔹 Build SelectedShifts with "All Shift" logic
                  const SelectedShifts = updatedShiftList
                    .map((d) => {
                      const checkedShifts = d.shift.filter(
                        (s) => s.isShiftCheck
                      );

                      if (checkedShifts.length === 0) return null;

                      // If all shifts in this date are checked -> one entry like "01 Sep 2025 All Shift"
                      if (checkedShifts.length === d.shift.length) {
                        return [`${d.date}, All Shift`];
                      }

                      // Else multiple entries for each shift
                      return checkedShifts.map((s) => `${d.date}, ${s.time}`);
                    })
                    .filter(Boolean)
                    .flat();

                  const SelectedDates = updatedShiftList
                    .filter((d) => d.shift.some((s) => s.isShiftCheck))
                    .map((d) => d.date)
                    .join(", ");

                  const AllocatedDateIDs = updatedShiftList
                    .flatMap((d) => d.shift)
                    .filter((s) => s.isShiftCheck)
                    .map((s) => s.ExhibitionDaysID)
                    .join(", ");

                  const isAllSelectedShift = updatedShiftList.every((d) =>
                    d.shift.every((s) => s.isShiftCheck)
                  );

                  return {
                    ...row,
                    ShiftList: updatedShiftList,
                    SelectedDates,
                    SelectedShifts,
                    isAllSelectedShift,
                    AllocatedDateIDs,
                    ActionID: row.ActionID === 0 ? 2 : row.ActionID,
                  };
                });
            } else if (fieldName !== "HallZonelist") {
              const updatedList = updatedItem.hallPreSetupDaysList.map(
                (row, idx) =>
                  idx === rowIndex
                    ? {
                      ...row,
                      [fieldName]: value,
                      ActionID: row.ActionID === 0 ? 2 : row.ActionID,
                    }
                    : row
              );

              const isDuplicate = this.checkDuplicates(updatedList, [
                "EmailID",
              ]);
              if (isDuplicate) {
                toastError(`Duplicate email cannot be inserted`);
                return item; // keep original item if duplicate
              }

              updatedItem = {
                ...updatedItem,
                hallPreSetupDaysList: updatedList,
              };
            } else {
              updatedItem.hallPreSetupDaysList =
                updatedItem.hallPreSetupDaysList.map((row, idx) => {
                  if (idx !== rowIndex) return row;
                  const updatedHallZoneList = this.updateHallZoneList(
                    row.HallZoneList,
                    hallIndex,
                    type,
                    param,
                    e,
                    zoneIndex
                  );
                  const selectedHalls = updatedHallZoneList
                    .filter((h) => h.isHallChecked)
                    .map((h) => h.HallName || h.Name)
                    .join(", ");

                  const selectedHallsIds = updatedHallZoneList
                    .filter((h) => h.isHallChecked)
                    .map((h) => h.HallId || h.HallID)
                    .join(", ");

                  return {
                    ...row,
                    HallZoneList: updatedHallZoneList,
                    SelectedHalls: selectedHalls,
                    HallIDs: selectedHallsIds,
                    EmailID: row.EmailID,
                    ActionID: row.ActionID === 0 ? 2 : row.ActionID,
                  };
                });
            }
          } else if (sectionName === "hallEventDays") {
            if (fieldName === "Shift") {
              updatedItem.hallEventDaysList = updatedItem.hallEventDaysList.map(
                (row, idx) => {
                  if (idx !== rowIndex) return row;

                  const updatedShiftList = row.ShiftList.map(
                    (dateObj, dIdx) => {
                      if (dIdx !== hallIndex) return dateObj;

                      if (type === "isDate") {
                        return {
                          ...dateObj,
                          isDateCheck: e.target.checked,
                        };
                      }

                      return dateObj;
                    }
                  );

                  const SelectedDates = updatedShiftList
                    .filter((d) => d.isDateCheck)
                    .map((d) => d.DateValue)
                    .join(", ");

                  return {
                    ...row,
                    ShiftList: updatedShiftList,
                    SelectedDates,
                    ActionID: row.ActionID === 0 ? 2 : row.ActionID,
                  };
                }
              );
            } else if (fieldName !== "HallZonelist") {
              const updatedList = updatedItem.hallEventDaysList.map(
                (row, idx) =>
                  idx === rowIndex
                    ? {
                      ...row,
                      [fieldName]: value,
                      ActionID: row.ActionID === 0 ? 2 : row.ActionID,
                    }
                    : row
              );

              const isDuplicate = this.checkDuplicates(updatedList, [
                "EmailID",
              ]);
              if (isDuplicate) {
                toastError(`Duplicate email cannot be inserted`);
                return item;
              }

              updatedItem = {
                ...updatedItem,
                hallEventDaysList: updatedList,
              };
            } else {
              updatedItem.hallEventDaysList = updatedItem.hallEventDaysList.map(
                (row, idx) => {
                  if (idx !== rowIndex) return row;
                  const updatedHallZoneList = this.updateHallZoneList(
                    row.HallZoneList,
                    hallIndex,
                    type,
                    param,
                    e,
                    zoneIndex
                  );
                  const selectedHalls = updatedHallZoneList
                    .filter((h) => h.isHallChecked)
                    .map((h) => h.HallName || h.Name)
                    .join(", ");

                  return {
                    ...row,
                    HallZoneList: updatedHallZoneList,
                    SelectedHalls: selectedHalls,
                    ActionID: row.ActionID === 0 ? 2 : row.ActionID,
                  };
                }
              );
            }
          } else if (sectionName === "hallDismantlingDays") {
            if (fieldName === "Shift") {
              updatedItem.hallDismantlingDaysList =
                updatedItem.hallDismantlingDaysList.map((row, idx) => {
                  if (idx !== rowIndex) return row;

                  const updatedShiftList = row.ShiftList.map(
                    (dateObj, dIdx) => {
                      if (dIdx !== hallIndex) return dateObj;

                      if (type === "isDate") {
                        return {
                          ...dateObj,
                          isDateCheck: e.target.checked,
                          shift: dateObj.shift.map((s) => ({
                            ...s,
                            isShiftCheck: e.target.checked ? true : false, // uncheck all if date unchecked
                          })),
                        };
                      }

                      if (type === "isShift") {
                        const newShifts = dateObj.shift.map((s, sIdx) =>
                          sIdx === zoneIndex
                            ? { ...s, isShiftCheck: e.target.checked }
                            : s
                        );
                        return {
                          ...dateObj,
                          shift: newShifts,
                        };
                      }

                      return dateObj;
                    }
                  );

                  const SelectedShifts = updatedShiftList
                    .map((d) => {
                      const checkedShifts = d.shift.filter(
                        (s) => s.isShiftCheck
                      );
                      if (checkedShifts.length === 0) return null;
                      if (checkedShifts.length === d.shift.length) {
                        return [`${d.date}, All Shift`];
                      }
                      return checkedShifts.map((s) => `${d.date}, ${s.time}`);
                    })
                    .filter(Boolean)
                    .flat();

                  const SelectedDates = updatedShiftList
                    .filter((d) => d.shift.some((s) => s.isShiftCheck))
                    .map((d) => d.date)
                    .join(", ");

                  const isAllSelectedShift = updatedShiftList.every((d) =>
                    d.shift.every((s) => s.isShiftCheck)
                  );

                  const AllocatedDateIDs = updatedShiftList
                    .flatMap((d) => d.shift)
                    .filter((s) => s.isShiftCheck)
                    .map((s) => s.ExhibitionDaysID)
                    .join(", ");

                  return {
                    ...row,
                    ShiftList: updatedShiftList,
                    SelectedDates,
                    SelectedShifts,
                    isAllSelectedShift,
                    AllocatedDateIDs,
                    ActionID: row.ActionID === 0 ? 2 : row.ActionID,
                  };
                });
            } else if (fieldName !== "HallZonelist") {
              const updatedList = updatedItem.hallDismantlingDaysList.map(
                (row, idx) =>
                  idx === rowIndex
                    ? {
                      ...row,
                      [fieldName]: value,
                      ActionID: row.ActionID === 0 ? 2 : row.ActionID,
                    }
                    : row
              );

              const isDuplicate = this.checkDuplicates(updatedList, [
                "EmailID",
              ]);
              if (isDuplicate) {
                toastError(`Duplicate email cannot be inserted`);
                return item;
              }

              updatedItem = {
                ...updatedItem,
                hallDismantlingDaysList: updatedList,
              };
            } else {
              updatedItem.hallDismantlingDaysList =
                updatedItem.hallDismantlingDaysList.map((row, idx) => {
                  if (idx !== rowIndex) return row;
                  const updatedHallZoneList = this.updateHallZoneList(
                    row.HallZoneList,
                    hallIndex,
                    type,
                    param,
                    e,
                    zoneIndex
                  );
                  const selectedHalls = updatedHallZoneList
                    .filter((h) => h.isHallChecked)
                    .map((h) => h.HallName || h.Name)
                    .join(", ");

                  return {
                    ...row,
                    HallZoneList: updatedHallZoneList,
                    SelectedHalls: selectedHalls,
                    ActionID: row.ActionID === 0 ? 2 : row.ActionID,
                  };
                });
            }
          } else if (sectionName === "PreSetupDaysStaffBadgeCount") {
            updatedItem.PreSetupDaysStaffBadgeCount = value;
          } else if (sectionName === "DismantlingDaysStaffBadgeCount") {
            updatedItem.DismantlingDaysStaffBadgeCount = value;
          } else if (sectionName === "PlanSubmissionDate") {
            updatedItem.PlanSubmissionDate = value;
          } else if (sectionName === "isHallChecked") {
            if (e.target.checked) {
              updatedItem.isHallChecked = value;
            } else {
              !e.target.checked && this.setState({ isHallPop: true });
            }
          }

          return updatedItem;
        });

        return { SectionPageList: updatedList };
      },
      () => {
        console.log("SectionPageList--->", this.state.SectionPageList);
      }
    );
  }

  onStallSelect(e) {
    const { RenderhallList } = this.state;
    const value = e.target.value;
    this.setState({ stallId: value });
  }

  async onHallSelect(e) {
    const { ExhibitionID, allHallStallList } = this.state;
    const value = e.target.value;
    if (value != "" && value != "Select") {
      this.setState({
        hallId: e.target.value,
        stallId: "",
        allSelected: false,
      });

      const filterArray = allHallStallList.filter((obj) => value == obj.HallId);

      this.setState({ RenderhallList: filterArray, stallList: filterArray });
    } else {
      this.setState({ hallId: "", stallId: "", allSelected: false });
    }
  }

  allSelected(e) {
    const { RenderhallList, allHallStallList, hallId } = this.state;
    const value = e.target.checked;
    if (RenderhallList.length > 0) {
      this.setState({ allSelected: value });
      RenderhallList.forEach((obj) => {
        obj.isCheck = value;
      });
      allHallStallList.forEach((obj) => {
        if (obj.HallId == hallId) {
          obj.isCheck = value;
        }
      });
      const array = allHallStallList.filter((item) => item.isCheck);
      this.setState({
        RenderhallList: RenderhallList,
        selectedHallStallList: array,
      });
    }
  }

  onExhibitionSelect(e) {
    this.setState({ ExhibitionID: e.target.value, ExhibitionIDErr: "" }, () => {
      this.getFillList(
        vendorStaffSectionShiftActionId,
        e.target.value,
        "",
        "P",
        "",
        ""
      );
      this.getFillList(
        vendorStaffSectionShiftActionId,
        e.target.value,
        "",
        "D",
        "",
        ""
      );
    });
  }

  selectVendor(e) {
    const { vendorList } = this.state;
    this.setState({ vendorId: e.target.value, vendorIdErr: "" }, async () => {
      await this.getFillList(
        scopeOfWorkHallZoneListctionId,
        "",
        "",
        e.target.value,
        "",
        ""
      );
      const serviceList = await this.getFillList(
        scopeOfWorkVendorServicesActionId,
        "",
        "",
        e.target.value,
        "",
        ""
      );
      const ID = vendorList.find(
        (item) => item.AccountID == e.target.value
      )?.Userid;
      const result = serviceList.map((item) => ({
        label: item.Name,
        value: item.ServiceID,
      }));
      this.detailsVendorRegistration(ID);
      this.onChangeWorkOrderService(result);
    });
  }

  handleRemoveFile(e, index) {
    const { documentList } = this.state;
    for (let i = 0; i < documentList.length; i++) {
      if (i === index) {
        documentList[i]["FilePath"] = "";
        documentList[i]["FileName"] = "";
        documentList[i]["FileType"] = "";
      }
    }
    this.setState({ documentList: documentList });
  }

  async documentHandleInput(e, index, feildName) {
    const { documentList } = this.state;
    const file = e.target.files;
    for (let i = 0; i < documentList.length; i++) {
      if (i === index) {
        if (feildName == "DocumentName") {
          documentList[i]["DocumentName"] = e.target.value;
        } else if (feildName == "file") {
          const result = await this.onFilePick(e, file);
          documentList[i]["FilePath"] = result.FilePath;
          documentList[i]["FileName"] = result.FileName;
          documentList[i]["FileType"] = result.FileType;
        } else if (feildName == "clear") {
          documentList[i]["DocumentName"] = "";
          documentList[i]["FilePath"] = "";
          documentList[i]["FileName"] = "";
          documentList[i]["FileType"] = "";
        }
      }
    }
    if (feildName == "delete") {
      const filterArray = documentList.filter((item, i) => i != index);
      const filterArray2 = documentList
        .filter((item, i) => i === index)
        .map((obj) => ({ ...obj, ActionID: 3 }));

      this.setState((prev) => ({
        deleteDocumentList: [...prev.deleteDocumentList, ...filterArray2],
      }));

      return this.setState({ documentList: filterArray });
    }
    this.setState({ documentList: documentList });
  }

  convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  onFilePick = async (e, file) => {
    e.preventDefault();
    if (file[0]["size"] > 5242880) {
      toast.error("File size more than 5mb are not allow.", {
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
      return;
    }
    if (
      file[0]["name"].toString().toLowerCase().includes(".pdf") ||
      file[0]["name"].toString().toLowerCase().includes(".jpeg") ||
      file[0]["name"].toString().toLowerCase().includes(".png") ||
      file[0]["name"].toString().toLowerCase().includes(".jpg")
    ) {
      let image
      if (file[0]["name"].includes("pdf")) {
        image = await this.onPdfSelect(file[0]);
      } else {
        image = await this.resizeFile(file[0]);
      }

      const fileType = file[0]["type"];
      var fileTypeList;
      if (fileType.includes("/")) {
        fileTypeList = fileType.split("/");
      }
      const finalFileTypeName =
        fileTypeList.length > 0 ? fileTypeList[1] : "";

      return {
        FilePath: image,
        FileName: file[0]["name"],
        FileType: finalFileTypeName,
      };
    } else {
      toast.error(`Allowed File types .jpg,.jpeg,.png,.pdf with maximum size 5 MB`, {
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
      return;
    }
  };


  onDeliverableFilePick = async (e, file) => {
    e.preventDefault();

    if (!file || !file[0]) {
      return;
    }

    const selectedFile = file[0];
    const maxFileSize = 25 * 1024 * 1024; // 25 MB

    // File size validation
    if (selectedFile.size > maxFileSize) {
      toast.error("File size more than 25MB is not allowed.", {
        position: "top-center",
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
      return;
    }

    const fileName = selectedFile.name;
    const fileExtension = fileName.split(".").pop().toLowerCase();

    const allowedExtensions = [
      "pdf",
      "jpeg",
      "jpg",
      "png",
      "dwg",
      "dxf",
      "dwt",
      "doc",
      "docx",
      "xls",
      "xlsx",
    ];

    // File type validation
    if (!allowedExtensions.includes(fileExtension)) {
      toast.error(
        "Only .pdf, .jpeg, .jpg, .png, .dwg, .dxf, .dwt, .doc, .docx, .xls and .xlsx files are allowed.",
        {
          position: "top-center",
          theme: "colored",
          autoClose: 3000,
          hideProgressBar: true,
        }
      );
      return;
    }

    try {
      // Convert original file directly to Base64
      const image = await this.convertToBase64(selectedFile);

      return {
        FilePath: image,
        FileName: fileName,
        FileType: fileExtension,
      };
    } catch (error) {
      console.error("File processing error:", error);

      toast.error("Unable to process the selected file.", {
        position: "top-center",
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });

      return null;
    }
  };

  handleDeliverableDocUpload = async (e, sectionPageName, deliverableIndex, docIndex) => {
    const file = e.target.files;
    if (!file || !file[0]) return;

    const result = await this.onDeliverableFilePick(e, file);

    if (!result) {
      const input = document.getElementById(
        `deliverableFile_${sectionPageName}_${deliverableIndex}_${docIndex}`
      );

      if (input) input.value = "";
      return;
    }

    this.setState((prevState) => {
      const updatedList = prevState.SectionPageList.map((item) => {
        if (item.SectionPageName !== sectionPageName) return item;

        return {
          ...item,
          DeliverablesServicesList: item.DeliverablesServicesList.map((d, i) => {
            if (i !== deliverableIndex) return d;

            const docs = [...(d.DocumentsList || [])];

            docs.push({
              DocumentPath: result.FilePath,
              DocumentName: result.FileName,
              DocumentType: result.FileType,
              DocumentRefNo: docs.length + 1,
              ActionID: 1,
              SowDeliverablesDocumentsID: null,
              Instructions: null,
            });

            return {
              ...d,
              DocumentsList: docs,
              isInstructionOrDocUpdate: true
            };
          }),
        };
      });

      return { SectionPageList: updatedList };
    });

    e.target.value = "";
  };

  handleDeliverableDocRemove = (sectionPageName, deliverableIndex, docIndex) => {
    this.setState((prevState) => {
      const updatedList = prevState.SectionPageList.map((item) => {
        if (item.SectionPageName !== sectionPageName) return item;

        return {
          ...item,
          DeliverablesServicesList: item.DeliverablesServicesList.map((d, i) => {
            if (i !== deliverableIndex) return d;

            const docs = [...(d.DocumentsList || [])];

            if (docs[docIndex]) {
              docs[docIndex] = {
                ...docs[docIndex],
                ActionID: 2,
              };
            }

            return {
              ...d,
              isInstructionOrDocUpdate: true,
              DocumentsList: docs,
            };
          }),
        };
      });
      console.log("updatedList--------->", updatedList)
      return { SectionPageList: updatedList };
    });
  };

  onPdfSelect = (file) =>
    new Promise((resolve) => {
      let base64;
      // FileReader function for read the file.
      let fileReader = new FileReader();
      // Onload of file read the file content
      fileReader.onload = function (fileLoadedEvent) {
        base64 = fileLoadedEvent.target.result;
        // Print data in console
        resolve(base64);
      };
      // Convert data to base64
      fileReader.readAsDataURL(file);
    });

  resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        500,
        600,
        "JPEG",
        80,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64",
        300,
        300
      );
    });

  addMoreDocuments() {
    this.setState((prev) => ({
      documentList: [
        ...prev.documentList,
        {
          DocumentName: "",
          FileName: "",
          FilePath: "",
          FileType: "",
          ActionID: 1,
        },
      ],
    }));
  }

  DeliveryServicesPopSave() {
    const { SectionPageList, sectionPage, DeliveryServicesIndex } = this.state;

    const selectedSection = SectionPageList.find(
      (data) => data.SectionPageName === sectionPage
    );

    if (!selectedSection) return;

    // ✅ Only get the object at DeliveryServicesIndex
    const obj = selectedSection.DeliverablesServicesList[DeliveryServicesIndex];

    if (!obj) return;

    // ✅ Mandatory field check only on that row
    const allValid =
      obj.MainServiceDeliverablesID &&
      obj.AccessibleID &&
      (obj.AccessibleID == 2
        ? obj.DeliverablesPricingID &&
        obj.VendorOrganizerPriceInINR &&
        obj.VendorOrganizerPriceInUSD &&
        obj.VendorExhibitorPriceInINR &&
        obj.VendorExhibitorPriceInUSD &&
        obj.Quantity
        : true);

    if (!allValid) {
      toastError("Please enter mandatory fields");
      return;
    }

    // ✅ Compliance requirements empty check
    const ComplianceRequirementsIsBlank = this.checkValuesNotEmpty(
      obj.ComplianceRequirementsList,
      ["Specification", "LocationID", "Quantity", "DesigTimeLinenationID"]
    );

    if (!ComplianceRequirementsIsBlank) {
      this.setState({ isLoading: false });
      return toastError(
        `Please fill all row in the compliance requirements or delete that row`
      );
    }

    console.log(
      "obj.ComplianceRequirementsList--->",
      obj.ComplianceRequirementsList
    );

    // ✅ Duplicate check on compliance requirements
    const ComplianceRequirementsListDuplicate = this.checkDuplicates(
      obj.ComplianceRequirementsList,
      ["Specification", "LocationID", "Quantity", "TimeLine"]
    );

    if (ComplianceRequirementsListDuplicate) {
      this.setState({ isLoading: false });
      return toastError(
        `Duplicate records cannot be inserted in the compliance requirements or delete that row`
      );
    }

    // ✅ Close popup only after validation success
    this.setState({
      isDeliveryServicesPop: false,
      DeliveryServicesIndex: "",
      isAddDeliveryServicesPop: true,
    });
  }

  DeliveryServicesPopClosed() {
    const {
      isDeliveryServicesPopFlag,
      SectionPageList,
      DeliveryServicesIndex,
      sectionPage,
    } = this.state;
    if (isDeliveryServicesPopFlag == "isAdd") {
      SectionPageList.map((data) => {
        if (data.SectionPageName == sectionPage) {
          data.DeliverablesServicesList = data.DeliverablesServicesList.filter(
            (_, index) => index !== data.DeliverablesServicesList.length - 1
          );
        }
      });
      console.log("SectionPageList->", SectionPageList);
      this.setState({
        SectionPageList: SectionPageList,
        isAddDeliveryServicesPop: true,
      });
    }

    this.setState({ isDeliveryServicesPop: false, DeliveryServicesIndex: "" });
  }

  StaffSectionHallPop(rowIndex, value) {
    console.log("value--->", value);
    this.setState({
      StaffSectionIndex: rowIndex,
      StaffSectionHallPop: true,
      staffSectionTableName: value,
    });
  }

  StaffSectionShiftPop(rowIndex, value) {
    console.log("value--->", value);
    this.setState({
      StaffSectionIndex: rowIndex,
      StaffSectionShiftPop: true,
      staffSectionTableName: value,
    });
  }

  handleTableInput(e, serviceName, i, type, param, zoneIndex) {
    const { SectionPageList, sectionPage } = this.state;

    const selectedSection = SectionPageList.find(
      (data) => data.SectionPageName === sectionPage
    );

    if (!selectedSection) return;

    this.setState((prevState) => {
      const updatedList = prevState.sectionPageList.map((item) => {
        if (item.Name !== serviceName) return item;

        return {
          ...item,
          HallZoneList: item.HallZoneList.map((obj, index) => {
            if (index !== i) return obj;

            // RADIO toggle
            if (type === "radio") {
              return {
                ...obj,
                All: param === "All",
                Specific: param !== "All",
                zonelist: obj.zonelist.map((zone) => ({
                  ...zone,
                  isZoneChecked: param === "All", // tick/untick all
                })),
              };
            }

            // HALL toggle
            if (type === "hall") {
              return {
                ...obj,
                isHallChecked: e.target.checked,
              };
            }

            // ZONELIST toggle (individual checkbox)
            if (type === "zonelist") {
              const updatedZones = obj.zonelist.map((zone, zIndex) => {
                if (zIndex !== zoneIndex) return zone;
                return {
                  ...zone,
                  isZoneChecked: e.target.checked,
                };
              });

              // check if ALL zones are checked
              const allChecked = updatedZones.every((z) => z.isZoneChecked);

              return {
                ...obj,
                zonelist: updatedZones,
                All: allChecked,
                Specific: !allChecked,
              };
            }

            return obj;
          }),
        };
      });

      console.log("updated renderHallZoneList -->", updatedList);
      return { renderHallZoneList: updatedList };
    });
  }

  StaffSectionHallPopClosed() {
    this.setState({ StaffSectionHallPop: false });
  }

  StaffSectionShiftPopClosed() {
    this.setState({ StaffSectionShiftPop: false });
  }

  StaffSectionShiftPopSave() {
    const {
      SectionPageList,
      sectionPage,
      StaffSectionIndex,
      staffSectionTableName,
    } = this.state;

    const selectedSection = SectionPageList.find(
      (section) => section.SectionPageName === sectionPage
    );

    if (!selectedSection) return;

    // Determine the correct list name based on staffSectionTableName
    let listName = "";
    if (staffSectionTableName === "hallPreSetupDays")
      listName = "hallPreSetupDaysList";
    else if (staffSectionTableName === "hallEventDays")
      listName = "hallEventDaysList";
    else if (staffSectionTableName === "hallDismantlingDays")
      listName = "hallDismantlingDaysList";
    else return;

    // Get only the selected day
    const selectedDay = selectedSection[listName][StaffSectionIndex];
    if (!selectedDay) return;

    if (staffSectionTableName === "hallEventDays") {
      const isSomeCheck = selectedDay.ShiftList.some(
        (item) => item.isDateCheck
      );
      if (!isSomeCheck) {
        toastError("Please select atleast 1 date");
      } else {
        this.setState({
          StaffSectionShiftPop: false,
        });
      }
    } else {
      const isValid = (() => {
        // 1. At least one date is selected
        const selectedDates = selectedDay.ShiftList.filter(
          (d) => d.isDateCheck
        );
        if (selectedDates.length === 0) return false;

        // 2. Each selected date should have at least one checked shift
        return selectedDates.every((d) => d.shift.some((s) => s.isShiftCheck));
      })();

      if (!isValid) {
        toastError("Select at least one date with at least one shift.");
      } else {
        this.setState({
          StaffSectionShiftPop: false,
        });
      }
    }
  }

  StaffSectionHallPopSave() {
    const {
      SectionPageList,
      sectionPage,
      StaffSectionIndex,
      staffSectionTableName,
    } = this.state;

    const selectedSection = SectionPageList.find(
      (section) => section.SectionPageName === sectionPage
    );

    if (!selectedSection) return;

    // Determine the correct list name based on staffSectionTableName
    let listName = "";
    if (staffSectionTableName === "hallPreSetupDays")
      listName = "hallPreSetupDaysList";
    else if (staffSectionTableName === "hallEventDays")
      listName = "hallEventDaysList";
    else if (staffSectionTableName === "hallDismantlingDays")
      listName = "hallDismantlingDaysList";
    else return;

    // Get only the selected day
    const selectedDay = selectedSection[listName][StaffSectionIndex];
    if (!selectedDay) return;

    // Get the result from your helper function
    const result = this.getSelectedZones([selectedDay], selectedDay.EmailID);

    if (result !== true) {
      const updatedList = SectionPageList.map((section) => {
        if (section.SectionPageName !== sectionPage) return section; // leave other sections unchanged

        const updatedDaysList = section[listName].map((day, index) => {
          if (index !== StaffSectionIndex) return day; // leave other days unchanged
          return { ...day, selectedHallZoneList: result }; // update only selected index
        });

        return { ...section, [listName]: updatedDaysList };
      });
      console.log("updatedList--->", updatedList);

      this.setState({
        StaffSectionHallPop: false,
        StaffSectionIndex: "",
        SectionPageList: updatedList,
      });
    }
  }

  getSelectedZones(data, EmailID) {
    const results = [];

    for (const service of data) {
      // ✅ halls that are checked
      const hallsChecked = service.HallZoneList.filter(
        (hall) => hall.isHallChecked
      );

      if (hallsChecked.length === 0) {
        toastError("Please select atleast 1 hall.");
        return true;
      }

      for (const hall of hallsChecked) {
        const checkedZones = (hall.zonelist || []).filter(
          (z) => z.isZoneChecked
        );

        if (checkedZones.length === 0) {
          toastError("Please select a zone for the selected hall.");
          return true;
        }

        checkedZones.forEach((zone) => {
          results.push({
            HallID: hall.HallId,
            ZoneID: zone.ZoneID,
            vendorAllocationMappingID: null,
            EmailID: EmailID,
          });
        });
      }
    }

    // ✅ only reached if all conditions satisfied
    return results;
  }

  handleViewFile = (base64String, fileName) => {
    // Extract MIME type and Base64 data
    const mimeType = base64String.split(";")[0].split(":")[1]; // Extract MIME type (e.g., 'image/png' or 'application/pdf')
    const byteCharacters = atob(base64String.split(",")[1]); // Extract Base64 content
    const byteNumbers = Array.from(byteCharacters).map((char) =>
      char.charCodeAt(0)
    );
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });

    // Create a URL for the Blob
    const fileURL = URL.createObjectURL(blob);

    if (mimeType.startsWith("image/") || mimeType === "application/pdf") {
      // Open viewable files directly
      const newTab = window.open(fileURL, "_blank", "noopener,noreferrer");
    } else {
      // Download non-viewable files
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = fileName; // Use the specific file name for the download
      link.click();
    }

    // Clean up the blob URL after the file action
    setTimeout(() => URL.revokeObjectURL(fileURL), 500);
  };

  isHallManagerPopClosed() {
    const { sectionPage } = this.state;

    this.setState(
      (prevState) => {
        const updatedList = prevState.SectionPageList.map((item) => {
          if (item.SectionPageName === sectionPage) {
            let updatedItem = { ...item };

            // Move existing records into deleted lists with ActionID = 3
            const deletedPreSetup = updatedItem.hallPreSetupDaysList.map(
              (d) => ({
                ...d,
                ActionID: 3,
              })
            );
            const deletedEvent = updatedItem.hallEventDaysList.map((d) => ({
              ...d,
              ActionID: 3,
            }));
            const deletedDismantling = updatedItem.hallDismantlingDaysList.map(
              (d) => ({
                ...d,
                ActionID: 3,
              })
            );

            // Update deleted arrays in state
            this.setState((state) => ({
              deletedPreSetupDaysList: [
                ...state.deletedPreSetupDaysList,
                ...deletedPreSetup,
              ],
              deletedEventDaysList: [
                ...state.deletedEventDaysList,
                ...deletedEvent,
              ],
              deletedDismantlingDaysList: [
                ...state.deletedDismantlingDaysList,
                ...deletedDismantling,
              ],
              isHallPop: false,
            }));

            // Now clear original arrays
            updatedItem.isHallChecked = false;
            updatedItem.hallPreSetupDaysList = [];
            updatedItem.hallEventDaysList = [];
            updatedItem.hallDismantlingDaysList = [];

            return updatedItem;
          }
          return item;
        });

        return { SectionPageList: updatedList };
      },
      () => {
        console.log("sectionPageList--->", this.state.SectionPageList);
      }
    );
  }

  ChangePassword(userId) {
    this.setState({ showChangePasswordModal: true, selectedUserId: userId });
  }

  getCleanedRow(sourceRow, targetSection) {
    return {
      ...sourceRow,
      SelectedDates: null,
      AllocatedDateIDs: '',
      HallIDs: '',
      SelectedHalls: '',
      SelectedShifts: [],
      selectedHallZoneList: [],
      HallZoneList: this.state.HallZoneList,
      Password: sourceRow.Password || null,
      ShiftList:
        targetSection === "EventDays"
          ? this.state.EventDaysShiftList
          : this.state.hallDismantlingDaysList
    };
  }

  Replicate(sectionPageName, sectionName, rowIndex, targetSection) {
    let isReplicated = false;

    this.setState((prevState) => {
      const updatedList = prevState.SectionPageList.map((page) => {
        if (page.SectionPageName !== sectionPageName) return page;

        const updatedPage = { ...page };

        const sourceListName =
          sectionName === "Staff"
            ? "staffPreSetupDaysList"
            : "hallPreSetupDaysList";

        const sourceRowRaw = { ...page[sourceListName][rowIndex] };

        const commonFields = ["PersonName", "EmailID", "MobileNumber"];
        const fields =
          sectionName === "Staff"
            ? [...commonFields, "DesignationID"]
            : commonFields;

        // 🔴 validation
        const isSourceBlank = fields.every(
          (key) => !sourceRowRaw[key] || sourceRowRaw[key] === ""
        );

        if (isSourceBlank) {
          toastError("Please fill all required fields in Pre-Setup before replicating!");
          return page;
        }

        const targetListName =
          sectionName === "Staff"
            ? targetSection === "EventDays"
              ? "staffEventDaysList"
              : "staffDismantlingDaysList"
            : targetSection === "EventDays"
              ? "hallEventDaysList"
              : "hallDismantlingDaysList";

        let targetList = [...(updatedPage[targetListName] || [])];

        // 🟢 APPLY SAME CLEANING AS ReplicateAll
        const cleanedRow = this.getCleanedRow(sourceRowRaw, targetSection);

        // 🔵 duplicate check
        const exactDuplicate = targetList.some((row) =>
          fields.every((key) => row[key] === cleanedRow[key])
        );

        if (exactDuplicate) {
          toastError(
            `This row already exists in ${targetSection === "EventDays" ? "event" : "dismantling"
            } days!`
          );
          return page;
        }

        // 🟡 update blank row
        const updatableRowIndex = targetList.findIndex((row) =>
          fields.every((key) => !row[key] || row[key] === "")
        );

        if (updatableRowIndex !== -1) {
          const updatedRow = { ...targetList[updatableRowIndex] };

          fields.forEach((key) => {
            if ((!updatedRow[key] || updatedRow[key] === "") && cleanedRow[key]) {
              updatedRow[key] = cleanedRow[key];
            }
          });

          updatedRow.ActionID = 2;
          targetList[updatableRowIndex] = updatedRow;
        } else {
          // 🔵 add new row
          targetList.push({
            ...cleanedRow,
            ActionID: 1
          });
        }

        updatedPage[targetListName] = targetList;
        isReplicated = true;
        return updatedPage;
      });

      return { SectionPageList: updatedList };
    }, () => {
      if (isReplicated) {
        toastSuccess("Successfully replicated!");
      }
    });
  }

  ReplicateStaffToHall(sectionPageName, dayType) {
    const staffListMap = {
      PreSetup: "staffPreSetupDaysList",
      Event: "staffEventDaysList",
      Dismantling: "staffDismantlingDaysList",
    };

    const hallListMap = {
      PreSetup: "hallPreSetupDaysList",
      Event: "hallEventDaysList",
      Dismantling: "hallDismantlingDaysList",
    };

    this.setState((prevState) => {
      const updatedList = prevState.SectionPageList.map((page) => {
        if (page.SectionPageName !== sectionPageName) return page;

        const sourceList = page[staffListMap[dayType]] || [];
        let targetList = [...(page[hallListMap[dayType]] || [])];

        sourceList.forEach((sourceRow) => {
          const { PersonName, EmailID, MobileNumber } = sourceRow;

          if (!PersonName && !EmailID && !MobileNumber) return;

          // Check if same person already exists in Hall list
          const isDuplicate = targetList.some(
            (row) =>
              row.PersonName === PersonName &&
              row.EmailID === EmailID &&
              row.MobileNumber === MobileNumber
          );

          if (isDuplicate) return;

          // Find existing Hall record with same EmailID
          const existingHallUser = targetList.find(
            (row) =>
              row.EmailID &&
              EmailID &&
              row.EmailID.toLowerCase() === EmailID.toLowerCase()
          );

          // Keep password only if Hall already has one
          const replicatedPassword =
            existingHallUser && existingHallUser.Password
              ? existingHallUser.Password
              : "";

          const blankIndex = targetList.findIndex(
            (row) =>
              !row.PersonName &&
              !row.EmailID &&
              !row.MobileNumber
          );

          if (blankIndex !== -1) {
            targetList[blankIndex] = {
              ...targetList[blankIndex],
              PersonName,
              EmailID,
              MobileNumber,
              Password: replicatedPassword,
              ActionID:
                targetList[blankIndex].ActionID === 0
                  ? 2
                  : targetList[blankIndex].ActionID,
            };
          } else {
            targetList.push({
              ...targetList[targetList.length - 1],
              PersonName,
              EmailID,
              MobileNumber,
              Password: replicatedPassword,
              ActionID: 1,
              SelectedDates: null,
              AllocatedDateIDs: "",
              HallIDs: "",
              SelectedHalls: "",
              SelectedShifts: [],
              selectedHallZoneList: [],
              HallZoneList: this.state.HallZoneList,
              ShiftList:
                dayType === "Event"
                  ? this.state.EventDaysShiftList
                  : dayType === "Dismantling"
                    ? this.state.hallDismantlingDaysList
                    : this.state.PreSetupDaysShiftList,
            });
          }
        });

        return {
          ...page,
          [hallListMap[dayType]]: targetList,
        };
      });

      toastSuccess("Successfully replicated!");

      return {
        SectionPageList: updatedList,
      };
    });
  }

  ReplicateAll(sectionPageName, sectionName, targetSection) {
    const page = this.state.SectionPageList.find(
      (p) => p.SectionPageName === sectionPageName
    );
    if (!page) return;

    const sourceListName =
      sectionName === "Staff"
        ? "staffPreSetupDaysList"
        : "hallPreSetupDaysList";

    const sourceList = [...page[sourceListName]];

    const staffFields = ["PersonName", "EmailID", "MobileNumber", "DesignationID"];
    const hallFields = ["PersonName", "EmailID", "MobileNumber"];
    const fields = sectionName === "Staff" ? staffFields : hallFields;

    // 🔴 VALIDATE SOURCE LIST
    const hasFullyBlankRow = sourceList.some((row) =>
      fields.every((key) => !row[key] || row[key] === "")
    );

    const hasPartiallyFilledRow = sourceList.some((row) => {
      const filled = fields.filter((key) => row[key] && row[key] !== "").length;
      return filled > 0 && filled < fields.length;
    });

    if (hasFullyBlankRow || hasPartiallyFilledRow) {
      toastError("Fill all Pre-Setup rows before replicating.");
      return;
    }

    this.setState((prevState) => {
      const updatedList = prevState.SectionPageList.map((page) => {
        if (page.SectionPageName !== sectionPageName) return page;

        const updatedPage = { ...page };

        const targetListName =
          sectionName === "Staff"
            ? targetSection === "EventDays"
              ? "staffEventDaysList"
              : "staffDismantlingDaysList"
            : targetSection === "EventDays"
              ? "hallEventDaysList"
              : "hallDismantlingDaysList";

        let targetList = Array.isArray(updatedPage[targetListName])
          ? [...updatedPage[targetListName]]
          : [];
        sourceList.forEach((sourceRow) => {
          const cleanedRow = {
            ...sourceRow,
            SelectedHalls: null,
            SelectedShifts: [],
            SelectedDates: null,
            AllocatedDateIDs: '',
            HallIDs: '',
            SelectedHalls: '',
            selectedHallZoneList: [],
            HallZoneList: this.state.HallZoneList,
            Password: sourceRow.Password || null,
            ShiftList: targetSection === "EventDays" ? this.state.EventDaysShiftList : this.state.hallDismantlingDaysList
          };

          // 🟢 DUPLICATE CHECK
          const exactDuplicate = targetList.some((row) =>
            fields.every((key) => row[key] === cleanedRow[key])
          );
          if (exactDuplicate) return;

          // 🟡 FIND BLANK ROW TO UPDATE
          const blankRowIndex = targetList.findIndex((row) =>
            fields.every((key) => !row[key] || row[key] === "")
          );

          if (blankRowIndex !== -1) {
            let isUpdated = false;
            const updatedRow = { ...targetList[blankRowIndex] };

            fields.forEach((key) => {
              if (!updatedRow[key] && cleanedRow[key]) {
                updatedRow[key] = cleanedRow[key];
                isUpdated = true;
              }
            });

            if (isUpdated) {
              updatedRow.ActionID = 2;
              targetList[blankRowIndex] = updatedRow;
            }
          } else {
            // 🔵 ADD NEW ROW
            targetList.push({
              ...cleanedRow,
              ActionID: 1
            });
          }
        });

        updatedPage[targetListName] = targetList;
        return updatedPage;
      });

      toastSuccess("Successfully replicated!");
      console.log("updatedList--->", updatedList)
      return { SectionPageList: updatedList };
    });
  }

  closeChangePasswordModal = () => {
    this.setState({
      showChangePasswordModal: false,
      selectedUserId: null,
      old_pass: "",
      new_pass: "",
      confirm_pass: "",
      old_passErr: "",
      new_passErr: "",
      confirm_passErr: "",
      is_showOldpass: false,
      is_showConfirmpass: false,
      is_showNewpass: false,
    });
  };

  handleObscurePassword = (pass) => {
    const { is_showOldpass, is_showConfirmpass, is_showNewpass } = this.state;
    if (pass === 'new_pass') {
      this.setState({ is_showNewpass: !is_showNewpass });
    } else if (pass === 'old_pass') {
      this.setState({ is_showOldpass: !is_showOldpass });
    } else if (pass === 'confirm_pass') {
      this.setState({ is_showConfirmpass: !is_showConfirmpass });
    }
  };

  inputValidatePassword = () => {
    const { old_pass, new_pass, confirm_pass } = this.state;
    if (old_pass === "") {
      this.setState({ old_passErr: "Please Enter Current Password" });
    }
    if (new_pass === "") {
      this.setState({ new_passErr: "Please Enter New password" });
    }
    if (new_pass !== "") {
      var passErr = newPasswordValidator(new_pass);
      if (passErr !== "") {
        this.setState({ new_passErr: passErr });
        return;
      }
    }
    if (confirm_pass === "") {
      this.setState({ confirm_passErr: "Please Enter Confirm Password" });
    }
    if (confirm_pass !== "") {
      if (new_pass !== confirm_pass) {
        this.setState({ confirm_passErr: "New password and Confirm password should be same" });
      } else {
        this.setState({ confirm_passErr: "" });
      }
    }
  };

  updatePasswordModal = () => {
    const { selectedUserId } = this.state;
    this.inputValidatePassword();
    setTimeout(() => {
      const { old_pass, new_pass, confirm_pass, old_passErr, new_passErr, confirm_passErr } = this.state;
      if (old_pass !== "" && new_pass !== "" && confirm_pass !== "" && new_pass === confirm_pass) {
        if (old_passErr === "" && new_passErr === "" && confirm_passErr === "") {
          this.setState({ isLoading: true });
          this.props.updatePassword_action(old_pass, new_pass, selectedUserId)
            .then((data) => {
              if (data.error != 1) {
                this.setState({ isLoading: false });
                toastSuccess("Password Changed Successfully");
                this.closeChangePasswordModal();
                window.location.reload();
              } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
              }
            }).catch((e) => {
              console.log(e);
              this.setState({ isLoading: false });
            });
        }
      } else {
        this.setState({ isLoading: false });
        toastError("Please Check Your Password");
      }
    }, 500);
  };

  TagRead = () => {
    const { ExhibitionID, SectionPageList, isVendor, WorkOrderID } = this.state;
    const array1 = []
    for (const item of SectionPageList) {
      for (const o of item.DeliverablesServicesList) {
        array1.push({
          WorkOrderDeliverablesID: o.WorkOrderDeliverablesID,
          // IsDeliverablesRead: isVendor && (o.VendorActivity == 1) && o.IsDeliverablesRead || !isVendor && (o.VendorActivity == 2) && o.IsDeliverablesRead,
          // IsDocumentRead: isVendor && (o.VendorActivity == 1) && o.IsDocumentRead || !isVendor && (o.VendorActivity == 2) && o.IsDocumentRead,
          IsDeliverablesRead: true,
          IsDocumentRead: isVendor ? (o.VendorActivity == 2) && o.IsDocumentRead : (o.VendorActivity == 1) && o.IsDocumentRead,
          VendorActivity: !isVendor ? 1 : 2,
          DocumentRefNo: o.DocumentRefNo,
        });
      }
    }
    this.props.SOWTagRead_action(ExhibitionID, WorkOrderID, array1)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      }).catch((e) => {
        console.log(e);
        this.setState({ isLoading: false });
      });
  };

  isInstructionOrDocUpdateTag = (value) => {
    const { ExhibitionID, SectionPageList, WorkOrderID, isVendor } = this.state;
    const array1 = []
    for (const item of SectionPageList) {
      for (const o of item.DeliverablesServicesList) {
        if (o.isInstructionOrDocUpdate) {
          array1.push({
            WorkOrderDeliverablesID: o.WorkOrderDeliverablesID,
            IsDeliverablesRead: true,
            IsDocumentRead: false,
            VendorActivity: !isVendor ? 1 : 2,
            DocumentRefNo: o.DocumentRefNo,
          });
        }
      }
    }
    this.props.SOWTagRead_action(ExhibitionID, WorkOrderID, array1)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      }).catch((e) => {
        console.log(e);
        this.setState({ isLoading: false });
      });
  };

  getDeliverablesDocumentLog = (WorkOrderDeliverablesID) => {
    const { ExhibitionID, SectionPageList, isVendor, WorkOrderID } = this.state;

    this.props.getDeliverablesDocumentLog_action(ExhibitionID, WorkOrderID, WorkOrderDeliverablesID)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false, commentList: data.data, isCommentPop: true });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      }).catch((e) => {
        console.log(e);
        this.setState({ isLoading: false });
      });
  };

  createZoneManagerTeamMember = () => {
    const { ExhibitionID, SectionPageList, isVendor, WorkOrderID, ZoneManagerUserName } = this.state;

    this.props.createZoneManagerTeamMember_action(ExhibitionID, ZoneManagerUserName)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false, isConfirmPop: false });
          toastSuccess("Zone manager created successfully")
          this.getWorkOrderDetails()
        } else {
          this.setState({ isLoading: false, isConfirmPop: false });
          toastError(data.msg);
        }
      }).catch((e) => {
        console.log(e);
        this.setState({ isLoading: false });
      });
  };

  deleteZoneManagerTeamMember = () => {
    const { ExhibitionID, SectionPageList, isVendor, WorkOrderID, ZoneManagerUserName } = this.state;

    this.props.deleteZoneManagerTeamMember_action(ExhibitionID, ZoneManagerUserName)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false, isConfirmPop: false });
          toastSuccess("Zone manager deleted successfully")
          this.getWorkOrderDetails()
        } else {
          this.setState({ isLoading: false, isConfirmPop: false });
          toastError(data.msg);
        }
      }).catch((e) => {
        console.log(e);
        this.setState({ isLoading: false });
      });
  };

  viewDocTag = (WorkOrderDeliverablesID, index) => {
    const { ExhibitionID, SectionPageList, isVendor, WorkOrderID } = this.state;
    const array1 = []
    array1.push({
      WorkOrderDeliverablesID: WorkOrderDeliverablesID,
      IsDeliverablesRead: true,
      IsDocumentRead: true,
      VendorActivity: !isVendor ? 1 : 2,
      DocumentRefNo: index,
    });

    this.props.SOWTagRead_action(ExhibitionID, WorkOrderID, array1)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          this.getWorkOrderDetails()
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      }).catch((e) => {
        console.log(e);
        this.setState({ isLoading: false });
      });
  };

  handleAddMoreClick = (data, sectionPage) => {
    const { FormStatusID } = this.state;

    // if (FormStatusID) {
    //   this.setState({ showRevokePlanModal: true });
    // } else {
    this.DeliveryServicesPop(
      "isAdd",
      data.DeliverablesServicesList.length,
      sectionPage,
      "DeliverablesServices",
      false
    );
    // }
  };

  closeRevokePlanModal = () => {
    this.setState({ showRevokePlanModal: false });
  };

  // Action columns are driven by the getXXXActions lists below - the column header and the row
  // icons are built from the same list, so a header can never advertise an icon the rows do not
  // render. buildActionHeader joins the labels of whatever is actually shown, e.g. "Clear/Delete"
  buildActionHeader(actions, fallback = "ACTIONS") {
    const labels = actions
      .filter((action) => action.isVisible)
      .map((action) => action.label);
    return labels.length > 0 ? "ACTIONS" : fallback;
  }

  renderRowActions(actions, separator = null) {
    return actions
      .filter((action) => action.isVisible)
      .map((action, index) => (
        <React.Fragment key={action.label}>
          {index > 0 && separator}
          {action.render()}
        </React.Fragment>
      ));
  }

  // Deliverables Services grid
  getDeliverablesServiceActions(isView, isVendor, sectionPage, index) {
    const canEdit = !isView && !isVendor;
    return [
      {
        label: "Edit",
        isVisible: canEdit,
        render: () => (
          <i
            class="fa fa-pencil grid-icon"
            aria-hidden="true"
            onClick={() =>
              this.DeliveryServicesPop("isUpdate", index, sectionPage, "", false)
            }
          ></i>
        ),
      },
      {
        label: "Delete",
        isVisible: canEdit,
        render: () => (
          <i
            className="fa fa-trash text-danger"
            onClick={() =>
              this.handleRemoveSectionPageList(
                sectionPage,
                "DeliverablesServices",
                index
              )
            }
          />
        ),
      },
    ];
  }

  // Organizer Responsibilities grid - the row can only be deleted while more than one is left
  getOrganizerResponsibilityActions(isView, isVendor, canDelete, sectionPage, index) {
    const canEdit = !isView && !isVendor;
    return [
      {
        label: "Clear",
        isVisible: canEdit,
        render: () => (
          <i
            class="fa fa-times grid-icon"
            aria-hidden="true"
            onClick={() =>
              this.handleClearSectionPageList(
                sectionPage,
                "OrganizerResponsibilities",
                index
              )
            }
          ></i>
        ),
      },
      {
        label: "Delete",
        isVisible: canEdit && canDelete,
        render: () => (
          <i
            className="fa fa-trash ml-2 text-danger"
            onClick={() =>
              this.handleRemoveSectionPageList(
                sectionPage,
                "OrganizerResponsibilities",
                index
              )
            }
          />
        ),
      },
    ];
  }

  // Staff / Hall day grids - the pre setup grids additionally offer the Event and Dismantle copies
  getDayColumnActions({
    isView,
    sectionPage,
    listKey,
    listLength,
    replicateGroup,
    showCopyActions,
    index,
  }) {
    return [
      {
        label: "Event",
        isVisible: !isView && showCopyActions,
        render: () => (
          <div
            className="copy-icon-box text-center"
            onClick={() =>
              this.Replicate(sectionPage, replicateGroup, index, "EventDays")
            }
            style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer', margin: '0 8px' }}
          >
            <i className="fa fa-clone" style={{ fontSize: '14px', color: '#6b7280' }}></i>
            <span style={{ fontSize: '9px', marginTop: '4px', fontWeight: 'bold', color: '#6b7280' }}>EVENT</span>
          </div>
        ),
      },
      {
        label: "Dismantle",
        isVisible: !isView && showCopyActions,
        render: () => (
          <div
            className="copy-icon-box text-center"
            onClick={() =>
              this.Replicate(
                sectionPage,
                replicateGroup,
                index,
                "DismantlingDays"
              )
            }
            style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer', margin: '0 8px' }}
          >
            <i className="fa fa-clone" style={{ fontSize: '14px', color: '#6b7280' }}></i>
            <span style={{ fontSize: '9px', marginTop: '4px', fontWeight: 'bold', color: '#6b7280' }}>DISMANTLE</span>
          </div>
        ),
      },
      {
        label: "Clear",
        isVisible: !isView && listKey !== "hallPreSetupDaysList" && listKey !== "hallEventDaysList" && listKey !== "hallDismantlingDaysList" && listKey !== "teamMemberPreSetupDaysList" && listKey !== "teamMemberEventDaysList" && listKey !== "teamMemberDismantlingDaysList",
        render: () => (
          <div
            className="text-center"
            onClick={() =>
              this.handleClearSectionPageList(sectionPage, listKey, index)
            }
            style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer', margin: '0 8px' }}
          >
            <i className="fa fa-times" style={{ fontSize: '14px', color: '#6b7280' }}></i>
            <span style={{ fontSize: '9px', marginTop: '4px', fontWeight: 'bold', color: '#6b7280' }}>CLEAR</span>
          </div>
        ),
      },
      {
        label: "Delete",
        isVisible: !isView,
        render: () => (
          <div
            className="text-center"
            onClick={() =>
              this.handleRemoveSectionPageList(sectionPage, listKey, index)
            }
            style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer', margin: '0 8px' }}
          >
            <i className="fa fa-trash" style={{ fontSize: '14px', color: '#6b7280' }}></i>
            <span style={{ fontSize: '9px', marginTop: '4px', fontWeight: 'bold', color: '#6b7280' }}>DELETE</span>
          </div>
        ),
      },
    ];
  }

  // Documents grid - the last remaining document row can be cleared but not deleted
  getDocumentActions(isView, canDelete, index) {
    return [
      {
        label: "Clear",
        isVisible: !isView,
        render: () => (
          <i
            class="fa fa-times grid-icon"
            aria-hidden="true"
            onClick={(e) => this.documentHandleInput(e, index, "clear")}
          ></i>
        ),
      },
      {
        label: "Delete",
        isVisible: !isView && canDelete,
        render: () => (
          <i
            className="fa fa-trash ml-2 text-danger"
            onClick={(e) => this.documentHandleInput(e, index, "delete")}
          />
        ),
      },
    ];
  }

  // Compliance Requirements grid nested inside a Deliverables Service row
  getComplianceRequirementActions(isView, isVendor, sectionPage, index, compIndex) {
    const canEdit = !isView && !isVendor;
    return [
      {
        label: "Clear",
        isVisible: canEdit,
        render: () => (
          <i
            class="fa fa-times grid-icon"
            aria-hidden="true"
            onClick={() =>
              this.handleClearSectionPageList(
                sectionPage,
                "DeliverablesServices",
                index,
                "ComplianceRequirementsList",
                compIndex
              )
            }
          ></i>
        ),
      },
      {
        label: "Delete",
        isVisible: canEdit,
        render: () => (
          <i
            className="fa fa-trash ml-2 text-danger"
            onClick={() =>
              this.handleRemoveSectionPageList(
                sectionPage,
                "DeliverablesServices",
                index,
                "ComplianceRequirementsList",
                compIndex
              )
            }
          />
        ),
      },
    ];
  }

  render() {
    const {
      isInstruction,
      isLoading,
      summaryPage,
      sectionPage,
      workOrderServices,
      WorkOrderServiceList,
      SectionPageList,
      ExhibitionID,
      vendorId,
      vendorList,
      exhibitionList,
      StartDate,
      EndDate,
      WorkOrderNumber,
      PersonName,
      EmailID,
      MobileNumber,
      documentList,
      isDeliveryServicesPop,
      DeliveryServicesIndex,
      isScopeOfWorkPop,
      StaffSectionHallPop,
      StaffSectionIndex,
      StaffSectionShiftPop,
      staffSectionTableName,
      isDeliveryServicesPopFlag,
      update,
      replicate,
      isView,
      isVendor,
      isHallPop,
      isAddDeliveryServicesPop,
      isHallManager,
      isWorkUpdation,
      AccesibleList,
      DeliverablesPricingList,
      FormStatusID,
      RoleID,
      visibleIndexPassword,
      showChangePasswordModal,
      selectedUserId,
      isCommentPop,
      commentList,
      isConfirmPop,
      isCreateZoneManagerTeamMember
    } = this.state;
    const toInputUppercase = (e) => {
      e.target.value = ("" + e.target.value).toUpperCase();
    };
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {!isHallManager && (
          <>
            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
              <ExhibitorHeader />
            ) : (
              <HeaderWithLogo />
            )}
            {(JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7 || JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 17) &&
              !isHallManager ? (
              <VendorDrawer />
            ) : (
              <AdminDrawer />
            )}
          </>
        )}
        <div
          className={
            isHallManager ? "" : "app-content with-dr-container com-height"
          }
          style={{
            marginTop: isWorkUpdation
              ? 0
              : (JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7 || JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 17)
                ? 0
                : "",
          }}
        >
          {/* <div class="row">
          <div class="step-name">
            <p>Scope of work List</p>
          </div>
        </div> */}
          <div className={"navg mt-0"} style={{ paddingBottom: '80px' }}>
            <ul className="nav nav-pills tab-scroll-fixed">
              <li
                onClick={() =>
                  this.setState({ summaryPage: "WorkOrderDetails" })
                }
                className="nav-item "
              >
                {" "}
                <a
                  className={
                    summaryPage == "WorkOrderDetails"
                      ? "nav-link active px-4 py-2"
                      : "nav-link  px-4 py-1"
                  }
                >
                  Scope of work Details{" "}
                </a>{" "}
              </li>&emsp;&nbsp;
              <li
                // onClick={() =>
                //   this.setState({ summaryPage: "WorkOrderDocument" })
                // }
                className="nav-item "
              >
                {" "}
                <a
                // className={
                //   summaryPage == "WorkOrderDocument"
                //     ? "nav-link active px-4 py-2"
                //     : "nav-link  px-3 py-2"
                // }
                >
                  Scope of work {" "}
                </a>{" "}
              </li>
            </ul>
          </div>

          <div className="work-order admin-top-space" style={{ paddingBottom: '80px' }}>
            {summaryPage == "WorkOrderDetails" ? (
              <>
                <div className="row m-0">
                  <div className="col-md-4">
                    <label className="col-form-label">
                      Exhibition<span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control"
                      id="roledb"
                      // style={{ textAlign: "left" }}
                      disabled={true}
                      value={ExhibitionID}
                      onChange={(e) => this.onExhibitionSelect(e)}
                    >
                      {/* <option value={null}>Select</option> */}
                      {exhibitionList.length > 0 &&
                        exhibitionList.map((data) => (
                          <option
                            key={data.ExhibitionID}
                            value={data.ExhibitionID}
                          >
                            {data.ExhibitionName}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="col-form-label">
                      Service Partner<span className="text-danger">*</span>
                    </label>
                    <select
                      disabled={
                        isView || isVendor || (replicate ? false : update)
                      }
                      className="form-control"
                      id="roledb"
                      // style={{ textAlign: "left" }}
                      value={vendorId}
                      onChange={(e) => this.selectVendor(e)}
                    >
                      <option value={""}>Select</option>
                      {vendorList.length > 0 &&
                        vendorList.map((data) => (
                          <option key={data.AccountID} value={data.AccountID}>
                            {data.CompanyName}
                          </option>
                        ))}
                    </select>
                    {
                      <span className="text-danger text-start text-left d-block">
                        {this.state.vendorIdErr}
                      </span>
                    }
                  </div>
                  <div className="col-md-4">
                    <label className="col-form-label">
                      {" "}
                      Work Order Number<span className="text-danger">*</span>
                    </label>
                    <input
                      disabled={
                        isView || isVendor || (replicate ? false : update)
                      }
                      type="text"
                      className="form-control"
                      maxLength={50}
                      value={WorkOrderNumber}
                      onChange={(e) =>
                        this.setState({
                          WorkOrderNumber: e.target.value.replace(
                            /[^A-Za-z0-9]/g,
                            ""
                          ),
                          WorkOrderNumberErr: "",
                        })
                      }
                    />
                    {
                      <span className="text-danger text-start text-left d-block">
                        {this.state.WorkOrderNumberErr}
                      </span>
                    }
                  </div>
                </div>
                <div className="row m-0">
                  <div className="col-md-4">
                    <label className="col-form-label">
                      Person Name<span className="text-danger">*</span>
                    </label>
                    <input
                      // disabled={isView || isVendor}
                      disabled={true}
                      type="text"
                      className="form-control"
                      maxLength={100}
                      value={PersonName}
                      onChange={(e) =>
                        this.setState({
                          PersonName: e.target.value.replace(/[^a-zA-Z ]/g, ""),
                          PersonNameErr: "",
                        })
                      }
                    />
                    {
                      <span className="text-danger text-start text-left d-block">
                        {this.state.PersonNameErr}
                      </span>
                    }
                  </div>
                  <div className="col-md-4">
                    <label className="col-form-label">
                      Email ID<span className="text-danger">*</span>
                    </label>
                    <input
                      // disabled={isView || isVendor}
                      disabled={true}
                      type="text"
                      className="form-control"
                      maxLength={100}
                      value={EmailID}
                      onChange={(e) =>
                        this.setState({
                          EmailID: e.target.value,
                          EmailIDErr: "",
                        })
                      }
                    />
                    {
                      <span className="text-danger text-start text-left d-block">
                        {this.state.EmailIDErr}
                      </span>
                    }
                  </div>
                  <div className="col-md-4">
                    <label className="col-form-label">
                      Mobile Number<span className="text-danger">*</span>
                    </label>
                    <input
                      // disabled={isView || isVendor}
                      disabled={true}
                      type="text"
                      className="form-control"
                      maxLength={20}
                      value={MobileNumber}
                      onChange={(e) =>
                        this.setState({
                          MobileNumber: e.target.value.replace(/\D/g, ""),
                          MobileNumberErr: "",
                        })
                      }
                    />
                    {
                      <span className="text-danger text-start text-left d-block">
                        {this.state.MobileNumberErr}
                      </span>
                    }
                  </div>
                </div>
                <div className="row m-0">
                  <div className="col-md-4">
                    <label className="col-form-label">
                      Scope of work Services
                      <span className="text-danger">*</span>
                    </label>
                    <Select
                      isDisabled={
                        isView || isVendor || (replicate ? false : update)
                      }
                      className="text-left"
                      options={WorkOrderServiceList.map((option) => ({
                        label: option.Name,
                        value: option.ServiceID,
                      }))}
                      value={workOrderServices}
                      onChange={(e) => this.onChangeWorkOrderService(e)}
                      isMulti
                      styles={{
                        multiValueRemove: (base, state) => ({
                          ...base,
                          display:
                            isView || isVendor || (replicate ? false : update)
                              ? "none"
                              : "block",
                        }),
                      }}
                    />
                    {
                      <span className="text-danger text-start text-left d-block">
                        {this.state.workOrderServicesErr}
                      </span>
                    }
                  </div>
                  <div className="col-md-8 mb-4">
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">
                          Start Date<span className="text-danger">*</span>
                        </label>
                        {/* <DatePicker
                          selected={StartDate}
                          disabled={isView || isVendor}
                          minDate={new Date()}
                          dateFormat={"dd/MM/yyyy"}
                          className="form-control"
                          onChange={(date) =>
                            this.setState({
                              StartDate: date,
                              EndDate: null,
                              StartDateErr: "",
                            })
                          }
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          placeholderText="dd/mm/yyyy"
                          dayClassName={() => "example-datepicker-day-class"}
                          popperClassName="example-datepicker-class"
                        /> */}

                        <DatePicker
                          selected={StartDate}
                          disabled={isView || isVendor}
                          minDate={new Date()}
                          onChange={(date) =>
                            this.setState({
                              StartDate: date,
                              EndDate: null,
                              StartDateErr: "",
                            })
                          }
                          showTimeSelect
                          timeFormat="HH:mm"
                          timeIntervals={1} // choose time in 15-min steps
                          dateFormat="dd-MM-yyyy HH:mm"
                          placeholderText="Select date and time"
                          className="form-control"
                        />
                        {
                          <span className="text-danger text-start text-left d-block">
                            {this.state.StartDateErr}
                          </span>
                        }
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label">
                          End Date<span className="text-danger">*</span>
                        </label>
                        {/* <DatePicker
                          selected={EndDate}
                          dateFormat={"dd/MM/yyyy"}
                          className="form-control"
                          onChange={(date) =>
                            this.setState({ EndDate: date, EndDateErr: "" })
                          }
                          minDate={StartDate}
                          disabled={!StartDate || isView || isVendor}
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          placeholderText="dd/mm/yyyy"
                          dayClassName={() => "example-datepicker-day-class"}
                          popperClassName="example-datepicker-class"
                        /> */}

                        <DatePicker
                          selected={EndDate}
                          disabled={!StartDate || isView || isVendor}
                          onChange={(date) =>
                            this.setState({ EndDate: date, EndDateErr: "" })
                          }
                          minDate={StartDate}
                          showTimeSelect
                          timeFormat="HH:mm"
                          timeIntervals={1} // choose time in 15-min steps
                          dateFormat="dd-MM-yyyy HH:mm"
                          placeholderText="Select date and time"
                          className="form-control"
                        />
                        {
                          <span className="text-danger text-start text-left d-block">
                            {this.state.EndDateErr}
                          </span>
                        }
                      </div>
                    </div>
                  </div>
                </div>

                {/* {workOrderServices.length > 0 && */}
                <>
                  <div className="row m-0 mx-2 px-1">
                    <ul
                      className="nav nav-pills"
                      style={{ borderBottom: "1px solid #00000030" }}
                    >
                      {workOrderServices.map((item) => (
                        <li
                          onClick={() =>
                            this.setState({ sectionPage: item.label })
                          }
                          className=""
                        >
                          {" "}
                          <a
                            style={{
                              borderRadius: "5px 5px 0 0",
                              border: "1px solid #00000030",
                            }}
                            className={
                              sectionPage == item.label
                                ? "nav-link tab-design active px-4 py-1"
                                : "nav-link  px-4 py-1"
                            }
                          >
                            {item.label}{" "}
                          </a>{" "}
                        </li>
                      ))}
                    </ul>
                  </div>
                  {SectionPageList.length > 0 &&
                    SectionPageList.map((data) => (
                      <>
                        {data.SectionPageName == sectionPage && (
                          <div className="row m-0">
                            <div className="card py-3 pb-0 mb-1 pt-0">
                              <div className="card-body px-0 pb-0 pt-0">
                                {/* Default Tabs */}
                                <div className="tab-content" id="myTabContent">
                                  <div
                                    className="tab-pane fade show active bg-white"
                                    id="home"
                                    role="tabpanel"
                                    aria-labelledby="home-tab"
                                  >
                                    <div className="row">
                                      <div className="col-md-4">
                                        <label className="col-form-label">
                                          Plan Submission Date
                                          <span className="text-danger">*</span>
                                        </label>
                                        <DatePicker
                                          minDate={new Date()}
                                          selected={
                                            data.PlanSubmissionDate
                                              ? moment(
                                                data.PlanSubmissionDate
                                              ).toDate()
                                              : null
                                          }
                                          disabled={isView || isVendor}
                                          onChange={(e) =>
                                            this.handleInputSectionPageList(
                                              "varchra",
                                              sectionPage,
                                              "PlanSubmissionDate",
                                              e,
                                              "",
                                              "PlanSubmissionDate"
                                            )
                                          }
                                          showTimeSelect
                                          timeFormat="HH:mm"
                                          timeIntervals={1} // choose time in 15-min steps
                                          dateFormat="dd-MM-yyyy HH:mm"
                                          placeholderText="Select date and time"
                                          className="form-control"
                                        />
                                      </div>
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center mt-2 mb-1">
                                      <div>
                                        <h6 className="section-title mb-0  fw-semibold mt-2 mb-1">
                                          Deliverables Services
                                        </h6>
                                        <p className="text-danger text-left m-0">(If you want to change any instructions or documents, kindly update or delete them, and then upload the updated file)</p>
                                      </div>
                                      {!isVendor && (
                                        <button
                                          disabled={isView || isVendor}
                                          className="btn btn-aqua px-2 p-1"
                                          id="addMoreBtn"
                                          onClick={() =>
                                            this.DeliveryServicesPop(
                                              "isAdd",
                                              data.DeliverablesServicesList
                                                .length,
                                              sectionPage,
                                              "DeliverablesServices",
                                              false
                                            )
                                          }
                                        >
                                          Add More
                                        </button>
                                      )}
                                    </div>

                                    {/* Mobile/Tablet Card View */}
                                    <div className="d-block d-lg-none mb-3">
                                      {data.DeliverablesServicesList.length > 0 ? (
                                        data.DeliverablesServicesList.map((item, index) => (
                                          <div className="card mb-3 border shadow-sm p-0" style={{ borderRadius: '12px' }} key={index}>
                                            <div
                                              className="card-header bg-white d-flex align-items-center justify-content-between p-3 border-bottom-0"
                                              data-bs-toggle="collapse"
                                              data-bs-target={`#collapseDeliverable_${sectionPage.replace(/\s+/g, '')}_${index}`}
                                              style={{ cursor: 'pointer', borderRadius: '12px 12px 0 0' }}
                                            >
                                              <div className="d-flex align-items-start w-100 me-2">
                                                <div className="rounded-circle d-flex align-items-center justify-content-center me-3 shrink-0" style={{ width: '32px', height: '32px', backgroundColor: '#eef2fb', color: '#1a365d', fontSize: '14px', fontWeight: '500', minWidth: '32px' }}>
                                                  {index + 1}
                                                </div>
                                                <h6 className="mb-0" style={{ color: '#1a365d', fontSize: '13px', lineHeight: '1.4', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                                  {item.MainServiceDeliverablesName || "-"}
                                                </h6>
                                              </div>
                                              <i className="fa fa-angle-down text-dark"></i>
                                            </div>
                                            <div id={`collapseDeliverable_${sectionPage.replace(/\s+/g, '')}_${index}`} className="collapse show">
                                              <div className="card-body pt-0 px-3 pb-3">
                                                <div className="row g-2">
                                                  <div className="col-6">
                                                    <div className="border rounded p-2 h-100 d-flex flex-column justify-content-center text-center" style={{ backgroundColor: '#f8f9fa' }}>
                                                      <div className="text-secondary mb-2" style={{ fontSize: '11px', fontWeight: '500' }}>Compliance Requirements</div>
                                                      <div className="d-flex justify-content-center">
                                                        <i onClick={() => this.DeliveryServicesPop("isUpdate", index, sectionPage, "", false)} className="fa fa-eye" style={{ cursor: 'pointer', fontSize: '18px', color: '#1a365d' }}></i>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="col-6">
                                                    <div className="border rounded p-2 h-100 d-flex flex-column justify-content-center text-center">
                                                      <div className="text-secondary mb-1" style={{ fontSize: '11px', fontWeight: '500' }}>Quantity</div>
                                                      <div className="fw-bold" style={{ fontSize: '13px', color: '#1a365d' }}>{item.Quantity || "-"}</div>
                                                    </div>
                                                  </div>
                                                  <div className="col-6">
                                                    <div className="border rounded p-2 h-100 d-flex flex-column justify-content-center text-center">
                                                      <div className="text-secondary mb-1" style={{ fontSize: '11px', fontWeight: '500' }}>Price (INR)</div>
                                                      <div className="fw-bold" style={{ fontSize: '13px', color: '#1a365d' }}>{item.VendorExhibitorPriceInINR || "-"}</div>
                                                    </div>
                                                  </div>
                                                  <div className="col-6">
                                                    <div className="border rounded p-2 h-100 d-flex flex-column justify-content-center text-center">
                                                      <div className="text-secondary mb-1" style={{ fontSize: '11px', fontWeight: '500' }}>Price (USD)</div>
                                                      <div className="fw-bold" style={{ fontSize: '13px', color: '#1a365d' }}>{item.VendorExhibitorPriceInUSD || "-"}</div>
                                                    </div>
                                                  </div>
                                                  {!isVendor && (
                                                    <>
                                                      <div className="col-6">
                                                        <div className="border rounded p-2 h-100 d-flex flex-column justify-content-center text-center">
                                                          <div className="text-secondary mb-1" style={{ fontSize: '11px', fontWeight: '500' }}>ITME Price (INR)</div>
                                                          <div className="fw-bold" style={{ fontSize: '13px', color: '#1a365d' }}>{item.VendorOrganizerPriceInINR || "-"}</div>
                                                        </div>
                                                      </div>
                                                      <div className="col-6">
                                                        <div className="border rounded p-2 h-100 d-flex flex-column justify-content-center text-center">
                                                          <div className="text-secondary mb-1" style={{ fontSize: '11px', fontWeight: '500' }}>ITME Price (USD)</div>
                                                          <div className="fw-bold" style={{ fontSize: '13px', color: '#1a365d' }}>{item.VendorOrganizerPriceInUSD || "-"}</div>
                                                        </div>
                                                      </div>
                                                    </>
                                                  )}
                                                  <div className="col-6">
                                                    <div className="border rounded p-2 h-100 d-flex flex-column justify-content-center text-center">
                                                      <div className="text-secondary mb-2" style={{ fontSize: '11px', fontWeight: '500' }}>Available</div>
                                                      <div className="d-flex justify-content-center">
                                                        <Switch
                                                          onChange={(e) => this.handleInputSectionPageList("varchar", sectionPage, "DeliverablesServices", e, index, "IsStockAvailable")}
                                                          checked={item.IsStockAvailable}
                                                          onColor="#0d6efd"
                                                          offColor="#fff"
                                                          offHandleColor="#6c757d"
                                                          uncheckedIcon={false}
                                                          checkedIcon={false}
                                                          disabled={isView}
                                                          handleDiameter={14}
                                                          height={20}
                                                          width={36}
                                                          className="border rounded-pill"
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="col-6">
                                                    <div className="border rounded p-2 h-100 d-flex flex-column justify-content-center text-center">
                                                      <div className="text-secondary mb-1" style={{ fontSize: '11px', fontWeight: '500' }}>Action</div>
                                                      <div className="fw-bold" style={{ fontSize: '13px', color: '#1a365d' }}>
                                                        {!isView && !isVendor ? (
                                                          this.renderRowActions(this.getDeliverablesServiceActions(isView, isVendor, sectionPage, index), <span style={{ color: "#ccc" }}> | </span>)
                                                        ) : (
                                                          "-"
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        ))
                                      ) : (
                                        <div className="text-center p-3 text-muted border rounded bg-light">Record not found</div>
                                      )}
                                    </div>

                                    {/* Desktop Table View */}
                                    <div class="table-responsive sticky-table-wrapper d-none d-lg-block">
                                      <table class="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0">
                                        <thead class="table-light sticky-top" style={{ zIndex: 9 }}>
                                          <tr>
                                            <th style={{ width: 150 }}>
                                              Deliverables Service
                                            </th>
                                            {/* <th>
                                          Scope of Work<span className="text-danger">*</span>
                                        </th> */}
                                            {/* <th>Logistics Responsibilities</th> */}
                                            <th className="text-center" style={{ width: isVendor ? 10 : '' }}>
                                              Compliance Requirements
                                            </th>
                                            {/* <th style={{ width: 100 }}>Manpower</th> */}
                                            {/* <th className="text-center">
                                          Start and End Date Time<span className="text-danger">*</span>
                                        </th> */}
                                            {!isVendor &&
                                              <th className="text-center" style={{ width: isVendor ? 10 : '' }}>
                                                Quantity
                                              </th>
                                            }
                                            <th className="text-center">
                                              Instructions
                                            </th>
                                            <th className="text-center" style={{ width: '10px' }}>
                                              Documents
                                            </th>
                                            {/* <th className="text-center">
                                              Revert Required
                                            </th> */}
                                            {!isVendor &&
                                              <th
                                                colSpan={2}
                                                className="text-center"
                                              >
                                                Service Partner Rate
                                              </th>
                                            }
                                            {!isVendor && (
                                              <th
                                                colSpan={2}
                                                className="text-center"
                                              >
                                                Itme Rate
                                              </th>
                                            )}
                                            {!isVendor &&
                                              <th
                                                style={{ width: 50 }}
                                                className="text-center"
                                              >
                                                Available
                                              </th>
                                            }
                                            {!isVendor &&
                                              <th
                                                style={{ width: 50 }}
                                                className="text-center"
                                              >
                                                {this.buildActionHeader(
                                                  this.getDeliverablesServiceActions(
                                                    isView,
                                                    isVendor
                                                  ),
                                                  "Action"
                                                )}
                                              </th>
                                            }
                                          </tr>

                                          {!isVendor &&
                                            <tr>
                                              <th colSpan={5} />
                                              <th className="text-center">
                                                Price (INR)
                                              </th>
                                              <th className="text-center">
                                                Price (USD)
                                              </th>
                                              <th className="text-center">
                                                Price (INR)
                                              </th>
                                              <th className="text-center">
                                                Price (USD)
                                              </th>
                                              <th className="text-center">
                                                Yes / No
                                              </th>
                                              <th />
                                            </tr>
                                          }
                                        </thead>
                                        <tbody>
                                          {data.DeliverablesServicesList.length >
                                            0 ? (
                                            data.DeliverablesServicesList.map(
                                              (item, index) => (
                                                <tr>
                                                  <td className="wrap-break-td">
                                                    {item.MainServiceDeliverablesName ||
                                                      "-"}{" "}&nbsp;
                                                    {(!item.IsDeliverablesRead || (item.DocumentsList.length > 0 && !item.IsDocumentRead)) &&
                                                      <span
                                                        style={{
                                                          display: "inline-block",
                                                          marginLeft: "8px",
                                                          padding: "2px 8px",
                                                          fontSize: "11px",
                                                          fontWeight: "600",
                                                          color: "#fff",
                                                          backgroundColor: "#3dbca7",
                                                          borderRadius: "12px",
                                                          textTransform: "uppercase",
                                                          letterSpacing: "0.5px"
                                                        }}
                                                      >
                                                        New {!item.IsDeliverablesRead ? "Deliverable" : "Attachments"}
                                                      </span>
                                                    }
                                                  </td>
                                                  {/* <td className='text-center'>   <i onClick={() => this.DeliveryServicesPop('isUpdate', index, sectionPage, 'DeliverablesServices', true)} class="fa fa-eye" aria-hidden="true"></i></td> */}
                                                  {/* <td>{item.LogisticsResponsibilities || '-'}</td> */}
                                                  <td className="text-center">
                                                    {" "}
                                                    <i
                                                      onClick={() =>
                                                        this.DeliveryServicesPop(
                                                          "isUpdate",
                                                          index,
                                                          sectionPage,
                                                          "",
                                                          false
                                                        )
                                                      }
                                                      class="fa fa-eye grid-icon"
                                                      aria-hidden="true"
                                                    ></i>
                                                  </td>
                                                  {/* <td>{item.Manpower || '-'}</td> */}
                                                  {/* <td className="text-center">  {item.DeliverablesServicesStartDate &&
                                              moment(item.DeliverablesServicesStartDate).format("DD MMM YYYY HH:mm")} - {item.DeliverablesServicesEndDate &&
                                                moment(item.DeliverablesServicesEndDate).format("DD MMM YYYY HH:mm")}</td> */}
                                                  {!isVendor &&
                                                    <td className="text-center">
                                                      {" "}
                                                      {item.Quantity || "-"}
                                                    </td>
                                                  }
                                                  <td className="wrap-break-td" style={{ maxWidth: 150 }}>
                                                    {
                                                      item.Instructions ? (
                                                        <>
                                                          {item.Instructions}&nbsp;
                                                          <i className="fa fa-edit text-muted"
                                                            title="Update Instruction"
                                                            onClick={() =>
                                                              this.DeliveryServicesPop(
                                                                "isUpdate",
                                                                index,
                                                                sectionPage,
                                                                "",
                                                                false,
                                                                'Instruction'
                                                              )
                                                            }
                                                          ></i>
                                                        </>
                                                      ) : (
                                                        <p className="text-center">
                                                          <i className="fa fa-plus text-muted"
                                                            title="Add Instruction"
                                                            onClick={() =>
                                                              this.DeliveryServicesPop(
                                                                "isUpdate",
                                                                index,
                                                                sectionPage,
                                                                "",
                                                                false,
                                                                'Instruction'
                                                              )
                                                            }
                                                          ></i>
                                                        </p>
                                                      )
                                                    }
                                                    <i className="ri-message-3-line comment-his text-white"
                                                      onClick={() => this.getDeliverablesDocumentLog(item.WorkOrderDeliverablesID, index + 1)}
                                                      title='View Instructions/Documents'
                                                    ></i>
                                                  </td>
                                                  <td>
                                                    <div className="col-md-12">
                                                      {[0, 1].map((slotIndex) => {
                                                        const activeDocs = (item.DocumentsList || []).filter(
                                                          (d) => d.ActionID === 0 || d.ActionID === 1
                                                        );

                                                        const doc = activeDocs[slotIndex];

                                                        return (
                                                          <div key={slotIndex} className={`d-flex align-items-center gap-2 ${slotIndex == 1 ? "mb-3" : "mb-2"}`}>
                                                            {doc ? (
                                                              <>
                                                                <span
                                                                  className="text-aqua"
                                                                  style={{
                                                                    cursor: "pointer",
                                                                    whiteSpace: "nowrap",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    width: "180px",
                                                                  }}
                                                                  onClick={() => {
                                                                    if (doc.DocumentType) {
                                                                      this.handleViewFile(doc.DocumentPath, doc.DocumentName);
                                                                    } else {
                                                                      window.open(BASE_URL.split('/api')[0] + doc.DocumentPath, "_blank");
                                                                      this.viewDocTag(item.WorkOrderDeliverablesID, index + 1)
                                                                    }
                                                                  }}
                                                                  title={doc.DocumentName}
                                                                >
                                                                  {doc.DocumentName}
                                                                </span>

                                                                {!isView && (
                                                                  <i
                                                                    className="fa fa-trash text-danger"
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={() =>
                                                                      this.handleDeliverableDocRemove(
                                                                        sectionPage,
                                                                        index,
                                                                        item.DocumentsList.findIndex(
                                                                          (d) =>
                                                                            d.DocumentRefNo === doc.DocumentRefNo &&
                                                                            d.DocumentName === doc.DocumentName &&
                                                                            d.ActionID === doc.ActionID
                                                                        )
                                                                      )
                                                                    }
                                                                  />
                                                                )}
                                                              </>
                                                            ) : (
                                                              !isView && (
                                                                <input
                                                                  id={`deliverableFile_${sectionPage}_${index}_${slotIndex}`}
                                                                  type="file"
                                                                  style={{ maxWidth: "200px" }}
                                                                  accept=".pdf, .jpeg, .jpg, .png, .dwg, .dxf, .dwt, .doc, .docx, .xls, .xlsx"
                                                                  onChange={(e) =>
                                                                    this.handleDeliverableDocUpload(
                                                                      e,
                                                                      sectionPage,
                                                                      index,
                                                                      slotIndex
                                                                    )
                                                                  }
                                                                />
                                                              )
                                                            )}
                                                          </div>
                                                        );
                                                      })}
                                                    </div>
                                                    <i className="ri-message-3-line comment-his text-white"
                                                      onClick={() => this.getDeliverablesDocumentLog(item.WorkOrderDeliverablesID, index + 1)}
                                                      title='View Instructions/Documents'
                                                    ></i>
                                                  </td>

                                                  {/* <td className="text-center">
                                                    <input type="checkbox"
                                                      onChange={(e) =>
                                                        this.handleInputSectionPageList(
                                                          "checkbox",
                                                          sectionPage,
                                                          "DeliverablesServices",
                                                          e,
                                                          index,
                                                          "IsRevertRequired"
                                                        )
                                                      }
                                                    />
                                                  </td> */}
                                                  {!isVendor && (
                                                    <>
                                                      <td className="text-center">
                                                        {item.VendorExhibitorPriceInINR ||
                                                          "-"}
                                                      </td>
                                                      <td className="text-center">
                                                        {item.VendorExhibitorPriceInUSD ||
                                                          "-"}
                                                      </td>
                                                      <td className="text-center">
                                                        {item.VendorOrganizerPriceInINR ||
                                                          "-"}
                                                      </td>
                                                      <td className="text-center">
                                                        {item.VendorOrganizerPriceInUSD ||
                                                          "-"}
                                                      </td>
                                                    </>
                                                  )}
                                                  {!isVendor &&
                                                    <td className="text-center">
                                                      <Switch
                                                        onChange={(e) =>
                                                          this.handleInputSectionPageList(
                                                            "varchar",
                                                            sectionPage,
                                                            "DeliverablesServices",
                                                            e,
                                                            index,
                                                            "IsStockAvailable"
                                                          )
                                                        }
                                                        checked={
                                                          item.IsStockAvailable
                                                        }
                                                        onColor="#0d6efd"
                                                        offColor="#fff"
                                                        offHandleColor="#6c757d"
                                                        uncheckedIcon={false}
                                                        checkedIcon={false}
                                                        disabled={isView}
                                                        handleDiameter={10} // smaller knob
                                                        height={14} // smaller height
                                                        width={28} // smaller width
                                                        className="me-1 border small-switch"
                                                      />
                                                    </td>
                                                  }
                                                  {!isView && !isVendor &&
                                                    <td className="text-center">
                                                      {this.renderRowActions(
                                                        this.getDeliverablesServiceActions(
                                                          isView,
                                                          isVendor,
                                                          sectionPage,
                                                          index
                                                        ),
                                                        <span
                                                          style={{ color: "#ccc" }}
                                                        >
                                                          {" "}
                                                          |{" "}
                                                        </span>
                                                      )}
                                                    </td>
                                                  }
                                                </tr>
                                              )
                                            )
                                          ) : (
                                            <tr className="text-center">
                                              <td colSpan={20}>
                                                Record not found
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    </div>

                                    {/* <div className="d-flex justify-content-between align-items-center mb-2 mt-4">
                                      <h6 className="section-title mb-0 fw-semibold">
                                        Instruction for Service Partners
                                      </h6>
                                      {!isVendor && (
                                        <button
                                          disabled={isView || isVendor}
                                          className="btn btn-aqua px-2 p-1"
                                          id="addMoreBtn"
                                          onClick={() =>
                                            this.addMoreSectionPageList(
                                              sectionPage,
                                              "OrganizerResponsibilities"
                                            )
                                          }
                                        >
                                          Add More
                                        </button>
                                      )}
                                    </div> */}
                                  </div>
                                  {/* <div class="table-responsive">
                                    <table
                                      className="table table-bordered mb-4"
                                      id="responsibilityTable"
                                    >
                                      <thead className="table-light text-uppercase" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
                                        <tr>
                                          <th>Instruction</th>
                                          <th
                                            className="text-center"
                                            style={{ width: 50 }}
                                          >
                                            {this.buildActionHeader(
                                              this.getOrganizerResponsibilityActions(
                                                isView,
                                                isVendor,
                                                data.OrganizerResponsibilitiesList
                                                  .length > 1
                                              )
                                            )}
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {data.OrganizerResponsibilitiesList.map(
                                          (item, index) => (
                                            <tr>
                                              <td
                                                style={{
                                                  backgroundColor: "#fffdf3",
                                                }}
                                              >
                                                <input
                                                  disabled={isView || isVendor}
                                                  className="form-control"
                                                  value={item.Responsibilities}
                                                  onChange={(e) =>
                                                    this.handleInputSectionPageList(
                                                      "varchar",
                                                      sectionPage,
                                                      "OrganizerResponsibilities",
                                                      e,
                                                      index,
                                                      "Responsibilities"
                                                    )
                                                  }
                                                />
                                              </td>

                                              {!isView && !isVendor ? (
                                                <td className="text-center">
                                                  {this.renderRowActions(
                                                    this.getOrganizerResponsibilityActions(
                                                      isView,
                                                      isVendor,
                                                      data
                                                        .OrganizerResponsibilitiesList
                                                        .length > 1,
                                                      sectionPage,
                                                      index
                                                    )
                                                  )}
                                                </td>
                                              ) : (
                                                <td className="text-center">-</td>
                                              )}
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </div> */}
                                  {update && (
                                    <>
                                      <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="section-title mb-0  fw-semibold">
                                          Staff Section{" "}
                                          {isVendor && (
                                            <span className="text-danger">*</span>
                                          )}
                                        </h6>
                                      </div>
                                      <ol className="list-group ">
                                        <li
                                          className="list-group-item px-1  justify-content-between align-items-start"
                                          style={{ zIndex: 0 }}
                                        >
                                          <div className="ms-0 me-auto">
                                            <h6 className="col-form-label section-title py-0 fw-semibold">
                                              Pre-Setup Days
                                            </h6>
                                            <label className="col-form-label">
                                              Staff Count{" "}
                                              {isVendor && (
                                                <span className="text-danger">
                                                  *
                                                </span>
                                              )}
                                            </label>
                                            <input
                                              disabled={isView}
                                              className="form-control dis-days"
                                              value={
                                                data.PreSetupDaysStaffBadgeCount
                                              }
                                              onChange={(e) =>
                                                this.handleInputSectionPageList(
                                                  "int",
                                                  sectionPage,
                                                  "PreSetupDaysStaffBadgeCount",
                                                  e,
                                                  "",
                                                  "staffPreSetupDays"
                                                )
                                              }
                                            />
                                          </div>

                                          <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center mt-2">

                                            <h6 className="col-form-label section-title py-0 fw-semibold">
                                              Manager/Cordinator/Supervisor Details
                                            </h6>

                                            <div className="d-flex flex-column flex-md-row gap-2 mb-2">
                                              <button
                                                className="replicate-btn w-100 w-md-auto bg-light"
                                                onClick={() => this.ReplicateAll(sectionPage, "Staff", "EventDays")}
                                              >
                                                <i className="fa fa-clone grid-icon"></i>
                                                PreSetup To Event Days
                                              </button>

                                              <button
                                                className="replicate-btn w-100 w-md-auto bg-light"
                                                onClick={() => this.ReplicateAll(sectionPage, "Staff", "DismantlingDays")}
                                              >
                                                <i className="fa fa-clone grid-icon"></i>
                                                PreSetup To Dismantling Days
                                              </button>
                                              <button
                                                disabled={isView}
                                                className="btn btn-aqua px-2 p-1 float-right"
                                                onClick={() =>
                                                  this.addMoreSectionPageList(sectionPage, "staffPreSetupDays")
                                                }
                                              >
                                                Add More
                                              </button>
                                            </div>

                                          </div>

                                          <div className="table-responsive">
                                            <table
                                              className="table table-bordered align-middle mb-0"
                                              id="staffTable"
                                            >
                                              <thead className="table-light text-uppercase" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
                                                <tr>
                                                  <th>
                                                    Person Name{" "}
                                                    {isVendor && (
                                                      <span className="text-danger">
                                                        *
                                                      </span>
                                                    )}
                                                  </th>
                                                  <th>
                                                    Email ID{" "}
                                                    {isVendor && (
                                                      <span className="text-danger">
                                                        *
                                                      </span>
                                                    )}
                                                  </th>
                                                  <th>
                                                    Mobile Number{" "}
                                                    {isVendor && (
                                                      <span className="text-danger">
                                                        *
                                                      </span>
                                                    )}
                                                  </th>
                                                  <th>
                                                    Designation{" "}
                                                    {isVendor && (
                                                      <span className="text-danger">
                                                        *
                                                      </span>
                                                    )}
                                                  </th>
                                                  <th
                                                    className="text-center"
                                                    style={{ width: 50 }}
                                                  >
                                                    {this.buildActionHeader(
                                                      this.getDayColumnActions({
                                                        isView,
                                                        listKey: "staffPreSetupDaysList",
                                                        showCopyActions: true,
                                                      })
                                                    )}
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {data.staffPreSetupDaysList
                                                  .length > 0 ? (
                                                  data.staffPreSetupDaysList.map(
                                                    (item, index) => (
                                                      <tr>
                                                        <td>
                                                          <input
                                                            disabled={isView}
                                                            type="text"
                                                            className="form-control"
                                                            value={
                                                              item.PersonName
                                                            }
                                                            onChange={(e) =>
                                                              this.handleInputSectionPageList(
                                                                "onlyText",
                                                                sectionPage,
                                                                "staffPreSetupDays",
                                                                e,
                                                                index,
                                                                "PersonName"
                                                              )
                                                            }
                                                            maxLength={100}
                                                          />
                                                        </td>
                                                        <td>
                                                          <input
                                                            disabled={isView}
                                                            className="form-control"
                                                            value={item.EmailID}
                                                            onChange={(e) =>
                                                              this.handleInputSectionPageList(
                                                                "varchar",
                                                                sectionPage,
                                                                "staffPreSetupDays",
                                                                e,
                                                                index,
                                                                "EmailID"
                                                              )
                                                            }
                                                            type="text"
                                                            maxLength={100}
                                                          />
                                                        </td>
                                                        <td>
                                                          <input
                                                            disabled={isView}
                                                            type="text"
                                                            className="form-control"
                                                            value={
                                                              item.MobileNumber
                                                            }
                                                            onChange={(e) =>
                                                              this.handleInputSectionPageList(
                                                                "int",
                                                                sectionPage,
                                                                "staffPreSetupDays",
                                                                e,
                                                                index,
                                                                "MobileNumber"
                                                              )
                                                            }
                                                            maxLength={20}
                                                          />
                                                        </td>
                                                        <td>
                                                          <select
                                                            disabled={isView}
                                                            className="form-control"
                                                            value={
                                                              item.DesignationID
                                                            }
                                                            onChange={(e) =>
                                                              this.handleInputSectionPageList(
                                                                "varchar",
                                                                sectionPage,
                                                                "staffPreSetupDays",
                                                                e,
                                                                index,
                                                                "DesignationID"
                                                              )
                                                            }
                                                          >
                                                            <option value={""}>
                                                              Select
                                                            </option>
                                                            {item.DesignationList
                                                              .length > 0 &&
                                                              item.DesignationList.map(
                                                                (data) => (
                                                                  <option
                                                                    key={
                                                                      data.StaffDesignationID
                                                                    }
                                                                    value={
                                                                      data.StaffDesignationID
                                                                    }
                                                                  >
                                                                    {
                                                                      data.StaffDesignation
                                                                    }
                                                                  </option>
                                                                )
                                                              )}
                                                          </select>
                                                        </td>

                                                        {!isView ? (
                                                          <td className="text-center">
                                                            <div className="d-flex justify-content-center">
                                                              {this.renderRowActions(
                                                                this.getDayColumnActions({
                                                                  isView,
                                                                  sectionPage,
                                                                  listKey: "staffPreSetupDaysList",
                                                                  listLength:
                                                                    data.staffPreSetupDaysList.length,
                                                                  replicateGroup: "Staff",
                                                                  showCopyActions: true,
                                                                  index,
                                                                })
                                                              )}
                                                            </div>

                                                          </td>
                                                        ) : (
                                                          <td className="text-center">
                                                            -
                                                          </td>
                                                        )}
                                                      </tr>
                                                    )
                                                  )
                                                ) : (
                                                  <tr className="text-center">
                                                    <td colSpan={20}>
                                                      Record not found
                                                    </td>
                                                  </tr>
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </li>
                                        {/* style="background-color: #fef4cf;" */}
                                        <li
                                          className="list-group-item px-1 d-flex justify-content-between align-items-start"
                                          style={{ zIndex: 0 }}
                                        >
                                          <div
                                            className="ms-0 me-auto"
                                            style={{ width: "100%" }}
                                          >
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                              <h6 className="col-form-label section-title py-0 fw-semibold">
                                                Event Days
                                              </h6>
                                              <button
                                                disabled={isView}
                                                className="btn btn-aqua px-2 p-1 mb-2"
                                                style={{ float: "right" }}
                                                onClick={() =>
                                                  this.addMoreSectionPageList(
                                                    sectionPage,
                                                    "staffEventDays"
                                                  )
                                                }
                                              >
                                                Add More
                                              </button>
                                            </div>
                                            <div className="table-responsive">
                                              <table
                                                className="table table-bordered align-middle mb-0"
                                                id="staffTable"
                                              >
                                                <thead className="table-light text-uppercase" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
                                                  <tr>
                                                    <th>
                                                      Person Name{" "}
                                                      {isVendor && (
                                                        <span className="text-danger">
                                                          *
                                                        </span>
                                                      )}
                                                    </th>
                                                    <th>
                                                      Email ID{" "}
                                                      {isVendor && (
                                                        <span className="text-danger">
                                                          *
                                                        </span>
                                                      )}
                                                    </th>
                                                    <th>
                                                      Mobile Number{" "}
                                                      {isVendor && (
                                                        <span className="text-danger">
                                                          *
                                                        </span>
                                                      )}
                                                    </th>
                                                    <th>
                                                      Designation{" "}
                                                      {isVendor && (
                                                        <span className="text-danger">
                                                          *
                                                        </span>
                                                      )}
                                                    </th>
                                                    <th
                                                      className="text-center"
                                                      style={{ width: 50 }}
                                                    >
                                                      {this.buildActionHeader(
                                                        this.getDayColumnActions({
                                                          isView,
                                                          listKey: "staffEventDaysList",
                                                        })
                                                      )}
                                                    </th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {data.staffEventDaysList
                                                    .length > 0 ? (
                                                    data.staffEventDaysList.map(
                                                      (item, index) => (
                                                        <tr>
                                                          <td>
                                                            <input
                                                              disabled={isView}
                                                              className="form-control"
                                                              value={
                                                                item.PersonName
                                                              }
                                                              onChange={(e) =>
                                                                this.handleInputSectionPageList(
                                                                  "onlyText",
                                                                  sectionPage,
                                                                  "staffEventDays",
                                                                  e,
                                                                  index,
                                                                  "PersonName"
                                                                )
                                                              }
                                                              type="text"
                                                              maxLength={100}
                                                            />
                                                          </td>
                                                          <td>
                                                            <input
                                                              disabled={isView}
                                                              className="form-control"
                                                              value={item.EmailID}
                                                              onChange={(e) =>
                                                                this.handleInputSectionPageList(
                                                                  "varchar",
                                                                  sectionPage,
                                                                  "staffEventDays",
                                                                  e,
                                                                  index,
                                                                  "EmailID"
                                                                )
                                                              }
                                                              type="text"
                                                              maxLength={100}
                                                            />
                                                          </td>
                                                          <td>
                                                            <input
                                                              disabled={isView}
                                                              className="form-control"
                                                              value={
                                                                item.MobileNumber
                                                              }
                                                              onChange={(e) =>
                                                                this.handleInputSectionPageList(
                                                                  "int",
                                                                  sectionPage,
                                                                  "staffEventDays",
                                                                  e,
                                                                  index,
                                                                  "MobileNumber"
                                                                )
                                                              }
                                                              type="text"
                                                              maxLength={20}
                                                            />
                                                          </td>
                                                          <td>
                                                            <select
                                                              disabled={isView}
                                                              className="form-control"
                                                              value={
                                                                item.DesignationID
                                                              }
                                                              onChange={(e) =>
                                                                this.handleInputSectionPageList(
                                                                  "varchar",
                                                                  sectionPage,
                                                                  "staffEventDays",
                                                                  e,
                                                                  index,
                                                                  "DesignationID"
                                                                )
                                                              }
                                                            >
                                                              <option value={""}>
                                                                Select
                                                              </option>
                                                              {item
                                                                .DesignationList
                                                                .length > 0 &&
                                                                item.DesignationList.map(
                                                                  (data) => (
                                                                    <option
                                                                      key={
                                                                        data.StaffDesignationID
                                                                      }
                                                                      value={
                                                                        data.StaffDesignationID
                                                                      }
                                                                    >
                                                                      {
                                                                        data.StaffDesignation
                                                                      }
                                                                    </option>
                                                                  )
                                                                )}
                                                            </select>
                                                          </td>

                                                          {!isView ? (
                                                            <td className="text-center">
                                                              <div className="d-flex justify-content-center">
                                                                {this.renderRowActions(
                                                                  this.getDayColumnActions({
                                                                    isView,
                                                                    sectionPage,
                                                                    listKey: "staffEventDaysList",
                                                                    listLength:
                                                                      data.staffEventDaysList.length,
                                                                    index,
                                                                  })
                                                                )}
                                                              </div>
                                                            </td>
                                                          ) : (
                                                            <td className="text-center">
                                                              -
                                                            </td>
                                                          )}
                                                        </tr>
                                                      )
                                                    )
                                                  ) : (
                                                    <tr className="text-center">
                                                      <td colSpan={20}>
                                                        Record not found
                                                      </td>
                                                    </tr>
                                                  )}
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        </li>
                                        <li
                                          className="list-group-item px-1  justify-content-between align-items-start"
                                          style={{ zIndex: 0 }}
                                        >
                                          <div className="ms-0 me-auto ">
                                            <h6 className="col-form-label section-title py-0 fw-semibold">
                                              Dismantling Days
                                            </h6>
                                            <label className="col-form-label">
                                              Staff Count{" "}
                                              {isVendor && (
                                                <span className="text-danger">
                                                  *
                                                </span>
                                              )}
                                            </label>
                                            <input
                                              disabled={isView}
                                              className="form-control dis-days"
                                              value={
                                                data.DismantlingDaysStaffBadgeCount
                                              }
                                              onChange={(e) =>
                                                this.handleInputSectionPageList(
                                                  "int",
                                                  sectionPage,
                                                  "DismantlingDaysStaffBadgeCount",
                                                  e,
                                                  "",
                                                  "staffDismantlingDays"
                                                )
                                              }
                                            />
                                          </div>
                                          <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mb-2">
                                            <h6 className="col-form-label section-title py-0 fw-semibold mb-2 mb-sm-0">
                                              Manager/Cordinator/Supervisor Details
                                            </h6>

                                            <button
                                              disabled={isView}
                                              className="btn btn-aqua px-2 py-1"
                                              onClick={() =>
                                                this.addMoreSectionPageList(
                                                  sectionPage,
                                                  "staffDismantlingDays"
                                                )
                                              }
                                            >
                                              Add More
                                            </button>
                                          </div>


                                          <div className="table-responsive">
                                            <table
                                              className="table table-bordered align-middle mb-0"
                                              id="staffTable"
                                            >
                                              <thead className="table-light text-uppercase" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
                                                <tr>
                                                  <th>
                                                    Person Name{" "}
                                                    {isVendor && (
                                                      <span className="text-danger">
                                                        *
                                                      </span>
                                                    )}
                                                  </th>
                                                  <th>
                                                    Email ID{" "}
                                                    {isVendor && (
                                                      <span className="text-danger">
                                                        *
                                                      </span>
                                                    )}
                                                  </th>
                                                  <th>
                                                    Mobile Number{" "}
                                                    {isVendor && (
                                                      <span className="text-danger">
                                                        *
                                                      </span>
                                                    )}
                                                  </th>
                                                  <th>
                                                    Designation{" "}
                                                    {isVendor && (
                                                      <span className="text-danger">
                                                        *
                                                      </span>
                                                    )}
                                                  </th>
                                                  <th
                                                    className="text-center"
                                                    style={{ width: 50 }}
                                                  >
                                                    {this.buildActionHeader(
                                                      this.getDayColumnActions({
                                                        isView,
                                                        listKey: "staffDismantlingDaysList",
                                                      })
                                                    )}
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {data.staffDismantlingDaysList
                                                  .length > 0 ? (
                                                  data.staffDismantlingDaysList.map(
                                                    (item, index) => (
                                                      <tr>
                                                        <td>
                                                          <input
                                                            disabled={isView}
                                                            className="form-control"
                                                            value={
                                                              item.PersonName
                                                            }
                                                            onChange={(e) =>
                                                              this.handleInputSectionPageList(
                                                                "onlyText",
                                                                sectionPage,
                                                                "staffDismantlingDays",
                                                                e,
                                                                index,
                                                                "PersonName"
                                                              )
                                                            }
                                                            maxLength={100}
                                                          />
                                                        </td>
                                                        <td>
                                                          <input
                                                            disabled={isView}
                                                            className="form-control"
                                                            value={item.EmailID}
                                                            onChange={(e) =>
                                                              this.handleInputSectionPageList(
                                                                "varchar",
                                                                sectionPage,
                                                                "staffDismantlingDays",
                                                                e,
                                                                index,
                                                                "EmailID"
                                                              )
                                                            }
                                                            maxLength={100}
                                                          />
                                                        </td>
                                                        <td>
                                                          <input
                                                            disabled={isView}
                                                            className="form-control"
                                                            value={
                                                              item.MobileNumber
                                                            }
                                                            onChange={(e) =>
                                                              this.handleInputSectionPageList(
                                                                "int",
                                                                sectionPage,
                                                                "staffDismantlingDays",
                                                                e,
                                                                index,
                                                                "MobileNumber"
                                                              )
                                                            }
                                                            maxLength={20}
                                                          />
                                                        </td>
                                                        <td>
                                                          <select
                                                            disabled={isView}
                                                            className="form-control"
                                                            value={
                                                              item.DesignationID
                                                            }
                                                            onChange={(e) =>
                                                              this.handleInputSectionPageList(
                                                                "varchar",
                                                                sectionPage,
                                                                "staffDismantlingDays",
                                                                e,
                                                                index,
                                                                "DesignationID"
                                                              )
                                                            }
                                                          >
                                                            <option value={""}>
                                                              Select
                                                            </option>
                                                            {item.DesignationList
                                                              .length > 0 &&
                                                              item.DesignationList.map(
                                                                (data) => (
                                                                  <option
                                                                    key={
                                                                      data.StaffDesignationID
                                                                    }
                                                                    value={
                                                                      data.StaffDesignationID
                                                                    }
                                                                  >
                                                                    {
                                                                      data.StaffDesignation
                                                                    }
                                                                  </option>
                                                                )
                                                              )}
                                                          </select>
                                                        </td>

                                                        {!isView ? (
                                                          <td className="text-center">
                                                            <div className="d-flex justify-content-center">
                                                              {this.renderRowActions(
                                                                this.getDayColumnActions({
                                                                  isView,
                                                                  sectionPage,
                                                                  listKey:
                                                                    "staffDismantlingDaysList",
                                                                  listLength:
                                                                    data.staffDismantlingDaysList
                                                                      .length,
                                                                  index,
                                                                })
                                                              )}
                                                            </div>
                                                          </td>
                                                        ) : (
                                                          <td className="text-center">
                                                            -
                                                          </td>
                                                        )}
                                                      </tr>
                                                    )
                                                  )
                                                ) : (
                                                  <tr className="text-center">
                                                    <td colSpan={20}>
                                                      Record not found
                                                    </td>
                                                  </tr>
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </li>
                                      </ol>

                                      {/* Header section as per second image */}
                                      <div className="d-flex flex-column mb-3 mt-3 w-100 ms-0 ps-0">
                                        <div className="d-flex justify-content-between align-items-start w-100 m-0 p-0">
                                          <div className="text-start m-0 p-0">
                                            <h5 className="fw-bold mb-1" style={{ color: '#333', fontSize: '1.1rem' }}>
                                              {data.SectionPageName == "Onsite Agency" ? 'Hall Manager Allocation' : 'Team Member Allocation'}
                                            </h5>
                                            <p className="text-muted mb-3" style={{ fontSize: '13px' }}>
                                              Manage staffing schedules for pre-setup, event, and dismantling phases.
                                            </p>
                                          </div>
                                          <div className="d-flex align-items-center mt-1">
                                            <label className="fw-bold d-flex align-items-center" style={{ color: '#006256', cursor: 'pointer', fontSize: '14px' }}>
                                              <input
                                                disabled={sectionPage == "Onsite Agency"}
                                                type="checkbox"
                                                checked={data.isHallChecked}
                                                onChange={(e) =>
                                                  this.handleInputSectionPageList(
                                                    "varchar",
                                                    sectionPage,
                                                    "isHallChecked",
                                                    e,
                                                    "",
                                                    "isHallChecked"
                                                  )
                                                }
                                                style={{ marginRight: '8px', cursor: 'pointer' }}
                                              />
                                              {data.SectionPageName == "Onsite Agency" ? 'Hall Manager' : 'Team Member'}
                                            </label>
                                          </div>
                                        </div>

                                        <div className="d-flex flex-wrap gap-2">
                                          <button
                                            className="replicate-btn bg-light m-0"
                                            style={{ whiteSpace: 'normal', height: 'auto', textAlign: 'left', border: '1px solid #ccc', borderRadius: '20px', padding: '6px 16px' }}
                                            onClick={() => this.ReplicateStaffToHall(sectionPage, "PreSetup")}
                                          >
                                            <i className="fa fa-clone grid-icon"></i>
                                            Staff PreSetup Days To {data.SectionPageName == "Onsite Agency" ? 'Hall Manager' : 'Team Member'} PreSetup Days
                                          </button>

                                          <button
                                            className="replicate-btn bg-light m-0"
                                            style={{ whiteSpace: 'normal', height: 'auto', textAlign: 'left', border: '1px solid #ccc', borderRadius: '20px', padding: '6px 16px' }}
                                            onClick={() => this.ReplicateStaffToHall(sectionPage, "Event")}
                                          >
                                            <i className="fa fa-clone grid-icon"></i>
                                            Staff Event Days To {data.SectionPageName == "Onsite Agency" ? 'Hall Manager' : 'Team Member'} Event Days
                                          </button>

                                          <button
                                            className="replicate-btn bg-light m-0"
                                            style={{ whiteSpace: 'normal', height: 'auto', textAlign: 'left', border: '1px solid #ccc', borderRadius: '20px', padding: '6px 16px' }}
                                            onClick={() => this.ReplicateStaffToHall(sectionPage, "Dismantling")}
                                          >
                                            <i className="fa fa-clone grid-icon"></i>
                                            Staff Dismantling Days To {data.SectionPageName == "Onsite Agency" ? 'Hall Manager' : 'Team Member'} Dismantling Days
                                          </button>
                                        </div>
                                      </div>
                                      {data.isHallChecked && (
                                        <ol className="list-group ">
                                          <li
                                            className="list-group-item px-1 d-flex justify-content-between align-items-start"
                                            style={{ zIndex: 0 }}
                                          >
                                            <div
                                              className="ms-0 me-auto"
                                              style={{ width: "100%" }}
                                            >
                                              <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center mb-0 p-2 rounded-top" style={{ backgroundColor: '#f4f7fb' }}>

                                                <h6 className="col-form-label section-title fw-bold m-0" style={{ color: '#333', fontSize: '15px' }}>
                                                  Pre-Setup Days
                                                </h6>

                                                <div className="d-flex flex-wrap align-items-stretch gap-2 mt-2 mt-lg-0">

                                                  <button
                                                    className="replicate-btn m-0"
                                                    style={{ padding: '0.25rem 0.5rem', display: 'flex', alignItems: 'center' }}
                                                    onClick={() => this.ReplicateAll(sectionPage, "Hall", "EventDays")}
                                                  >
                                                    <i className="fa fa-clone grid-icon me-1"></i>
                                                    PreSetup To Event Days
                                                  </button>

                                                  <button
                                                    className="replicate-btn m-0"
                                                    style={{ padding: '0.25rem 0.5rem', display: 'flex', alignItems: 'center' }}
                                                    onClick={() => this.ReplicateAll(sectionPage, "Hall", "DismantlingDays")}
                                                  >
                                                    <i className="fa fa-clone grid-icon me-1"></i>
                                                    PreSetup To Dismantling Days
                                                  </button>

                                                  <button
                                                    disabled={isView}
                                                    className="btn btn-aqua px-2 p-1 m-0"
                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                    onClick={() =>
                                                      this.addMoreSectionPageList(sectionPage, "hallPreSetupDays")
                                                    }
                                                  >
                                                    Add More
                                                  </button>

                                                </div>
                                              </div>

                                              <div className="table-responsive">
                                                <table
                                                  className="table table-bordered align-middle mb-0"
                                                  id="staffTable"
                                                  style={{ overflowY: "auto" }}
                                                >
                                                  <thead className="table-light text-uppercase" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
                                                    <tr>
                                                      <th>
                                                        Person Name{" "}
                                                        {isVendor && (
                                                          <span className="text-danger">
                                                            *
                                                          </span>
                                                        )}
                                                      </th>
                                                      <th>
                                                        Email ID{" "}
                                                        {isVendor && (
                                                          <span className="text-danger">
                                                            *
                                                          </span>
                                                        )}
                                                      </th>
                                                      <th>
                                                        Password{" "}
                                                      </th>
                                                      <th>
                                                        Mobile Number{" "}
                                                        {isVendor && (
                                                          <span className="text-danger">
                                                            *
                                                          </span>
                                                        )}
                                                      </th>
                                                      <th>
                                                        Allocated Halls{" "}
                                                        {isVendor && (
                                                          <span className="text-danger">
                                                            *
                                                          </span>
                                                        )}
                                                      </th>
                                                      <th>
                                                        Allocated Date{" "}
                                                        {isVendor && (
                                                          <span className="text-danger">
                                                            *
                                                          </span>
                                                        )}
                                                      </th>
                                                      <th
                                                        className="text-center"
                                                        style={{ width: 50 }}
                                                      >
                                                        {this.buildActionHeader(
                                                          this.getDayColumnActions({
                                                            isView,
                                                            listKey: "hallPreSetupDaysList",
                                                            showCopyActions: true,
                                                          })
                                                        )}
                                                      </th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {data.hallPreSetupDaysList
                                                      .length > 0 ? (
                                                      data.hallPreSetupDaysList.map(
                                                        (item, index) => (
                                                          <tr>
                                                            <td>
                                                              <input
                                                                disabled={isView}
                                                                type="text"
                                                                className="form-control"
                                                                value={
                                                                  item.PersonName
                                                                }
                                                                onChange={(e) =>
                                                                  this.handleInputSectionPageList(
                                                                    "onlyText",
                                                                    sectionPage,
                                                                    "hallPreSetupDays",
                                                                    e,
                                                                    index,
                                                                    "PersonName"
                                                                  )
                                                                }
                                                                maxLength={100}
                                                              />
                                                            </td>
                                                            <td>
                                                              <input
                                                                disabled={isView}
                                                                className="form-control"
                                                                value={
                                                                  item.EmailID
                                                                }
                                                                onChange={(e) =>
                                                                  this.handleInputSectionPageList(
                                                                    "varchar",
                                                                    sectionPage,
                                                                    "hallPreSetupDays",
                                                                    e,
                                                                    index,
                                                                    "EmailID"
                                                                  )
                                                                }
                                                                type="text"
                                                                maxLength={100}
                                                              />
                                                            </td>
                                                            <td className="text-center">{item.Password || '-'}</td>
                                                            <td>
                                                              <input
                                                                disabled={isView}
                                                                type="text"
                                                                className="form-control"
                                                                value={
                                                                  item.MobileNumber
                                                                }
                                                                onChange={(e) =>
                                                                  this.handleInputSectionPageList(
                                                                    "int",
                                                                    sectionPage,
                                                                    "hallPreSetupDays",
                                                                    e,
                                                                    index,
                                                                    "MobileNumber"
                                                                  )
                                                                }
                                                                maxLength={20}
                                                              />
                                                            </td>
                                                            <td>
                                                              <span
                                                                onClick={() =>
                                                                  this.StaffSectionHallPop(
                                                                    index,
                                                                    "hallPreSetupDays"
                                                                  )
                                                                }
                                                                className="text-primary"
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                              >
                                                                {item.SelectedHalls ? (
                                                                  <a>
                                                                    {
                                                                      item.SelectedHalls
                                                                    }
                                                                  </a>
                                                                ) : (
                                                                  <i class="fa fa-th-large"></i>
                                                                )}
                                                              </span>
                                                            </td>
                                                            <td>
                                                              <span
                                                                onClick={() =>
                                                                  this.StaffSectionShiftPop(
                                                                    index,
                                                                    "hallPreSetupDays"
                                                                  )
                                                                }
                                                                className="text-primary"
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                  color:
                                                                    "#0d6efd",
                                                                }}
                                                              >
                                                                {item
                                                                  .SelectedShifts
                                                                  .length > 0 ? (
                                                                  <>
                                                                    {item.SelectedShifts.map(
                                                                      (
                                                                        shift,
                                                                        index
                                                                      ) => (
                                                                        <a
                                                                          key={
                                                                            index
                                                                          }
                                                                        >
                                                                          {
                                                                            shift.split(
                                                                              ","
                                                                            )[0]
                                                                          }
                                                                          {shift.includes(
                                                                            "All Shift"
                                                                          ) ? (
                                                                            <span
                                                                              className="alert alert-success alert-dismissible fade show px-1 py-0 mx-1 d-inline-block mb-0 text-primary"
                                                                              role="alert"
                                                                            >
                                                                              <i className="fa fa-check-circle me-1"></i>{" "}
                                                                              All
                                                                              Shift
                                                                            </span>
                                                                          ) : (
                                                                            <span
                                                                              className="alert alert-warning alert-dismissible fade show px-1 py-0 mx-1 d-inline-block mb-0 "
                                                                              role="alert"
                                                                            >
                                                                              <i className="fa fa-calendar-check-o"></i>{" "}
                                                                              {
                                                                                shift.split(
                                                                                  ","
                                                                                )[1]
                                                                              }
                                                                            </span>
                                                                          )}
                                                                          {index <
                                                                            item
                                                                              .SelectedShifts
                                                                              .length -
                                                                            1 &&
                                                                            ", "}
                                                                        </a>
                                                                      )
                                                                    )}
                                                                  </>
                                                                ) : (
                                                                  <i class="fa fa-calendar-plus-o"></i>
                                                                )}
                                                              </span>
                                                            </td>

                                                            {!isView ? (
                                                              <td className="text-center">
                                                                <div className="d-flex justify-content-center">
                                                                  {this.renderRowActions(
                                                                    this.getDayColumnActions({
                                                                      isView,
                                                                      sectionPage,
                                                                      listKey:
                                                                        "hallPreSetupDaysList",
                                                                      listLength:
                                                                        data.hallPreSetupDaysList
                                                                          .length,
                                                                      replicateGroup: "Hall",
                                                                      showCopyActions: true,
                                                                      index,
                                                                    })
                                                                  )}
                                                                </div>

                                                              </td>
                                                            ) : (
                                                              <td className="text-center">
                                                                -
                                                              </td>
                                                            )}
                                                          </tr>
                                                        )
                                                      )
                                                    ) : (
                                                      <tr className="text-center">
                                                        <td colSpan={20}>
                                                          Record not found
                                                        </td>
                                                      </tr>
                                                    )}
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          </li>
                                          {/* style="background-color: #fef4cf;" */}
                                          <li
                                            className="list-group-item px-1 d-flex justify-content-between align-items-start"
                                            style={{ zIndex: 0 }}
                                          >
                                            <div
                                              className="ms-0 me-auto"
                                              style={{ width: "100%" }}
                                            >
                                              <div className="d-flex justify-content-between align-items-center mb-0 p-2 rounded-top" style={{ backgroundColor: '#f4f7fb' }}>
                                                <h6 className="col-form-label section-title fw-bold m-0" style={{ color: '#333', fontSize: '15px' }}>
                                                  Event Days
                                                </h6>
                                                <button
                                                  disabled={isView}
                                                  className="btn btn-aqua px-2 p-1 m-0"
                                                  style={{ float: "right" }}
                                                  onClick={() =>
                                                    this.addMoreSectionPageList(
                                                      sectionPage,
                                                      "hallEventDays"
                                                    )
                                                  }
                                                >
                                                  Add More
                                                </button>
                                              </div>
                                              <div class="table-responsive">
                                                <table
                                                  className="table table-bordered align-middle mb-0"
                                                  id="staffTable"
                                                >
                                                  <thead className="table-light text-uppercase" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
                                                    <tr>
                                                      <th>
                                                        Person Name{" "}
                                                        {isVendor && (
                                                          <span className="text-danger">
                                                            *
                                                          </span>
                                                        )}
                                                      </th>
                                                      <th>
                                                        Email ID{" "}
                                                        {isVendor && (
                                                          <span className="text-danger">
                                                            *
                                                          </span>
                                                        )}
                                                      </th>
                                                      <th>
                                                        Password{" "}
                                                      </th>
                                                      <th>
                                                        Mobile Number{" "}
                                                        {isVendor && (
                                                          <span className="text-danger">
                                                            *
                                                          </span>
                                                        )}
                                                      </th>
                                                      <th>
                                                        Allocated Halls{" "}
                                                        {isVendor && (
                                                          <span className="text-danger">
                                                            *
                                                          </span>
                                                        )}
                                                      </th>
                                                      <th>
                                                        Allocated Date{" "}
                                                        {isVendor && (
                                                          <span className="text-danger">
                                                            *
                                                          </span>
                                                        )}
                                                      </th>
                                                      <th
                                                        className="text-center"
                                                        style={{ width: 50 }}
                                                      >
                                                        {this.buildActionHeader(
                                                          this.getDayColumnActions({
                                                            isView,
                                                            listKey: "hallEventDaysList",
                                                          })
                                                        )}
                                                      </th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {data.hallEventDaysList
                                                      .length > 0 ? (
                                                      data.hallEventDaysList.map(
                                                        (item, index) => (
                                                          <tr>
                                                            <td>
                                                              <input
                                                                disabled={isView}
                                                                className="form-control"
                                                                value={
                                                                  item.PersonName
                                                                }
                                                                onChange={(e) =>
                                                                  this.handleInputSectionPageList(
                                                                    "onlyText",
                                                                    sectionPage,
                                                                    "hallEventDays",
                                                                    e,
                                                                    index,
                                                                    "PersonName"
                                                                  )
                                                                }
                                                                type="text"
                                                                maxLength={100}
                                                              />
                                                            </td>
                                                            <td>
                                                              <input
                                                                disabled={isView}
                                                                className="form-control"
                                                                value={
                                                                  item.EmailID
                                                                }
                                                                maxLength={100}
                                                                onChange={(e) =>
                                                                  this.handleInputSectionPageList(
                                                                    "varchar",
                                                                    sectionPage,
                                                                    "hallEventDays",
                                                                    e,
                                                                    index,
                                                                    "EmailID"
                                                                  )
                                                                }
                                                                type="text"
                                                              />
                                                            </td>
                                                            <td className="text-center">{item.Password || '-'}</td>
                                                            <td>
                                                              <input
                                                                disabled={isView}
                                                                className="form-control"
                                                                value={
                                                                  item.MobileNumber
                                                                }
                                                                maxLength={20}
                                                                onChange={(e) =>
                                                                  this.handleInputSectionPageList(
                                                                    "int",
                                                                    sectionPage,
                                                                    "hallEventDays",
                                                                    e,
                                                                    index,
                                                                    "MobileNumber"
                                                                  )
                                                                }
                                                                type="text"
                                                              />
                                                            </td>
                                                            <td>
                                                              <span
                                                                onClick={() =>
                                                                  this.StaffSectionHallPop(
                                                                    index,
                                                                    "hallEventDays"
                                                                  )
                                                                }
                                                                className="text-primary"
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                              >
                                                                {item.SelectedHalls ? (
                                                                  <a>
                                                                    {
                                                                      item.SelectedHalls
                                                                    }
                                                                  </a>
                                                                ) : (
                                                                  <i class="fa fa-th-large"></i>
                                                                )}
                                                              </span>
                                                            </td>
                                                            <td>
                                                              <span
                                                                onClick={() =>
                                                                  this.StaffSectionShiftPop(
                                                                    index,
                                                                    "hallEventDays"
                                                                  )
                                                                }
                                                                className="text-primary"
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                              >
                                                                {item.SelectedDates ? (
                                                                  <>
                                                                    <a>
                                                                      {
                                                                        item.SelectedDates
                                                                      }
                                                                      {index <
                                                                        item
                                                                          .SelectedShifts
                                                                          .length -
                                                                        1 &&
                                                                        ", "}
                                                                    </a>
                                                                  </>
                                                                ) : (
                                                                  <i class="fa fa-calendar-plus-o"></i>
                                                                )}
                                                              </span>
                                                            </td>

                                                            {!isView ? (
                                                              <td className="text-center">
                                                                <div className="d-flex justify-content-center">
                                                                  {this.renderRowActions(
                                                                    this.getDayColumnActions({
                                                                      isView,
                                                                      sectionPage,
                                                                      listKey: "hallEventDaysList",
                                                                      listLength:
                                                                        data.hallEventDaysList
                                                                          .length,
                                                                      index,
                                                                    })
                                                                  )}
                                                                </div>
                                                              </td>
                                                            ) : (
                                                              <td className="text-center">
                                                                -
                                                              </td>
                                                            )}
                                                          </tr>
                                                        )
                                                      )
                                                    ) : (
                                                      <tr className="text-center">
                                                        <td colSpan={20}>
                                                          Record not found
                                                        </td>
                                                      </tr>
                                                    )}
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          </li>
                                          <li
                                            className="list-group-item px-1 d-flex justify-content-between align-items-start"
                                            style={{ zIndex: 0 }}
                                          >
                                            <div
                                              className="ms-0 me-auto"
                                              style={{ width: "100%" }}
                                            >
                                              <div className="d-flex justify-content-between align-items-center mb-0 p-2 rounded-top" style={{ backgroundColor: '#f4f7fb' }}>
                                                <h6 className="col-form-label section-title fw-bold m-0" style={{ color: '#333', fontSize: '15px' }}>
                                                  Dismantling Days
                                                </h6>
                                                <button
                                                  disabled={isView}
                                                  className="btn btn-aqua px-2 p-1 m-0"
                                                  style={{ float: "right" }}
                                                  onClick={() =>
                                                    this.addMoreSectionPageList(
                                                      sectionPage,
                                                      "hallDismantlingDays"
                                                    )
                                                  }
                                                >
                                                  Add More
                                                </button>
                                              </div>
                                              <div className="table-responsive">
                                                <table
                                                  className="table table-bordered align-middle mb-0"
                                                  id="staffTable"
                                                >
                                                  <thead className="table-light text-uppercase" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
                                                    <tr>
                                                      <th>
                                                        Person Name{" "}
                                                        {isVendor && (
                                                          <span className="text-danger">
                                                            *
                                                          </span>
                                                        )}
                                                      </th>
                                                      <th>
                                                        Email ID{" "}
                                                        {isVendor && (
                                                          <span className="text-danger">
                                                            *
                                                          </span>
                                                        )}
                                                      </th>
                                                      <th>
                                                        Password{" "}
                                                      </th>
                                                      <th>
                                                        Mobile Number{" "}
                                                        {isVendor && (
                                                          <span className="text-danger">
                                                            *
                                                          </span>
                                                        )}
                                                      </th>
                                                      <th>
                                                        Allocated Halls{" "}
                                                        {isVendor && (
                                                          <span className="text-danger">
                                                            *
                                                          </span>
                                                        )}
                                                      </th>
                                                      <th>
                                                        Allocated Date{" "}
                                                        {isVendor && (
                                                          <span className="text-danger">
                                                            *
                                                          </span>
                                                        )}
                                                      </th>
                                                      <th
                                                        className="text-center"
                                                        style={{ width: 50 }}
                                                      >
                                                        {this.buildActionHeader(
                                                          this.getDayColumnActions({
                                                            isView,
                                                            listKey: "hallDismantlingDaysList",
                                                          })
                                                        )}
                                                      </th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {data.hallDismantlingDaysList
                                                      .length > 0 ? (
                                                      data.hallDismantlingDaysList.map(
                                                        (item, index) => (
                                                          <tr>
                                                            <td>
                                                              <input
                                                                disabled={isView}
                                                                className="form-control"
                                                                value={
                                                                  item.PersonName
                                                                }
                                                                maxLength={100}
                                                                onChange={(e) =>
                                                                  this.handleInputSectionPageList(
                                                                    "onlyText",
                                                                    sectionPage,
                                                                    "hallDismantlingDays",
                                                                    e,
                                                                    index,
                                                                    "PersonName"
                                                                  )
                                                                }
                                                              />
                                                            </td>
                                                            <td>
                                                              <input
                                                                disabled={isView}
                                                                className="form-control"
                                                                value={
                                                                  item.EmailID
                                                                }
                                                                maxLength={100}
                                                                onChange={(e) =>
                                                                  this.handleInputSectionPageList(
                                                                    "varchar",
                                                                    sectionPage,
                                                                    "hallDismantlingDays",
                                                                    e,
                                                                    index,
                                                                    "EmailID"
                                                                  )
                                                                }
                                                              />
                                                            </td>
                                                            <td className="text-center">{item.Password || '-'}</td>
                                                            <td>
                                                              <input
                                                                disabled={isView}
                                                                className="form-control"
                                                                value={
                                                                  item.MobileNumber
                                                                }
                                                                maxLength={20}
                                                                onChange={(e) =>
                                                                  this.handleInputSectionPageList(
                                                                    "int",
                                                                    sectionPage,
                                                                    "hallDismantlingDays",
                                                                    e,
                                                                    index,
                                                                    "MobileNumber"
                                                                  )
                                                                }
                                                              />
                                                            </td>
                                                            <td>
                                                              <span
                                                                onClick={() =>
                                                                  this.StaffSectionHallPop(
                                                                    index,
                                                                    "hallDismantlingDays"
                                                                  )
                                                                }
                                                                className="text-primary"
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                              >
                                                                {item.SelectedHalls ? (
                                                                  <a>
                                                                    {
                                                                      item.SelectedHalls
                                                                    }
                                                                  </a>
                                                                ) : (
                                                                  <i class="fa fa-th-large"></i>
                                                                )}
                                                              </span>
                                                            </td>
                                                            <td>
                                                              <span
                                                                onClick={() =>
                                                                  this.StaffSectionShiftPop(
                                                                    index,
                                                                    "hallDismantlingDays"
                                                                  )
                                                                }
                                                                className="text-primary"
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                              >
                                                                {item
                                                                  .SelectedShifts
                                                                  .length > 0 ? (
                                                                  <>
                                                                    {item.SelectedShifts.map(
                                                                      (
                                                                        shift,
                                                                        index
                                                                      ) => (
                                                                        <a
                                                                          key={
                                                                            index
                                                                          }
                                                                        >
                                                                          {
                                                                            shift.split(
                                                                              ","
                                                                            )[0]
                                                                          }
                                                                          {shift.includes(
                                                                            "All Shift"
                                                                          ) ? (
                                                                            <span
                                                                              className="alert alert-success alert-dismissible fade show px-1 py-0 mx-1 d-inline-block mb-0"
                                                                              role="alert"
                                                                            >
                                                                              <i className="fa fa-check-circle me-1"></i>{" "}
                                                                              All
                                                                              Shift
                                                                            </span>
                                                                          ) : (
                                                                            <span
                                                                              className="alert alert-warning alert-dismissible fade show px-1 py-0 mx-1 d-inline-block mb-0"
                                                                              role="alert"
                                                                            >
                                                                              <i className="fa fa-calendar-check-o"></i>{" "}
                                                                              {
                                                                                shift.split(
                                                                                  ","
                                                                                )[1]
                                                                              }
                                                                            </span>
                                                                          )}
                                                                          {index <
                                                                            item
                                                                              .SelectedShifts
                                                                              .length -
                                                                            1 &&
                                                                            ", "}
                                                                        </a>
                                                                      )
                                                                    )}
                                                                  </>
                                                                ) : (
                                                                  <i class="fa fa-calendar-plus-o"></i>
                                                                )}
                                                              </span>
                                                            </td>

                                                            {!isView ? (
                                                              <td className="text-center">
                                                                <div className="d-flex justify-content-center">
                                                                  {this.renderRowActions(
                                                                    this.getDayColumnActions({
                                                                      isView,
                                                                      sectionPage,
                                                                      listKey:
                                                                        "hallDismantlingDaysList",
                                                                      listLength:
                                                                        data.hallDismantlingDaysList
                                                                          .length,
                                                                      index,
                                                                    })
                                                                  )}
                                                                </div>
                                                              </td>
                                                            ) : (
                                                              <td className="text-center">
                                                                -
                                                              </td>
                                                            )}
                                                          </tr>
                                                        )
                                                      )
                                                    ) : (
                                                      <tr className="text-center">
                                                        <td colSpan={20}>
                                                          Record not found
                                                        </td>
                                                      </tr>
                                                    )}
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          </li>
                                        </ol>
                                      )}
                                    </>
                                  )}
                                  {sectionPage == "Onsite Agency" &&
                                    update &&
                                    FormStatusID && (
                                      <>
                                        {data.HallManagerLoginCredentialList
                                          .length == 0 ? (
                                          <div
                                            className="mb-3 p-1 border mt-4 rounded-2"
                                            style={{
                                              justifyContent: "space-between",
                                              display: "flex",
                                            }}
                                          >
                                            <h6 className="col-form-label section-title">
                                              Portal Access
                                            </h6>
                                            <button
                                              className="btn btn-aqua p-1"
                                              onClick={() => {
                                                const hallPreSetupIsBlank = this.checkValuesNotEmpty(
                                                  data.hallPreSetupDaysList,
                                                  [
                                                    "PersonName",
                                                    "EmailID",
                                                    "MobileNumber",
                                                    "SelectedHalls",
                                                    "AllocatedDateIDs",
                                                  ]
                                                )
                                                const hallEventIsBlank = this.checkValuesNotEmpty(
                                                  data.hallEventDaysList,
                                                  [
                                                    "PersonName",
                                                    "EmailID",
                                                    "MobileNumber",
                                                    "SelectedHalls",
                                                    "SelectedDates",
                                                  ]
                                                )
                                                const hallDismantlingIsBlank = this.checkValuesNotEmpty(
                                                  data.hallDismantlingDaysList,
                                                  [
                                                    "PersonName",
                                                    "EmailID",
                                                    "MobileNumber",
                                                    "SelectedHalls",
                                                    "AllocatedDateIDs",
                                                  ]
                                                )
                                                if (hallPreSetupIsBlank && hallEventIsBlank &&
                                                  hallDismantlingIsBlank) {
                                                  this.insertUpdateWorkOrder(
                                                    1,
                                                    false,
                                                    true,
                                                    "submit"
                                                  );
                                                } else {
                                                  toastError(
                                                    "Please add all hall manager details"
                                                  );
                                                }
                                              }}
                                            >
                                              Create Hall Manager Access
                                            </button>
                                          </div>
                                        ) : (
                                          <div className="mb-3 mt-4 bg-white p-0 border rounded-3 shadow-sm">
                                            <div className="d-flex jtext-left align-items-start mb-3">
                                              <div className="p-3 text-left py-1 pt-2 pb-1">
                                                <h6 className="col-form-label section-title m-0 p-0" style={{ color: '#002842', fontSize: '1.2rem' }}>
                                                  Portal Access Management
                                                </h6>
                                              </div>
                                            </div>
                                            <div className="table-responsive">
                                              <table
                                                className="table align-middle mb-0"
                                                id="staffTable"
                                              >
                                                <thead style={{ backgroundColor: '#f9fafb', color: '#6b7280', fontSize: '11px', letterSpacing: '0.5px', textTransform: 'uppercase', borderBottom: '2px solid #e5e7eb' }}>
                                                  <tr>
                                                    <th className="py-2 px-1 border-0 border-end" style={{ width: '150px' }}>Hall Name</th>
                                                    <th className="py-2 px-2 border-0">User Type</th>
                                                    <th className="py-2 px-2 border-0">User Name (Email)</th>
                                                    <th style={{ width: "300px" }} className="py-2 px-2 border-0">Password</th>
                                                    <th
                                                      className="text-center py-2 px-2 border-0"
                                                      style={{ width: "100px" }}
                                                    >
                                                      Change Password
                                                    </th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {Object.values(
                                                    data.HallManagerLoginCredentialList.reduce((groups, item) => {
                                                      if (!groups[item.HallID]) {
                                                        groups[item.HallID] = {
                                                          HallName: item.HallName,
                                                          users: [],
                                                        };
                                                      }

                                                      groups[item.HallID].users.push(item);

                                                      return groups;
                                                    }, {})
                                                  ).map((hall, hallIndex) => {

                                                    /* =====================================================
                                                       Hall Manager
                                                       Example:
                                                       Hall_1.ITME2026
                                                       ===================================================== */

                                                    const hallManager = hall.users.find((user) =>
                                                      user.UserName.startsWith("Hall_")
                                                    );


                                                    /* =====================================================
                                                       Zone Managers ONLY
                                                
                                                       Valid:
                                                       H12_Z1.ITME2026
                                                       H11_Z1.ITME2026
                                                       H14_Z1.ITME2026
                                                
                                                       NOT:
                                                       H12_Z1_T1.ITME2026
                                                       ===================================================== */

                                                    const zoneManagers = hall.users.filter((user) => {
                                                      const userName = user.UserName || "";

                                                      return (
                                                        /_Z\d+\./i.test(userName) &&
                                                        !user.ZoneManagerTeamMemberID
                                                      );
                                                    });


                                                    /* =====================================================
                                                       Build display list
                                                
                                                       Hall Manager
                                                          ↓
                                                       Zone Manager
                                                          ↓
                                                       Team Members of that Zone Manager
                                                       ===================================================== */

                                                    const users = [];

                                                    if (hallManager) {
                                                      users.push(hallManager);
                                                    }


                                                    zoneManagers.forEach((zoneManager) => {

                                                      /* Add Zone Manager */
                                                      users.push(zoneManager);


                                                      /*
                                                        Find Team Members belonging to this Zone Manager.
                                                
                                                        New format:
                                                
                                                        Zone Manager:
                                                        H12_Z1.ITME2026
                                                
                                                        Team Members:
                                                        H12_Z1_T1.ITME2026
                                                        H12_Z1_T2.ITME2026
                                                      */

                                                      const zoneManagerBase = zoneManager.UserName.split(".")[0];

                                                      const teamMembers = hall.users.filter((user) => {
                                                        const userName = user.UserName || "";

                                                        return (
                                                          user.ZoneManagerTeamMemberID &&
                                                          userName.startsWith(zoneManagerBase + "_T")
                                                        );
                                                      });


                                                      /* Add Team Members immediately after Zone Manager */
                                                      users.push(...teamMembers);
                                                    });


                                                    return users.map((item, userIndex) => {

                                                      const isHallManager =
                                                        item.UserName &&
                                                        item.UserName.startsWith("Hall_");


                                                      const isTeamMember =
                                                        !!item.ZoneManagerTeamMemberID;


                                                      const isZoneManager =
                                                        !isHallManager &&
                                                        !isTeamMember;


                                                      return (
                                                        <tr
                                                          key={item.UserID}
                                                          style={{
                                                            borderBottom: "1px solid #e5e7eb",
                                                          }}
                                                        >

                                                          {/* =================================================
              Hall Name
              ================================================= */}

                                                          {userIndex === 0 && (
                                                            <td
                                                              rowSpan={users.length}
                                                              className="border-0 border-end fw-600 px-3 py-3"
                                                              style={{
                                                                verticalAlign: "middle",
                                                              }}
                                                            >
                                                              {hall.HallName}
                                                            </td>
                                                          )}


                                                          {/* =================================================
              User Type
              ================================================= */}

                                                          <td className="border-0 py-2 px-2">

                                                            {/* ================= Hall Manager ================= */}

                                                            {isHallManager ? (

                                                              <span style={{ color: "#006256" }}>
                                                                <i className="fa fa-shield me-2"></i>
                                                                Hall Manager
                                                              </span>

                                                            ) : isTeamMember ? (

                                                              /* ================= Team Member ================= */

                                                              <span style={{ color: "#4b5563" }}>

                                                                <i className="fa fa-user-o me-2"></i>

                                                                Team Member

                                                                <i
                                                                  className="fa fa-trash text-danger mx-1"
                                                                  title="Delete team member"
                                                                  style={{
                                                                    cursor: "pointer",
                                                                  }}
                                                                  onClick={() =>
                                                                    this.setState({
                                                                      isConfirmPop: true,
                                                                      isCreateZoneManagerTeamMember: false,
                                                                      ZoneManagerUserName: item.UserName,
                                                                    })
                                                                  }
                                                                />

                                                              </span>

                                                            ) : (

                                                              /* ================= Zone Manager ================= */

                                                              <span style={{ color: "#4b5563" }}>

                                                                <i className="fa fa-id-card-o me-2"></i>

                                                                Zone Manager

                                                                <i
                                                                  className="fa fa-plus-circle me-1 mx-2"
                                                                  style={{
                                                                    cursor: "pointer",
                                                                  }}
                                                                  onClick={() =>
                                                                    this.setState({
                                                                      isConfirmPop: true,
                                                                      isCreateZoneManagerTeamMember: true,
                                                                      ZoneManagerUserName: item.UserName,
                                                                    })
                                                                  }
                                                                  title="Create team member"
                                                                ></i>

                                                              </span>

                                                            )}

                                                          </td>


                                                          {/* =================================================
              Username
              ================================================= */}

                                                          <td
                                                            className="border-0 py-2 px-2"
                                                            style={{
                                                              color: "#374151",
                                                            }}
                                                          >
                                                            {item.UserName}
                                                          </td>


                                                          {/* =================================================
              Password
              ================================================= */}

                                                          <td
                                                            className="border-0 py-2 px-2"
                                                            style={{
                                                              color: "#374151",
                                                              fontWeight: "bold",
                                                              letterSpacing: "2px",
                                                            }}
                                                          >

                                                            <div className="d-flex align-items-center">

                                                              <span>
                                                                {visibleIndexPassword === item.UserID
                                                                  ? item.Password
                                                                  : "............"}
                                                              </span>

                                                              <i
                                                                className={`fa ${visibleIndexPassword === item.UserID
                                                                  ? "fa-eye-slash"
                                                                  : "fa-eye"
                                                                  }`}
                                                                style={{
                                                                  marginLeft: "10px",
                                                                  cursor: "pointer",
                                                                  color: "#9ca3af",
                                                                  letterSpacing: "normal",
                                                                }}
                                                                onClick={() =>
                                                                  this.setState({
                                                                    visibleIndexPassword:
                                                                      visibleIndexPassword === item.UserID
                                                                        ? null
                                                                        : item.UserID,
                                                                  })
                                                                }
                                                              ></i>

                                                            </div>

                                                          </td>


                                                          {/* =================================================
              Change Password
              ================================================= */}

                                                          <td className="text-center border-0 py-2 px-2">

                                                            <button
                                                              className="btn btn-aqua px-2 p-1"
                                                              onClick={() =>
                                                                this.ChangePassword(item.UserID)
                                                              }
                                                            >
                                                              Click here
                                                            </button>

                                                          </td>

                                                        </tr>
                                                      );
                                                    });
                                                  })}
                                                </tbody>

                                              </table>
                                            </div>
                                          </div>
                                        )}
                                      </>
                                    )}
                                </div>
                              </div>
                            </div >
                          </div>
                        )}
                      </>
                    ))}
                </>
                {/* } */}
              </>
            ) : (
              <div className="row m-0 ">
                <div className="pb-0 col-12 p-0">
                  <div className="d-flex justify-content-between align-items-center flex-nowrap mb-2 pt-2">

                    <h6 className="section-title mb-0 fw-semibold flex-grow-1">
                      Document Section
                    </h6>
                    {!isHallManager && !isVendor ? (
                      <button
                        disabled={isView || RoleID == 7 || RoleID == 17}
                        className="btn btn-aqua px-2 flex-shrink-0"
                        id="addDocumentBtn"
                        onClick={() => this.addMoreDocuments()}
                      >
                        Add More
                      </button>
                    ) : (
                      <></>
                    )
                    }

                  </div>
                  {(isHallManager || isVendor ? (documentList?.some(item => item.FileName)) : true) ?
                    <table
                      className="table table-bordered col-md-7"
                      id="documentTable"
                    >
                      <thead className="table-light text-uppercase" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
                        <tr>
                          <th>Document Name</th>
                          <th>Attachment</th>
                          <th className="text-center" style={{ width: 50 }}>
                            {this.buildActionHeader(
                              this.getDocumentActions(
                                isView,
                                documentList.length > 1 && RoleID != 7 && RoleID != 17
                              ),
                              "Action"
                            )}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {documentList.length > 0 ? (
                          documentList.map((item, index) => (
                            <tr>
                              <td>
                                <input
                                  disabled={isView || RoleID == 7 || RoleID == 17}
                                  className="form-control"
                                  value={item.DocumentName}
                                  onChange={(e) =>
                                    this.documentHandleInput(
                                      e,
                                      index,
                                      "DocumentName"
                                    )
                                  }
                                />
                              </td>
                              <td>
                                {item.FileName ? (
                                  <>
                                    <div
                                      className="d-flex"
                                      style={{ justifyContent: "center" }}
                                    >
                                      <div className="chooseStallFile m-0">
                                        <p className="overflow-membership m-0">
                                          {!item.FileType ? (
                                            <a
                                              style={{ cursor: "pointer" }}
                                              target="__blank"
                                              href={
                                                BASE_URL.split("/api")[0] +
                                                item.FilePath
                                              }
                                            >
                                              {item.FileName}
                                            </a>
                                          ) : (
                                            <a
                                              style={{ cursor: "pointer" }}
                                              onClick={() =>
                                                this.handleViewFile(
                                                  item.FilePath,
                                                  item.FileName
                                                )
                                              }
                                            >
                                              {item.FileName}
                                            </a>
                                          )}
                                        </p>
                                        {(!isView && (RoleID != 7 || RoleID != 17)) &&
                                          <span
                                            className="membership_file_cross text-danger"
                                            onClick={(e) =>
                                              this.handleRemoveFile(e, index)
                                            }
                                          >
                                            X
                                          </span>
                                        }
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <input
                                    disabled={isView || RoleID == 7 || RoleID != 17}
                                    type="file"
                                    className="form-control"
                                    accept=".pdf, .jpg, .png, .jpeg"
                                    onChange={(e) =>
                                      this.documentHandleInput(e, index, "file")
                                    }
                                  />
                                )}
                              </td>

                              {!isView &&
                                (isVendor ? item.ActionID != 2 : true) ? (
                                <td className="text-center">
                                  {this.renderRowActions(
                                    this.getDocumentActions(
                                      isView,
                                      documentList.length > 1 && (RoleID != 7 && RoleID != 17),
                                      index
                                    )
                                  )}
                                </td>
                              ) : (
                                <td className="text-center">-</td>
                              )}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={5} className="text-center">
                              Record not found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table> :
                    <h6 className="text-center" style={{ position: 'relative', top: '100%' }}>No documents attached by the organizer</h6>
                  }
                </div>
              </div>
            )}
            {(summaryPage == "WorkOrderDocument" ? !isHallManager && !isVendor : true) && (
              <div className="p-2 mb-0" style={{ position: 'fixed', bottom: '0', left: '0', right: '0', zIndex: 10, backgroundColor: '#f8f9fa', borderTop: '1px solid #e5e7eb', boxShadow: '0 -2px 5px rgba(0,0,0,0.05)' }}>
                <div className="d-flex justify-content-end flex-wrap gap-2 pe-0">

                  <button
                    className="btn px-4 py-2 btn btn-gray "
                    style={{ backgroundColor: '#ffffff', color: '#111827', border: '1px solid #d1d5db' }}
                    onClick={(e) => this.cancle()}
                  >
                    Back
                  </button>

                  {!isView && (
                    <>
                      {(this.props.location.state &&
                        this.props.location.state.add) ||
                        replicate ||
                        !FormStatusID ? (
                        <>
                          <button
                            disabled={isView}
                            className="btn btn-aqua px-4 py-2"
                            style={{ cursor: "pointer", backgroundColor: '#006256', color: 'white' }}
                            onClick={(e) =>
                              this.saveAsDraftWorkOrder(0, false, false, "draft")
                            }
                          >
                            Save As Draft
                          </button>

                          <button
                            disabled={isView}
                            className="btn btn-aqua px-4 py-2"
                            style={{ cursor: "pointer", backgroundColor: '#006256', color: 'white' }}
                            onClick={(e) =>
                              this.insertUpdateWorkOrder(
                                1,
                                false,
                                false,
                                "submit"
                              )
                            }
                          >
                            Submit
                          </button>
                        </>
                      ) : (
                        <button
                          disabled={isView}
                          className="btn btn-aqua px-4 py-2"
                          style={{ backgroundColor: '#006256', color: 'white' }}
                          onClick={(e) =>
                            this.insertUpdateWorkOrder(0, true, false, "update")
                          }
                        >
                          Update
                        </button>
                      )}
                    </>
                  )}

                </div>
              </div>
            )}
          </div>
        </div >

        <Modal isOpen={isDeliveryServicesPop}>
          <div class="modal-dialog modal-xl">
            <div class="modal-content w-auto">
              <div class="modal-header py-2 pt-3">
                <h6 className="modal-title fw-semibold">
                  {isInstruction ? 'Instruction' : (isScopeOfWorkPop ? "Scope of Work" : "Deliverables Services")}
                </h6>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  onClick={() =>
                    isAddDeliveryServicesPop
                      ? this.DeliveryServicesPopClosed()
                      : this.DeliveryServicesPopSave()
                  }
                />
              </div>
              {SectionPageList.length > 0 &&
                SectionPageList.map((data, i) => (
                  <>
                    {data.SectionPageName == sectionPage && (
                      <div
                        className="modal-bod p-3 pb-2"
                        style={{
                          overflow: "auto",
                        }}
                      >
                        {data.DeliverablesServicesList.length > 0 &&
                          data.DeliverablesServicesList.map(
                            (item, index) =>
                              index == DeliveryServicesIndex && (
                                <>
                                  {!isVendor && (
                                    <div className="row">
                                      {/* <div className='tog-btn'>
                                <Switch
                                  onChange={(e) => this.handleInputSectionPageList('varchar', sectionPage, 'DeliverablesServices', e, index, 'IsStockAvailable')}
                                  checked={item.IsStockAvailable}
                                  style={{
                                    backgroundColor: item.IsStockAvailable ? '#0d6efd' : '#FFFF',
                                    border:'1px solid black'
                                  }}
                                />
                              </div> */}
                                      {!isInstruction &&
                                        <div className="tog-btn">
                                          <div className="d-flex available-btn align-items-center text-white">
                                            <span className="fw-semibold me-2">
                                              Available:
                                            </span>
                                            <span className="me-1">No</span>
                                            <Switch
                                              onChange={(e) =>
                                                this.handleInputSectionPageList(
                                                  "varchar",
                                                  sectionPage,
                                                  "DeliverablesServices",
                                                  e,
                                                  index,
                                                  "IsStockAvailable"
                                                )
                                              }
                                              checked={item.IsStockAvailable}
                                              onColor="#0d6efd"
                                              offColor="#fff"
                                              offHandleColor="#6c757d"
                                              uncheckedIcon={false}
                                              disabled={isView || isVendor}
                                              checkedIcon={false}
                                              handleDiameter={12}
                                              height={18}
                                              width={36}
                                              className="me-1 border"
                                            />
                                            <span>Yes</span>
                                          </div>
                                        </div>
                                      }
                                      {!isInstruction &&
                                        <div className="col-md-12">
                                          <div className="d-flex justify-content-between align-items-center">
                                            <label className="col-form-label">
                                              Deliverables Service
                                              <span className="text-danger">*</span>
                                            </label>
                                            {!isVendor && (
                                              <button
                                                disabled={isView || isVendor}
                                                className="btn btn-aqua px-2 p-1"
                                                onClick={() =>
                                                  this.props.navigate('/ServiceDeliverableMaster')
                                                }
                                              >
                                                Add More Deliverables
                                              </button>
                                            )}
                                          </div>
                                          {isDeliveryServicesPopFlag ==
                                            "isUpdate" ? (
                                            <textarea
                                              disabled={true}
                                              className="form-control .wrap-break-td"
                                              id="roledb"
                                              value={
                                                item.MainServiceDeliverablesName
                                              }
                                            />
                                          ) : (
                                            <select
                                              disabled={isView || isVendor}
                                              className="form-control"
                                              id="roledb"
                                              value={
                                                item.MainServiceDeliverablesID
                                              }
                                              onChange={(e) =>
                                                this.handleInputSectionPageList(
                                                  "varchar",
                                                  sectionPage,
                                                  "DeliverablesServices",
                                                  e,
                                                  index,
                                                  "MainServiceDeliverablesID"
                                                )
                                              }
                                            >
                                              <option value={""}>Select</option>
                                              {item.DropdownList.length > 0 &&
                                                item.DropdownList.map((data) => (
                                                  <option
                                                    key={
                                                      data.MainServiceDeliverablesID
                                                    }
                                                    value={
                                                      data.MainServiceDeliverablesID
                                                    }
                                                  >
                                                    {
                                                      data.MainServiceDeliverablesName
                                                    }
                                                  </option>
                                                ))}
                                            </select>
                                          )}
                                        </div>
                                      }
                                    </div>
                                  )}
                                  {/* <div className="row">
                            <div className="col-md-12 mb-2">
                              {!isScopeOfWorkPop && <label className="col-form-label">
                                Scope of Work<span className="text-danger">*</span>
                              </label>}
                              <JoditEditor
                                value={item.ScopeOfWork}
                                config={{
                                  ...config,
                                  readonly: isScopeOfWorkPop 
                                }}
                                onBlur={newContent => {
                                  this.handleInputSectionPageList('varchar',
                                    sectionPage,
                                    'DeliverablesServices',
                                    newContent,
                                    DeliveryServicesIndex,
                                    'ScopeOfWork'
                                  );
                                }}
                                onChange={() => { }}
                              />
                            </div>
                          </div> */}
                                  {!isInstruction &&
                                    <div className="row mt-2">

                                      <div className="col-md-12">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                          <label className="">
                                            Compliance Requirements{" "}
                                          </label>
                                          {!isVendor && (
                                            <button
                                              disabled={isView || isVendor}
                                              className="btn btn-aqua px-2 p-1"
                                              id="addMoreBtn"
                                              onClick={() =>
                                                this.addMoreSectionPageList(
                                                  sectionPage,
                                                  "DeliverablesServices",
                                                  "ComplianceRequirementsList"
                                                )
                                              }
                                            >
                                              Add More Compliance
                                            </button>
                                          )}
                                        </div>
                                        <div className="table-responsive mt-2">
                                          <table
                                            className="table table-bordered mb-4"
                                            id="responsibilityTable"
                                          >
                                            <thead className="table-light text-uppercase" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
                                              <tr>
                                                <th style={{ width: 10 }}>
                                                  Sr. No.
                                                </th>
                                                <th style={{ width: "400px" }}>
                                                  Specification
                                                </th>
                                                <th>Location</th>
                                                <th>Quantity</th>
                                                <th>TimeLine</th>
                                                <th>
                                                  {this.buildActionHeader(
                                                    this.getComplianceRequirementActions(
                                                      isView,
                                                      isVendor
                                                    ),
                                                    "Action"
                                                  )}
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {item.ComplianceRequirementsList
                                                .length > 0 ? (
                                                item.ComplianceRequirementsList.map(
                                                  (obj, compIndex) => (
                                                    <tr>
                                                      <td>{compIndex + 1}</td>
                                                      <td>
                                                        <input
                                                          disabled={
                                                            isView || isVendor
                                                          }
                                                          type="text"
                                                          class="form-control"
                                                          value={
                                                            obj.Specification
                                                          }
                                                          maxLength={100}
                                                          checked={
                                                            obj.Specification
                                                          }
                                                          onChange={(e) =>
                                                            this.handleInputSectionPageList(
                                                              "varchar",
                                                              sectionPage,
                                                              "DeliverablesServices",
                                                              e,
                                                              compIndex,
                                                              "Specification",
                                                              "ComplianceRequirementsList"
                                                            )
                                                          }
                                                        />
                                                      </td>
                                                      <td>
                                                        <select
                                                          disabled={
                                                            isView || isVendor
                                                          }
                                                          className="form-control"
                                                          value={obj.LocationID}
                                                          onChange={(e) =>
                                                            this.handleInputSectionPageList(
                                                              "varchar",
                                                              sectionPage,
                                                              "DeliverablesServices",
                                                              e,
                                                              compIndex,
                                                              "LocationID",
                                                              "ComplianceRequirementsList"
                                                            )
                                                          }
                                                        >
                                                          <option value={""}>
                                                            Select
                                                          </option>
                                                          {this.state.hallList
                                                            .length > 0 &&
                                                            this.state.hallList.map(
                                                              (data) => (
                                                                <option
                                                                  key={
                                                                    data.HallId
                                                                  }
                                                                  value={
                                                                    data.HallId
                                                                  }
                                                                >
                                                                  {data.HallName}
                                                                </option>
                                                              )
                                                            )}
                                                        </select>

                                                        {obj.LocationID ==
                                                          "Other" && (
                                                            <input
                                                              disabled={
                                                                isView || isVendor
                                                              }
                                                              type="text"
                                                              class="form-control mt-1"
                                                              value={
                                                                obj.LocationName
                                                              }
                                                              checked={
                                                                obj.LocationName
                                                              }
                                                              maxLength={400}
                                                              onChange={(e) =>
                                                                this.handleInputSectionPageList(
                                                                  "varchar",
                                                                  sectionPage,
                                                                  "DeliverablesServices",
                                                                  e,
                                                                  compIndex,
                                                                  "LocationName",
                                                                  "ComplianceRequirementsList"
                                                                )
                                                              }
                                                            />
                                                          )}
                                                      </td>
                                                      <td>
                                                        <input
                                                          disabled={
                                                            isView || isVendor
                                                          }
                                                          type="text"
                                                          class="form-control"
                                                          value={obj.Quantity}
                                                          checked={obj.Quantity}
                                                          maxLength={20}
                                                          onChange={(e) =>
                                                            this.handleInputSectionPageList(
                                                              "int",
                                                              sectionPage,
                                                              "DeliverablesServices",
                                                              e,
                                                              compIndex,
                                                              "Quantity",
                                                              "ComplianceRequirementsList"
                                                            )
                                                          }
                                                        />
                                                      </td>
                                                      <td>
                                                        <DatePicker
                                                          selected={
                                                            obj.TimeLine
                                                              ? moment(
                                                                obj.TimeLine
                                                              ).toDate()
                                                              : null
                                                          }
                                                          disabled={
                                                            isView || isVendor
                                                          }
                                                          onChange={(e) =>
                                                            this.handleInputSectionPageList(
                                                              "varchar",
                                                              sectionPage,
                                                              "DeliverablesServices",
                                                              e,
                                                              compIndex,
                                                              "TimeLine",
                                                              "ComplianceRequirementsList"
                                                            )
                                                          }
                                                          showTimeSelect
                                                          timeFormat="HH:mm"
                                                          timeIntervals={1} // choose time in 15-min steps
                                                          dateFormat="dd-MM-yyyy HH:mm"
                                                          placeholderText="Select date and time"
                                                          className="form-control"
                                                          popperProps={{
                                                            strategy: "fixed",
                                                            modifiers: [
                                                              {
                                                                name: "offset",
                                                                options: {
                                                                  offset: [0, 5],
                                                                },
                                                              },
                                                            ],
                                                          }}
                                                          style={{ zIndex: 9999 }}
                                                        />
                                                      </td>
                                                      {!isView && !isVendor ? (
                                                        <td className="text-center">
                                                          {this.renderRowActions(
                                                            this.getComplianceRequirementActions(
                                                              isView,
                                                              isVendor,
                                                              sectionPage,
                                                              index,
                                                              compIndex
                                                            )
                                                          )}
                                                        </td>
                                                      ) : (
                                                        <td className="text-center">
                                                          -
                                                        </td>
                                                      )}
                                                    </tr>
                                                  )
                                                )
                                              ) : (
                                                <tr className="text-center">
                                                  <td colSpan={10}>
                                                    Record not find
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  }

                                  {!isVendor && !isInstruction && (
                                    <div className="row">
                                      {/* <div className="col-md-2">
                                <label className="col-form-label">Manpower </label>

                                <input disabled={isView || isVendor}
                                  className="form-control"
                                  maxLength={20}
                                  value={item.Manpower}
                                  onChange={(e) => this.handleInputSectionPageList('varchar',sectionPage, 'DeliverablesServices', e, DeliveryServicesIndex, 'Manpower')}
                                />
                              </div> */}
                                      {/* <div className="col-md-5">
                                <label className="col-form-label">
                                  Start Date<span className="text-danger">*</span>
                                </label>
                                <DatePicker
                                  selected={
                                    item.DeliverablesServicesStartDate
                                      ? moment(item.DeliverablesServicesStartDate).toDate()
                                      : null
                                  }
                                  disabled={isView || isVendor}
                                  onChange={(e) => this.handleInputSectionPageList('varchar', sectionPage, 'DeliverablesServices', e, DeliveryServicesIndex, 'DeliverablesServicesStartDate')}
                                  showTimeSelect
                                  timeFormat="HH:mm"
                                  timeIntervals={1} // choose time in 15-min steps
                                  dateFormat="dd-MM-yyyy HH:mm"
                                  placeholderText="Select date and time"
                                  className="form-control"
                                />
                              </div>
                              <div className="col-md-5">
                                <label className="col-form-label">
                                  End Date<span className="text-danger">*</span>
                                </label>
                                <DatePicker
                                  selected={
                                    item.DeliverablesServicesEndDate
                                      ? moment(item.DeliverablesServicesEndDate).toDate()
                                      : null
                                  }
                                  minDate={item.DeliverablesServicesStartDate}
                                  disabled={!item.DeliverablesServicesStartDate || isView || isVendor}
                                  onChange={(e) => this.handleInputSectionPageList('varchar', sectionPage, 'DeliverablesServices', e, DeliveryServicesIndex, 'DeliverablesServicesEndDate')}
                                  showTimeSelect
                                  timeFormat="HH:mm"
                                  timeIntervals={1} // choose time in 15-min steps
                                  dateFormat="dd-MM-yyyy HH:mm"
                                  placeholderText="Select date and time"
                                  className="form-control"
                                />
                              </div> */}

                                      <div className="col-md-4">
                                        <label className="col-form-label">
                                          Accessible
                                          <span className="text-danger">*</span>
                                        </label>
                                        <select
                                          disabled={isView || isVendor}
                                          className="form-control"
                                          id="roledb"
                                          value={item.AccessibleID}
                                          onChange={(e) =>
                                            this.handleInputSectionPageList(
                                              "int",
                                              sectionPage,
                                              "DeliverablesServices",
                                              e,
                                              index,
                                              "AccessibleID"
                                            )
                                          }
                                        >
                                          <option value={""}>Select</option>
                                          {AccesibleList.length > 0 &&
                                            AccesibleList.map((data) => (
                                              <option
                                                key={data.AccessibleID}
                                                value={data.AccessibleID}
                                              >
                                                {data.Description}
                                              </option>
                                            ))}
                                        </select>
                                      </div>

                                      <div className="col-md-4">
                                        <label className="col-form-label">
                                          Deliverables Pricing Type{" "}
                                          {item.AccessibleID == 2 && (
                                            <span className="text-danger">
                                              *
                                            </span>
                                          )}
                                        </label>
                                        <select
                                          disabled={isView || isVendor}
                                          className="form-control"
                                          id="roledb"
                                          value={item.DeliverablesPricingID}
                                          onChange={(e) =>
                                            this.handleInputSectionPageList(
                                              "int",
                                              sectionPage,
                                              "DeliverablesServices",
                                              e,
                                              index,
                                              "DeliverablesPricingID"
                                            )
                                          }
                                        >
                                          <option value={""}>Select</option>
                                          {DeliverablesPricingList.length > 0 &&
                                            DeliverablesPricingList.map(
                                              (data) => (
                                                <option
                                                  key={
                                                    data.DeliverablesPricingID
                                                  }
                                                  value={
                                                    data.DeliverablesPricingID
                                                  }
                                                >
                                                  {data.Description}
                                                </option>
                                              )
                                            )}
                                        </select>
                                      </div>

                                      <div className="col-md-4">
                                        <label className="col-form-label">
                                          Quantity{" "}
                                          {item.AccessibleID == 2 && (
                                            <span className="text-danger">
                                              *
                                            </span>
                                          )}
                                        </label>
                                        <input
                                          disabled={isView || isVendor}
                                          className="form-control"
                                          maxLength={20}
                                          value={item.Quantity}
                                          onChange={(e) =>
                                            this.handleInputSectionPageList(
                                              "int",
                                              sectionPage,
                                              "DeliverablesServices",
                                              e,
                                              DeliveryServicesIndex,
                                              "Quantity"
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  )}
                                  {!isVendor && (
                                    <div className={isInstruction ? "row bg-white" : "row mt-3 bg-white"}>

                                      {!isInstruction && <>
                                        <div className="col-md-6 pe-3 py-2">
                                          {" "}
                                          {/* Light Gray with padding end */}
                                          <div className="row">
                                            <h6 className="fw-semibold mb-1">
                                              Service Partner Rate
                                            </h6>
                                            <div className="col-md-6">
                                              <label className="col-form-label">
                                                Price (INR){" "}
                                                {item.AccessibleID == 2 && (
                                                  <span className="text-danger">
                                                    *
                                                  </span>
                                                )}
                                              </label>
                                              <input
                                                disabled={isView || isVendor}
                                                type="number"
                                                className="form-control"
                                                value={
                                                  item.VendorExhibitorPriceInINR
                                                }
                                                maxLength={20}
                                                onChange={(e) =>
                                                  this.handleInputSectionPageList(
                                                    "decimal",
                                                    sectionPage,
                                                    "DeliverablesServices",
                                                    e,
                                                    DeliveryServicesIndex,
                                                    "VendorExhibitorPriceInINR"
                                                  )
                                                }
                                              />
                                            </div>
                                            <div className="col-md-6">
                                              <label className="col-form-label">
                                                Price (USD){" "}
                                                {item.AccessibleID == 2 && (
                                                  <span className="text-danger">
                                                    *
                                                  </span>
                                                )}
                                              </label>
                                              <input
                                                disabled={isView || isVendor}
                                                type="number"
                                                className="form-control"
                                                value={
                                                  item.VendorExhibitorPriceInUSD
                                                }
                                                maxLength={20}
                                                onChange={(e) =>
                                                  this.handleInputSectionPageList(
                                                    "decimal",
                                                    sectionPage,
                                                    "DeliverablesServices",
                                                    e,
                                                    DeliveryServicesIndex,
                                                    "VendorExhibitorPriceInUSD"
                                                  )
                                                }
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-md-6 ps-3 py-2">
                                          {" "}
                                          {/* Light Green with padding start */}
                                          <div className="row">
                                            <h6 className="fw-semibold mb-1">
                                              Itme Rate
                                            </h6>
                                            <div className="col-md-6">
                                              <label className="col-form-label">
                                                Price (INR)
                                                {item.AccessibleID == 2 && (
                                                  <span className="text-danger">
                                                    *
                                                  </span>
                                                )}
                                              </label>

                                              <input
                                                disabled={isView || isVendor}
                                                type="number"
                                                className="form-control"
                                                value={
                                                  item.VendorOrganizerPriceInINR
                                                }
                                                maxLength={20}
                                                onChange={(e) =>
                                                  this.handleInputSectionPageList(
                                                    "decimal",
                                                    sectionPage,
                                                    "DeliverablesServices",
                                                    e,
                                                    DeliveryServicesIndex,
                                                    "VendorOrganizerPriceInINR"
                                                  )
                                                }
                                              />
                                            </div>
                                            <div className="col-md-6">
                                              <label className="col-form-label">
                                                Price (USD)
                                                {item.AccessibleID == 2 && (
                                                  <span className="text-danger">
                                                    *
                                                  </span>
                                                )}
                                              </label>
                                              <input
                                                disabled={isView || isVendor}
                                                type="number"
                                                className="form-control"
                                                value={
                                                  item.VendorOrganizerPriceInUSD
                                                }
                                                maxLength={20}
                                                onChange={(e) =>
                                                  this.handleInputSectionPageList(
                                                    "decimal",
                                                    sectionPage,
                                                    "DeliverablesServices",
                                                    e,
                                                    DeliveryServicesIndex,
                                                    "VendorOrganizerPriceInUSD"
                                                  )
                                                }
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-md-12 ps-3 py-2">
                                          <label className="col-form-label">
                                            Remark
                                          </label>
                                          <textarea
                                            className="form-control"
                                            rows={6}
                                            style={{ width: "100%" }}
                                            disabled={isView || isVendor}
                                            value={item.Remark}
                                            maxLength={1000}
                                            onChange={(e) =>
                                              this.handleInputSectionPageList(
                                                "varchar",
                                                sectionPage,
                                                "DeliverablesServices",
                                                e,
                                                DeliveryServicesIndex,
                                                "Remark"
                                              )
                                            }
                                          />
                                        </div>
                                      </>
                                      }

                                    </div>
                                  )}
                                  {isInstruction &&
                                    <div className="col-md-12 ps-3 py-2">
                                      <label className="col-form-label">Instructions</label>
                                      <textarea
                                        className="form-control"
                                        rows={3}
                                        style={{ width: "100%" }}
                                        disabled={isView}
                                        value={item.Instructions || ""}
                                        maxLength={1000}
                                        onChange={(e) =>
                                          this.handleInputSectionPageList(
                                            "varchar",
                                            sectionPage,
                                            "DeliverablesServices",
                                            e,
                                            DeliveryServicesIndex,
                                            "Instructions"
                                          )
                                        }
                                      />
                                    </div>
                                  }
                                </>
                              )
                          )}
                      </div>
                    )}
                  </>
                ))}
              <div className="modal-footer py-1">
                {((!isScopeOfWorkPop && !isView && !isVendor) || isInstruction) && (
                  <button
                    disabled={isView || (isInstruction ? false : isVendor)}
                    className="btn p-1 px-3 btn-aqua"
                    id="saveBtn"
                    onClick={() => this.DeliveryServicesPopSave()}
                  >
                    Save
                  </button>
                )}
                <button
                  className="btn p-1 px-3 btn-gray"
                  data-bs-dismiss="modal"
                  onClick={() =>
                    isAddDeliveryServicesPop
                      ? this.DeliveryServicesPopClosed()
                      : this.DeliveryServicesPopSave()
                  }
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </Modal>

        <Modal isOpen={StaffSectionHallPop}>
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header py-2 pt-3 bg-light">
                <h6 className="modal-title  text-primary fw-bolder">
                  Select Hall & Zone
                </h6>
                <button
                  disabled={isView}
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  onClick={() => this.StaffSectionHallPopClosed()}
                />
              </div>
              {SectionPageList.length > 0 &&
                SectionPageList.map((data, i) => (
                  <>
                    {data.SectionPageName == sectionPage && (
                      <div
                        className="modal-body pb-2"
                        style={{
                          overflow: "auto",
                        }}
                      >
                        {staffSectionTableName == "hallPreSetupDays" &&
                          data.hallPreSetupDaysList.length > 0 &&
                          data.hallPreSetupDaysList.map(
                            (item, index) =>
                              index == StaffSectionIndex && (
                                <>
                                  <div className="table-responsive mt-2">
                                    <h6 className="text-primary">
                                      {item.Name}
                                    </h6>
                                    <table
                                      className="table table-bordered mb-2"
                                      id="responsibilityTable"
                                    >
                                      <thead className="table-light text-uppercase" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
                                        <tr>
                                          <th style={{ width: 180 }}>Hall</th>
                                          <th className="text-center">Zone</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {item.HallZoneList.length > 0 &&
                                          item.HallZoneList.map(
                                            (obj, hallIndex) => (
                                              <tr>
                                                <td>
                                                  <label class="d-flex">
                                                    <input
                                                      disabled={isView}
                                                      type="checkbox"
                                                      class="h-auto mx-1"
                                                      value={obj.isHallChecked}
                                                      checked={
                                                        obj.isHallChecked
                                                      }
                                                      onChange={(e) =>
                                                        this.handleInputSectionPageList(
                                                          "varchar",
                                                          sectionPage,
                                                          "hallPreSetupDays",
                                                          e,
                                                          StaffSectionIndex,
                                                          "HallZonelist",
                                                          "hall",
                                                          "",
                                                          hallIndex,
                                                          null
                                                        )
                                                      }
                                                    />
                                                    {obj.HallName}{" "}
                                                  </label>
                                                </td>
                                                <td className="text-center">
                                                  <div
                                                    className="d-flex"
                                                    style={{ marginLeft: 12 }}
                                                  >
                                                    <div className="form-check">
                                                      <input
                                                        className="form-check-input radio-all"
                                                        type="radio"
                                                        value={obj.All}
                                                        checked={obj.All}
                                                        disabled={
                                                          !obj.isHallChecked ||
                                                          isView
                                                        }
                                                        onChange={(e) =>
                                                          this.handleInputSectionPageList(
                                                            "varchar",
                                                            sectionPage,
                                                            "hallPreSetupDays",
                                                            e,
                                                            StaffSectionIndex,
                                                            "HallZonelist",
                                                            "radio",
                                                            "All",
                                                            hallIndex,
                                                            null
                                                          )
                                                        }
                                                      />
                                                      <label className="form-check-label">
                                                        All
                                                      </label>
                                                    </div>
                                                    <div className="form-check ml-2">
                                                      <input
                                                        className="form-check-input radio-specific"
                                                        type="radio"
                                                        value={obj.Specific}
                                                        checked={obj.Specific}
                                                        disabled={
                                                          !obj.isHallChecked ||
                                                          isView
                                                        }
                                                        onChange={(e) =>
                                                          this.handleInputSectionPageList(
                                                            "varchar",
                                                            sectionPage,
                                                            "hallPreSetupDays",
                                                            e,
                                                            StaffSectionIndex,
                                                            "HallZonelist",
                                                            "radio",
                                                            "Specific",
                                                            hallIndex,
                                                            null
                                                          )
                                                        }
                                                      />
                                                      <label className="form-check-label">
                                                        Specific
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <div
                                                    className="d-flex justify-content-start"
                                                    data-row={1}
                                                    style={{
                                                      rowGap: 0,
                                                      columnGap: 0,
                                                    }}
                                                  >
                                                    {obj.Specific &&
                                                      obj.isHallChecked &&
                                                      obj.zonelist.map(
                                                        (data, zoneIndex) => (
                                                          <div
                                                            className="zones"
                                                            style={{
                                                              width: "100%",
                                                            }}
                                                          >
                                                            <div className="row m-0">
                                                              <div className="col-md-3">
                                                                <div className="form-check">
                                                                  <input
                                                                    disabled={
                                                                      isView
                                                                    }
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    value={
                                                                      data.isZoneChecked
                                                                    }
                                                                    checked={
                                                                      data.isZoneChecked
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      this.handleInputSectionPageList(
                                                                        "varchar",
                                                                        sectionPage,
                                                                        "hallPreSetupDays",
                                                                        e,
                                                                        StaffSectionIndex,
                                                                        "HallZonelist",
                                                                        "zonelist",
                                                                        "Specific",
                                                                        hallIndex,
                                                                        zoneIndex
                                                                      )
                                                                    }
                                                                  />
                                                                  <label
                                                                    className="form-check-label"
                                                                    htmlFor="z1-1"
                                                                  >
                                                                    {data.Zone}
                                                                  </label>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        )
                                                      )}
                                                  </div>
                                                </td>
                                              </tr>
                                            )
                                          )}
                                      </tbody>
                                    </table>
                                  </div>
                                </>
                              )
                          )}

                        {staffSectionTableName == "hallEventDays" &&
                          data.hallEventDaysList.length > 0 &&
                          data.hallEventDaysList.map(
                            (item, index) =>
                              index == StaffSectionIndex && (
                                <>
                                  <div className="table-responsive mt-2">
                                    <h6 className="text-primary">
                                      {item.Name}
                                    </h6>
                                    <table
                                      className="table table-bordered mb-4"
                                      id="responsibilityTable"
                                    >
                                      <thead className="table-light text-uppercase" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
                                        <tr>
                                          <th style={{ width: 180 }}>Hall</th>
                                          <th className="text-center">Zone</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {item.HallZoneList.length > 0 &&
                                          item.HallZoneList.map(
                                            (obj, hallIndex) => (
                                              <tr>
                                                <td>
                                                  <label class="d-flex">
                                                    <input
                                                      disabled={isView}
                                                      type="checkbox"
                                                      class="h-auto mx-1"
                                                      value={obj.isHallChecked}
                                                      checked={
                                                        obj.isHallChecked
                                                      }
                                                      onChange={(e) =>
                                                        this.handleInputSectionPageList(
                                                          "varchar",
                                                          sectionPage,
                                                          "hallEventDays",
                                                          e,
                                                          StaffSectionIndex,
                                                          "HallZonelist",
                                                          "hall",
                                                          "",
                                                          hallIndex,
                                                          null
                                                        )
                                                      }
                                                    />
                                                    {obj.HallName}{" "}
                                                  </label>
                                                </td>
                                                <td className="text-center">
                                                  <div
                                                    className="d-flex"
                                                    style={{ marginLeft: 12 }}
                                                  >
                                                    <div className="form-check">
                                                      <input
                                                        className="form-check-input radio-all"
                                                        type="radio"
                                                        value={obj.All}
                                                        checked={obj.All}
                                                        disabled={
                                                          !obj.isHallChecked ||
                                                          isView
                                                        }
                                                        onChange={(e) =>
                                                          this.handleInputSectionPageList(
                                                            "varchar",
                                                            sectionPage,
                                                            "hallEventDays",
                                                            e,
                                                            StaffSectionIndex,
                                                            "HallZonelist",
                                                            "radio",
                                                            "All",
                                                            hallIndex,
                                                            null
                                                          )
                                                        }
                                                      />
                                                      <label className="form-check-label">
                                                        All
                                                      </label>
                                                    </div>
                                                    <div className="form-check ml-2">
                                                      <input
                                                        className="form-check-input radio-specific"
                                                        type="radio"
                                                        value={obj.Specific}
                                                        checked={obj.Specific}
                                                        disabled={
                                                          !obj.isHallChecked ||
                                                          isView
                                                        }
                                                        onChange={(e) =>
                                                          this.handleInputSectionPageList(
                                                            "varchar",
                                                            sectionPage,
                                                            "hallEventDays",
                                                            e,
                                                            StaffSectionIndex,
                                                            "HallZonelist",
                                                            "radio",
                                                            "Specific",
                                                            hallIndex,
                                                            null
                                                          )
                                                        }
                                                      />
                                                      <label className="form-check-label">
                                                        Specific
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <div
                                                    className="d-flex justify-content-start"
                                                    data-row={1}
                                                    style={{
                                                      rowGap: 0,
                                                      columnGap: 0,
                                                    }}
                                                  >
                                                    {obj.Specific &&
                                                      obj.isHallChecked &&
                                                      obj.zonelist.map(
                                                        (data, zoneIndex) => (
                                                          <div
                                                            className="zones"
                                                            style={{
                                                              width: "100%",
                                                            }}
                                                          >
                                                            <div className="row m-0">
                                                              <div className="col-md-3">
                                                                <div className="form-check">
                                                                  <input
                                                                    disabled={
                                                                      isView
                                                                    }
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    value={
                                                                      data.isZoneChecked
                                                                    }
                                                                    checked={
                                                                      data.isZoneChecked
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      this.handleInputSectionPageList(
                                                                        "varchar",
                                                                        sectionPage,
                                                                        "hallEventDays",
                                                                        e,
                                                                        StaffSectionIndex,
                                                                        "HallZonelist",
                                                                        "zonelist",
                                                                        "Specific",
                                                                        hallIndex,
                                                                        zoneIndex
                                                                      )
                                                                    }
                                                                  />
                                                                  <label
                                                                    className="form-check-label"
                                                                    htmlFor="z1-1"
                                                                  >
                                                                    {data.Zone}
                                                                  </label>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        )
                                                      )}
                                                  </div>
                                                </td>
                                              </tr>
                                            )
                                          )}
                                      </tbody>
                                    </table>
                                  </div>
                                </>
                              )
                          )}

                        {staffSectionTableName == "hallDismantlingDays" &&
                          data.hallDismantlingDaysList.length > 0 &&
                          data.hallDismantlingDaysList.map(
                            (item, index) =>
                              index == StaffSectionIndex && (
                                <>
                                  <div className="table-responsive mt-2">
                                    <h6 className="text-primary">
                                      {item.Name}
                                    </h6>
                                    <table
                                      className="table table-bordered mb-4"
                                      id="responsibilityTable"
                                    >
                                      <thead className="table-light text-uppercase" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
                                        <tr>
                                          <th style={{ width: 180 }}>Hall</th>
                                          <th className="text-center">Zone</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {item.HallZoneList.length > 0 &&
                                          item.HallZoneList.map(
                                            (obj, hallIndex) => (
                                              <tr>
                                                <td>
                                                  <label class="d-flex">
                                                    <input
                                                      disabled={isView}
                                                      type="checkbox"
                                                      class="h-auto mx-1"
                                                      value={obj.isHallChecked}
                                                      checked={
                                                        obj.isHallChecked
                                                      }
                                                      onChange={(e) =>
                                                        this.handleInputSectionPageList(
                                                          "varchar",
                                                          sectionPage,
                                                          "hallDismantlingDays",
                                                          e,
                                                          StaffSectionIndex,
                                                          "HallZonelist",
                                                          "hall",
                                                          "",
                                                          hallIndex,
                                                          null
                                                        )
                                                      }
                                                    />
                                                    {obj.HallName}{" "}
                                                  </label>
                                                </td>
                                                <td className="text-center">
                                                  <div
                                                    className="d-flex"
                                                    style={{ marginLeft: 12 }}
                                                  >
                                                    <div className="form-check">
                                                      <input
                                                        className="form-check-input radio-all"
                                                        type="radio"
                                                        value={obj.All}
                                                        checked={obj.All}
                                                        disabled={
                                                          !obj.isHallChecked ||
                                                          isView
                                                        }
                                                        onChange={(e) =>
                                                          this.handleInputSectionPageList(
                                                            "varchar",
                                                            sectionPage,
                                                            "hallDismantlingDays",
                                                            e,
                                                            StaffSectionIndex,
                                                            "HallZonelist",
                                                            "radio",
                                                            "All",
                                                            hallIndex,
                                                            null
                                                          )
                                                        }
                                                      />
                                                      <label className="form-check-label">
                                                        All
                                                      </label>
                                                    </div>
                                                    <div className="form-check ml-2">
                                                      <input
                                                        className="form-check-input radio-specific"
                                                        type="radio"
                                                        value={obj.Specific}
                                                        checked={obj.Specific}
                                                        disabled={
                                                          !obj.isHallChecked ||
                                                          isView
                                                        }
                                                        onChange={(e) =>
                                                          this.handleInputSectionPageList(
                                                            "varchar",
                                                            sectionPage,
                                                            "hallDismantlingDays",
                                                            e,
                                                            StaffSectionIndex,
                                                            "HallZonelist",
                                                            "radio",
                                                            "Specific",
                                                            hallIndex,
                                                            null
                                                          )
                                                        }
                                                      />
                                                      <label className="form-check-label">
                                                        Specific
                                                      </label>
                                                    </div>
                                                  </div>

                                                  <div
                                                    className="d-flex justify-content-start"
                                                    data-row={1}
                                                    style={{
                                                      rowGap: 0,
                                                      columnGap: 0,
                                                    }}
                                                  >
                                                    {obj.Specific &&
                                                      obj.isHallChecked &&
                                                      obj.zonelist.map(
                                                        (data, zoneIndex) => (
                                                          <div
                                                            className="zones"
                                                            style={{
                                                              width: "100%",
                                                            }}
                                                          >
                                                            <div className="row m-0">
                                                              <div className="col-md-3">
                                                                <div className="form-check">
                                                                  <input
                                                                    disabled={
                                                                      isView
                                                                    }
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    value={
                                                                      data.isZoneChecked
                                                                    }
                                                                    checked={
                                                                      data.isZoneChecked
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      this.handleInputSectionPageList(
                                                                        "varchar",
                                                                        sectionPage,
                                                                        "hallDismantlingDays",
                                                                        e,
                                                                        StaffSectionIndex,
                                                                        "HallZonelist",
                                                                        "zonelist",
                                                                        "Specific",
                                                                        hallIndex,
                                                                        zoneIndex
                                                                      )
                                                                    }
                                                                  />
                                                                  <label
                                                                    className="form-check-label"
                                                                    htmlFor="z1-1"
                                                                  >
                                                                    {data.Zone}
                                                                  </label>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        )
                                                      )}
                                                  </div>
                                                </td>
                                              </tr>
                                            )
                                          )}
                                      </tbody>
                                    </table>
                                  </div>
                                </>
                              )
                          )}
                      </div>
                    )}
                  </>
                ))}

              <div className="modal-footer py-1">
                {!isView ? (
                  <button
                    disabled={isView}
                    className="btn p-1 px-3 btn-aqua"
                    id="saveBtn"
                    onClick={() => this.StaffSectionHallPopSave()}
                  >
                    Save
                  </button>
                ) : (
                  <button
                    className="btn p-1 px-3 btn-gray"
                    data-bs-dismiss="modal"
                    onClick={() =>
                      this.setState({ StaffSectionHallPop: false })
                    }
                  >
                    Close
                  </button>
                )}
              </div>
            </div>
          </div>
        </Modal>

        <Modal isOpen={StaffSectionShiftPop}>
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header py-2 pt-3 bg-light">
                <h6 className="modal-title  text-primary fw-bolder">
                  Select Date and Shift
                </h6>
                <button
                  disabled={isView}
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  onClick={() => this.StaffSectionShiftPopClosed()}
                />
              </div>
              {SectionPageList.length > 0 &&
                SectionPageList.map((data, i) => (
                  <>
                    {data.SectionPageName == sectionPage && (
                      <div
                        className="modal-body pb-2"
                        style={{
                          overflow: "auto",
                        }}
                      >
                        {staffSectionTableName == "hallPreSetupDays" &&
                          data.hallPreSetupDaysList.length > 0 &&
                          data.hallPreSetupDaysList.map(
                            (item, index) =>
                              index == StaffSectionIndex && (
                                <>
                                  <div className="table-responsive mt-2">
                                    <h6 className="text-primary">
                                      {item.Name}
                                    </h6>
                                    <table
                                      className="table table-bordered mb-4"
                                      id="responsibilityTable"
                                    >
                                      <thead className="table-light text-uppercase" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
                                        <tr>
                                          <th style={{ width: 180 }}>Date</th>
                                          <th className="text-center">Shift</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {item.ShiftList.length > 0 &&
                                          item.ShiftList.map(
                                            (data, shiftIndex) => (
                                              <tr>
                                                <td>
                                                  <label class="d-flex">
                                                    <input
                                                      disabled={isView}
                                                      type="checkbox"
                                                      class="h-auto mx-1"
                                                      value={data.isDateCheck}
                                                      checked={data.isDateCheck}
                                                      onChange={(e) =>
                                                        this.handleInputSectionPageList(
                                                          "varchar",
                                                          sectionPage,
                                                          "hallPreSetupDays",
                                                          e,
                                                          StaffSectionIndex,
                                                          "Shift",
                                                          "isDate",
                                                          "",
                                                          shiftIndex,
                                                          null
                                                        )
                                                      }
                                                    />
                                                    {data.date}{" "}
                                                  </label>
                                                </td>
                                                <td class="text-left">
                                                  <div
                                                    class="action-group justify-content-start"
                                                    data-row="1"
                                                    style={{ rowGap: 0 }}
                                                  >
                                                    {data.shift.length > 0 &&
                                                      data.shift.map(
                                                        (obj, i) => (
                                                          <div class="form-check">
                                                            {console.log("obj=========================================================>", obj)}
                                                            <label class="d-flex">
                                                              <input
                                                                type="checkbox"
                                                                class="h-auto mx-1"
                                                                value={
                                                                  obj.isShiftCheck
                                                                }
                                                                checked={
                                                                  obj.isShiftCheck
                                                                }
                                                                disabled={
                                                                  !data.isDateCheck ||
                                                                  isView
                                                                }
                                                                onChange={(e) =>
                                                                  this.handleInputSectionPageList(
                                                                    "varchar",
                                                                    sectionPage,
                                                                    "hallPreSetupDays",
                                                                    e,
                                                                    StaffSectionIndex,
                                                                    "Shift",
                                                                    "isShift",
                                                                    "",
                                                                    shiftIndex,
                                                                    i
                                                                  )
                                                                }
                                                              />
                                                              {obj.time}{" "}
                                                            </label>
                                                          </div>
                                                        )
                                                      )}
                                                  </div>
                                                </td>
                                              </tr>
                                            )
                                          )}
                                      </tbody>
                                    </table>
                                  </div>
                                </>
                              )
                          )}

                        {staffSectionTableName == "hallEventDays" &&
                          data.hallEventDaysList.length > 0 &&
                          data.hallEventDaysList.map(
                            (item, index) =>
                              index == StaffSectionIndex && (
                                <>
                                  <div className="table-responsive mt-2">
                                    <h6 className="text-primary">
                                      {item.Name}
                                    </h6>
                                    <table
                                      className="table table-bordered mb-4"
                                      id="responsibilityTable"
                                    >
                                      <thead className="table-light text-uppercase" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
                                        <tr>
                                          <th>Date</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {item.ShiftList.length > 0 &&
                                          item.ShiftList.map(
                                            (data, shiftIndex) => (
                                              <tr>
                                                <td>
                                                  <label class="d-flex">
                                                    <input
                                                      disabled={isView}
                                                      type="checkbox"
                                                      class="h-auto mx-1"
                                                      value={data.isDateCheck}
                                                      checked={data.isDateCheck}
                                                      onChange={(e) =>
                                                        this.handleInputSectionPageList(
                                                          "varchar",
                                                          sectionPage,
                                                          "hallEventDays",
                                                          e,
                                                          StaffSectionIndex,
                                                          "Shift",
                                                          "isDate",
                                                          "",
                                                          shiftIndex,
                                                          null
                                                        )
                                                      }
                                                    />
                                                    {data.DateValue}{" "}
                                                  </label>
                                                </td>
                                              </tr>
                                            )
                                          )}
                                      </tbody>
                                    </table>
                                  </div>
                                </>
                              )
                          )}

                        {staffSectionTableName == "hallDismantlingDays" &&
                          data.hallDismantlingDaysList.length > 0 &&
                          data.hallDismantlingDaysList.map(
                            (item, index) =>
                              index == StaffSectionIndex && (
                                <>
                                  <div className="table-responsive mt-2">
                                    <h6 className="text-primary">
                                      {item.Name}
                                    </h6>
                                    <table
                                      className="table table-bordered mb-4"
                                      id="responsibilityTable"
                                    >
                                      <thead className="table-light text-uppercase" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
                                        <tr>
                                          <th style={{ width: 180 }}>Date</th>
                                          <th>Shift</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {item.ShiftList.length > 0 &&
                                          item.ShiftList.map(
                                            (data, shiftIndex) => (
                                              <tr>
                                                <td>
                                                  <label class="d-flex">
                                                    <input
                                                      disabled={isView}
                                                      type="checkbox"
                                                      class="h-auto mx-1"
                                                      value={data.isDateCheck}
                                                      checked={data.isDateCheck}
                                                      onChange={(e) =>
                                                        this.handleInputSectionPageList(
                                                          "varchar",
                                                          sectionPage,
                                                          "hallDismantlingDays",
                                                          e,
                                                          StaffSectionIndex,
                                                          "Shift",
                                                          "isDate",
                                                          "",
                                                          shiftIndex,
                                                          null
                                                        )
                                                      }
                                                    />
                                                    {data.date}{" "}
                                                  </label>
                                                </td>
                                                <td class="text-left">
                                                  <div
                                                    class="action-group justify-content-start"
                                                    data-row="1"
                                                    style={{ rowGap: 0 }}
                                                  >
                                                    {data.shift.length > 0 &&
                                                      data.shift.map(
                                                        (obj, i) => (
                                                          <div class="form-check">
                                                            <label class="d-flex">
                                                              <input
                                                                type="checkbox"
                                                                class="h-auto mx-1"
                                                                value={
                                                                  obj.isShiftCheck
                                                                }
                                                                checked={
                                                                  obj.isShiftCheck
                                                                }
                                                                disabled={
                                                                  !data.isDateCheck ||
                                                                  isView
                                                                }
                                                                onChange={(e) =>
                                                                  this.handleInputSectionPageList(
                                                                    "varchar",
                                                                    sectionPage,
                                                                    "hallDismantlingDays",
                                                                    e,
                                                                    StaffSectionIndex,
                                                                    "Shift",
                                                                    "isShift",
                                                                    "",
                                                                    shiftIndex,
                                                                    i
                                                                  )
                                                                }
                                                              />
                                                              {obj.time}{" "}
                                                            </label>
                                                          </div>
                                                        )
                                                      )}
                                                  </div>
                                                </td>
                                              </tr>
                                            )
                                          )}
                                      </tbody>
                                    </table>
                                  </div>
                                </>
                              )
                          )}
                      </div>
                    )}
                  </>
                ))}
              <div className="modal-footer py-1">
                {!isView ? (
                  <button
                    disabled={isView}
                    className="btn p-1 px-3 btn-aqua"
                    id="saveBtn"
                    onClick={() => this.StaffSectionShiftPopSave()}
                  >
                    Save
                  </button>
                ) : (
                  <button
                    className="btn p-1 px-3 btn-gray"
                    onClick={() =>
                      this.setState({ StaffSectionShiftPop: false })
                    }
                  >
                    Close
                  </button>
                )}
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={isHallPop}
          onRequestClose={() => this.setState({ isHallPop: false })}
        >
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '350px' }}>
            <div className="modal-content" style={{ borderRadius: '8px', border: 'none', overflow: 'hidden' }}>
              <div style={{ backgroundColor: '#3cbba7', padding: '16px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h6 style={{ color: 'white', margin: 0, fontWeight: '600', fontSize: '15px' }}>Confirm Clear</h6>
                <button onClick={() => this.setState({ isHallPop: false })} style={{ background: 'none', border: 'none', color: 'white', fontSize: '24px', lineHeight: '1', padding: 0, cursor: 'pointer' }}>&times;</button>
              </div>

              <div style={{ padding: '30px 24px' }}>
                <div style={{ display: 'flex', gap: '16px', alignItems: 'center', marginBottom: '24px' }}>
                  <div style={{ width: '40px', height: '40px', minWidth: '40px', backgroundColor: '#fee2e2', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <i className="fa fa-exclamation-triangle" style={{ color: '#dc2626', fontSize: '18px' }}></i>
                  </div>
                  <h5 style={{ color: '#4b5563', fontWeight: '500', fontSize: '14px', margin: 0, lineHeight: '1.5', textAlign: 'left' }}>
                    The below all record has been cleared. Are you sure?
                  </h5>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  <button onClick={(e) => this.isHallManagerPopClosed(e)} className="btn" style={{ backgroundColor: '#00695c', color: 'white', fontWeight: '600', padding: '10px', borderRadius: '4px', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    Yes
                  </button>
                  <button onClick={() => this.setState({ isHallPop: false })} className="btn" style={{ backgroundColor: 'white', color: '#1f2937', border: '1px solid #d1d5db', fontWeight: '600', padding: '10px', borderRadius: '4px', width: '100%' }}>
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.showRevokePlanModal}
          onRequestClose={() => this.setState({ showRevokePlanModal: false })}
        >
          <div className="modal-dialog">
            <div className="modal-content confirm-logout">
              <div class="modal-header p-2">
                <h5 class="modal-title">
                  Confirm Plan Revocation
                </h5>
                <button
                  type="button "
                  class="close pop-close"
                  data-dismiss="modal"
                  style={{ background: "#eeeeee" }}
                  onClick={() => this.setState({ showRevokePlanModal: false })}
                >
                  <span aria-hidden="true" class="pop-cancel">
                    &times;
                  </span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <p class="pop_label">
                      Your previous plan will be revoked. Do you want to continue?
                    </p>
                  </div>
                </div>
              </div>
              <div class="modal-footer p-1">
                <div class="form-group text-right mod-fot">
                  <button
                    type="button"
                    class="btn btn-del-pop"
                    onClick={this.handleRevokePlan}
                  >
                    Continue
                  </button>
                  <button
                    type="button"
                    class="btn btn-gray"
                    data-dismiss="modal"
                    style={{ marginLeft: "5px" }}
                    onClick={() => this.setState({ showRevokePlanModal: false })}
                  >
                    Back
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={showChangePasswordModal}
          onRequestClose={this.closeChangePasswordModal}
        >
          {/* <div className="modal-dialog">
            <div className="modal-content confirm-logout">
              <div class="modal-header p-2">
                <h5 class="modal-title modal_title_text">Change Password</h5>
                <button
                  type="button"
                  class="close pop-close"
                  style={{ background: "#eeeeee" }}
                  onClick={this.closeChangePasswordModal}
                >
                  <span aria-hidden="true" class="pop-cancel">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <div className="mb-3" style={{ position: 'relative' }}>
                      <label className="form-label">Current Password</label>
                      <input 
                        type={this.state.is_showOldpass ? "text" : "password"} 
                        className="form-control" 
                        placeholder="Enter Your Old Password"
                        value={this.state.old_pass}
                        onChange={e => this.setState({ old_pass: e.target.value, old_passErr: "" })}
                      />
                      {<span className='text-danger text-start text-left d-block mt-1'>{this.state.old_passErr}</span>}
                      <i
                        className="fa fa-eye"
                        onClick={e => this.handleObscurePassword('old_pass')}
                        style={{
                          top: '32px',
                          right: '10px',
                          position: "absolute",
                          color: 'gray',
                          cursor: 'pointer'
                        }}
                      />
                    </div>
                    <div className="mb-3" style={{ position: 'relative' }}>
                      <label className="form-label">New Password</label>
                      <input 
                        type={this.state.is_showNewpass ? "text" : "password"} 
                        className="form-control" 
                        placeholder="Enter New Password"
                        maxLength={'20'}
                        value={this.state.new_pass}
                        onChange={e => this.setState({ new_pass: e.target.value, new_passErr: "" })}
                      />
                      {<span className='text-danger text-start text-left d-block mt-1'>{this.state.new_passErr}</span>}
                      <i
                        className="fa fa-eye"
                        onClick={e => this.handleObscurePassword('new_pass')}
                        style={{
                          top: '32px',
                          right: '10px',
                          position: "absolute",
                          color: 'gray',
                          cursor: 'pointer'
                        }}
                      />
                    </div>
                    <div className="mb-3" style={{ position: 'relative' }}>
                      <label className="form-label">Confirm Password</label>
                      <input 
                        type={this.state.is_showConfirmpass ? "text" : "password"} 
                        className="form-control" 
                        placeholder="Enter New Password again"
                        maxLength={'20'}
                        value={this.state.confirm_pass}
                        onChange={e => this.setState({ confirm_pass: e.target.value, confirm_passErr: "" })}
                      />
                      {<span className='text-danger text-start text-left d-block mt-1'>{this.state.confirm_passErr}</span>}
                      <i
                        className="fa fa-eye"
                        onClick={e => this.handleObscurePassword('confirm_pass')}
                        style={{
                          top: '32px',
                          right: '10px',
                          position: "absolute",
                          color: 'gray',
                          cursor: 'pointer'
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer p-1">
                <div class="form-group text-right mod-fot">
                  <button 
                    type="button" 
                    class="btn btn-del-pop"
                    onClick={this.updatePasswordModal}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    class="btn btn-gray"
                    style={{ marginLeft: "5px" }}
                    onClick={this.closeChangePasswordModal}
                  >
                    Back
                  </button>
                </div>
              </div>
            </div>
          </div> */}

          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "420px" }}>
            <div className="modal-content shadow-lg border-0">

              {/* Header */}
              <div className="modal-header py-2" style={{ background: "#f8f9fa" }}>
                <h5 className="modal-title fw-bold">Change Password</h5>
                <button
                  type="button"
                  className="close pop-close"
                  onClick={this.closeChangePasswordModal}
                  style={{ background: "#eee", borderRadius: "4px" }}
                >
                  <span aria-hidden="true" className="pop-cancel">&times;</span>
                </button>
              </div>

              {/* Body */}
              <div className="modal-body pb-1 pt-0">
                <div className="row">
                  <div className="col-md-12">

                    {/* Current Password */}
                    <div className="mb-3 position-relative">
                      <label className="form-label">Current Password</label>
                      <input
                        type={this.state.is_showOldpass ? "text" : "password"}
                        className="form-control"
                        placeholder="Enter Your Current Password"
                        value={this.state.old_pass}
                        onChange={(e) =>
                          this.setState({ old_pass: e.target.value, old_passErr: "" })
                        }
                      />
                      <i
                        className="fa fa-eye grid-icon"
                        onClick={() => this.handleObscurePassword("old_pass")}
                        style={{
                          position: "absolute",
                          top: "38px",
                          right: "12px",
                          cursor: "pointer",
                          color: "#6c757d",
                        }}
                      />
                      <span className="text-danger small">{this.state.old_passErr}</span>
                    </div>

                    {/* New Password */}
                    <div className="mb-3 position-relative">
                      <label className="form-label">New Password</label>
                      <input
                        type={this.state.is_showNewpass ? "text" : "password"}
                        className="form-control"
                        placeholder="Enter New Password"
                        maxLength="20"
                        value={this.state.new_pass}
                        onChange={(e) =>
                          this.setState({ new_pass: e.target.value, new_passErr: "" })
                        }
                      />
                      <i
                        className="fa fa-eye grid-icon"
                        onClick={() => this.handleObscurePassword("new_pass")}
                        style={{
                          position: "absolute",
                          top: "38px",
                          right: "12px",
                          cursor: "pointer",
                          color: "#6c757d",
                        }}
                      />
                      <span className="text-danger small">{this.state.new_passErr}</span>
                    </div>

                    {/* Confirm Password */}
                    <div className="mb-1 position-relative">
                      <label className="form-label">Confirm Password</label>
                      <input
                        type={this.state.is_showConfirmpass ? "text" : "password"}
                        className="form-control"
                        placeholder="Re-enter New Password"
                        maxLength="20"
                        value={this.state.confirm_pass}
                        onChange={(e) =>
                          this.setState({ confirm_pass: e.target.value, confirm_passErr: "" })
                        }
                      />
                      <i
                        className="fa fa-eye grid-icon"
                        onClick={() => this.handleObscurePassword("confirm_pass")}
                        style={{
                          position: "absolute",
                          top: "38px",
                          right: "12px",
                          cursor: "pointer",
                          color: "#6c757d",
                        }}
                      />
                      <span className="text-danger small">{this.state.confirm_passErr}</span>
                    </div>

                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className="modal-footer py-2 d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-aqua px-4"
                  onClick={this.updatePasswordModal}
                >
                  Save
                </button>

                <button
                  type="button"
                  className="btn btn-gray px-4 ms-2"
                  onClick={this.closeChangePasswordModal}
                >
                  Back
                </button>
              </div>
            </div>
          </div>

        </Modal>

        <Modal
          isOpen={isCommentPop}
          onRequestClose={() => this.setState({ isCommentPop: false })}
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div class="modal-header py-3 text-white">
                <h6 className="mb-0">Instructions / Documents</h6>
                <button onClick={() => this.setState({ isCommentPop: false })} style={{ background: 'none', border: 'none', color: 'white', fontSize: '24px', lineHeight: '1', padding: 0, cursor: 'pointer' }}>&times;</button>

              </div>

              <div className="modal-body" style={{ background: "#f9fafb" }}>
                {/* Chat Section */}
                {commentList.length > 0 ? (
                  commentList.map((item, index) => (
                    <div
                      key={index}
                      className="chat-box"
                      style={{
                        maxHeight: 400,
                        overflowY: "auto",
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                      }}
                    >
                      {item.CreatedBy !=
                        JSON.parse(sessionStorage.getItem("loginDataSS")).UserID ? (
                        // Incoming message
                        <div
                          className="message incoming"
                          style={{ alignSelf: "flex-start", maxWidth: "80%" }}
                        >
                          <div
                            className="meta"
                            style={{
                              fontSize: 12,
                              color: "#6b7280",
                              marginBottom: 4,
                            }}
                          >
                            {item.PersonName}  {item.Designation ? `(${item.Designation})` : ""} •{" "}
                            {moment.utc(item.CreatedDate).format("DD/MM/YYYY, hh:mm A")}
                          </div>

                          <div
                            className="bubble"
                            style={{
                              // background:
                              //   index === commentList.length - 1 ? "#777777" : undefined,
                              // color:
                              //   index === commentList.length - 1 ? "#ffff" : undefined,
                              borderRadius: "12px 12px 4px 12px",
                              padding: "8px 16px",
                              fontSize: 14,
                              border: "1px solid #e5e7eb",
                            }}
                          >
                            {item.Instruction ?
                              <span>
                                {item.Instruction}
                              </span> :
                              <a
                                className="text-aqua overflow-membership"
                                style={{ cursor: "pointer" }}
                                target="__blank"
                                href={
                                  BASE_URL.split("/api")[0] +
                                  item.DocumentPath
                                }
                              >
                                {item.DocumentPath.split('/').pop()}
                              </a>
                            }
                          </div>
                        </div>
                      ) : (
                        // Outgoing message
                        <div
                          className="message outgoing"
                          style={{
                            alignSelf: "flex-end",
                            maxWidth: "80%",
                            textAlign: "right",
                          }}
                        >
                          <div
                            className="meta"
                            style={{
                              fontSize: 12,
                              color: "#6b7280",
                              marginBottom: 4,
                            }}
                          >
                            You • {moment.utc(item.CreatedDate).format("DD/MM/YYYY, hh:mm A")}
                          </div>

                          <div
                            className="bubble"
                            style={{
                              borderRadius: "12px 12px 4px 12px",
                              padding: "8px 16px",
                              fontSize: 14,
                              border: "1px solid #e5e7eb",
                            }}
                          >
                            {item.Instruction ?
                              <span>
                                {item.Instruction}
                              </span> :
                              <a
                                className="text-aqua overflow-membership"
                                style={{ cursor: "pointer" }}
                                target="__blank"
                                href={
                                  BASE_URL.split("/api")[0] +
                                  item.DocumentPath
                                }
                              >
                                {item.DocumentPath.split('/').pop()}
                              </a>
                            }
                          </div>
                        </div>
                      )}
                    </div>
                  ))
                ) : (
                  <div className="text-left">Record not found</div>
                )}
              </div>

              <div class="modal-footer p-1">
                <div class="form-group text-right mod-fot">
                  <button
                    type="button"
                    class="btn btn-gray"
                    data-dismiss="modal"
                    style={{ marginLeft: "5px" }}
                    onClick={() => this.setState({ isCommentPop: false, ListIndex: null })}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={isConfirmPop}
          onRequestClose={() => this.setState({ isConfirmPop: false })}
        >
          <div className="modal-dialog modal-l">
            <div className="modal-content">
              <div class="modal-header py-3 text-white">
                <h6 className="mb-0">Do you really want to {isCreateZoneManagerTeamMember ? 'create' : 'delete'} zone manager team member?</h6>
                <button onClick={() => this.setState({ isConfirmPop: false })} style={{ background: 'none', border: 'none', color: 'white', fontSize: '24px', lineHeight: '1', padding: 0, cursor: 'pointer' }}>&times;</button>
              </div>

              <div class="modal-footer p-1">
                <div class="form-group text-right mod-fot">
                  <button
                    type="button"
                    class="btn btn-aqua"
                    data-dismiss="modal"
                    style={{ marginLeft: "5px" }}
                    onClick={() => isCreateZoneManagerTeamMember ? this.createZoneManagerTeamMember() : this.deleteZoneManagerTeamMember()}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    class="btn btn-gray"
                    data-dismiss="modal"
                    style={{ marginLeft: "5px" }}
                    onClick={() => this.setState({ isConfirmPop: false, ListIndex: null })}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
    insertUpdateVendorWorkOrder_action,
    getVendorWorkOrderDetails_action,
    createhallManagerAccess_action,
    getDetailsVendorRegistration_action,
    revokeVendorPlan_action,
    updatePassword_action,
    SOWTagRead_action,
    getDeliverablesDocumentLog_action,
    createZoneManagerTeamMember_action,
    deleteZoneManagerTeamMember_action
  })(VendorWorkOrderAU)
);

